"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: production-v1.45.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManifestStatusEnum = exports.LogoutReasonEnum = exports.LocationStationTypeEnum = exports.LoadPointDetailsDefaultContainerTypeEnum = exports.LoadPointByQueryContainerTypeEnum = exports.LoadPointDefaultContainerTypeEnum = exports.IntegrationLabelFormatEnum = exports.InboundManifestResponseStatusEnum = exports.InboundManifestIssueItemEnum = exports.InboundManifestIssueLevelEnum = exports.InboundManifestStatusEnum = exports.InboundLoadLoadStatusEnum = exports.HoldReasonScopeEnum = exports.HoldReasonSourceEnum = exports.HoldReasonDeviceTypeEnum = exports.GenericErrorErrorCodeEnum = exports.EventEventSourceEnum = exports.EventEventTypeEnum = exports.EnrollmentTokenSerializarFormatEnum = exports.DeviceDetailsStationTypeEnum = exports.DeviceDetailsAreaTypeEnum = exports.DeviceDetailsVersionStatusEnum = exports.DeviceStationTypeEnum = exports.DeviceVersionStatusEnum = exports.CustomerPermissionPermissionsEnum = exports.CustomerPermissionRoleTypeEnum = exports.CorporateRolesDependenciesGroupEnum = exports.CorporateRolesDependenciesChildrenEnum = exports.CorporateRolesDependenciesParentsEnum = exports.CorporateRolesDependenciesPermissionEnum = exports.ContainerOpsBehaviorConfigRequireLabeledMoveEnum = exports.ContainerDetailsStateEnum = exports.ContainerDetailsLastProcessStepEnum = exports.ContainerDetailsProcessStepEnum = exports.ContainerDetailsContainerStatusEnum = exports.ContainerDetailsContainerTypeEnum = exports.ContainerByQueryContainerStatusEnum = exports.ContainerByQueryContainerTypeEnum = exports.ContainerCreationMethodEnum = exports.ContainerStateEnum = exports.ContainerLastProcessStepEnum = exports.ContainerProcessStepEnum = exports.ContainerContainerStatusEnum = exports.ContainerContainerTypeEnum = exports.ChaosFlagKindEnum = exports.BulkImportIssueLevelEnum = exports.AreaDetailsAreaTypeEnum = exports.AreaByQueryAreaTypeEnum = exports.AreaAreaTypeEnum = exports.APIExceptionErrorCodeEnum = void 0;
exports.WebHookSubscriptionFilterFilterTypeEnum = exports.WebHookSubscriptionFormatEnum = exports.WebHookSubscriptionMethodEnum = exports.WebHookGenerateApiTokenIntegrationRefEnum = exports.ValidationErrorErrorCodeEnum = exports.UserUserTypeEnum = exports.TrackingEventEventSourceEnum = exports.TrackingEventEventTypeEnum = exports.TrackingStatusEnum = exports.TaskFailureReasonEnum = exports.TaskStatusEnum = exports.StationPackageCountForEventTypeEventTypesEnum = exports.StationPackageCountCutOffEventTypesEnum = exports.StationDetailsStationTypeEnum = exports.StationStationTypeEnum = exports.StaffPermissionPermissionsEnum = exports.StaffPermissionRoleTypeEnum = exports.ShiftPlanPresetRecurrenceEnum = exports.ShiftPlanPresetShiftPlanTypeEnum = exports.ShiftPlanShiftPlanTypeEnum = exports.ReportDatasetProcessStepMetricEnum = exports.ReportDatasetProcessStepResourceEnum = exports.ReportDatasetProcessStepProcessStepsEnum = exports.ReportDatasetPerformanceTimeEnum = exports.ReportDatasetPerformanceMetricEnum = exports.ReportDatasetExpectedInfluxInfluxTypeEnum = exports.ReportDatasetEventIntervalsTargetEventEnum = exports.ReportDatasetEventIntervalsOriginEventEnum = exports.RelabelOptionsConfigProvidersEnum = exports.PublicContainerSerializerContainerTypeEnum = exports.ProcessStepDatasetRowColumnsEnum = exports.PermissionsPermissionsEnum = exports.PermissionsRoleTypeEnum = exports.PatchRolePermissionsEnum = exports.PatchRoleRoleTypeEnum = exports.PackageDetailsLastProcessStepEnum = exports.PackageDetailsProcessStepEnum = exports.PackageLastProcessStepEnum = exports.PackageProcessStepEnum = exports.OutboundLoadReportStatusEnum = exports.OutboundLoadLoadStatusEnum = exports.OutboundIntegrationUSPSProtocolEnum = exports.NestedProcessStepSerializerPackageProcessStepEnum = exports.NestedProcessStepSerializerContainerProcessStepEnum = exports.NestedOutboundLoadLoadStatusEnum = exports.NestedInboundManifestContainerContainerTypeEnum = exports.NestedEventEventTypeEnum = exports.NestedCreatePackageHoldReasonScopeEnum = exports.NestedContainerContainerStatusEnum = exports.ManifestSerializerDetailsStatusEnum = void 0;
exports.CustomersApi = exports.CustomersApiFactory = exports.CustomersApiFp = exports.CustomersApiAxiosParamCreator = exports.CustomerConfigsApi = exports.CustomerConfigsApiFactory = exports.CustomerConfigsApiFp = exports.CustomerConfigsApiAxiosParamCreator = exports.CountriesApi = exports.CountriesApiFactory = exports.CountriesApiFp = exports.CountriesApiAxiosParamCreator = exports.CorporateModulesListSortByEnum = exports.CorporateModulesListAreaTypeEnum = exports.CorporateApi = exports.CorporateApiFactory = exports.CorporateApiFp = exports.CorporateApiAxiosParamCreator = exports.ContainersListDefectsEnum = exports.ContainersListContainerStatusEnum = exports.ContainersListExcludeProcessStepEnum = exports.ContainersListProcessStepEnum = exports.ContainersListSortByEnum = exports.ContainersListContainerTypeEnum = exports.ContainersCsvDefectsEnum = exports.ContainersCsvContainerStatusEnum = exports.ContainersCsvExcludeProcessStepEnum = exports.ContainersCsvProcessStepEnum = exports.ContainersCsvSortByEnum = exports.ContainersCsvContainerTypeEnum = exports.ContainersApi = exports.ContainersApiFactory = exports.ContainersApiFp = exports.ContainersApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.AreasListSortByEnum = exports.AreasListAreaTypeEnum = exports.AreasApi = exports.AreasApiFactory = exports.AreasApiFp = exports.AreasApiAxiosParamCreator = exports.WebHookSubscriptionHistoryTrackingUpdateEventTypeEnum = exports.WebHookSubscriptionHistoryResourceTypeEnum = exports.WebHookSubscriptionHistoryTypeEnum = exports.WebHookSubscriptionHistoryStatusEnum = exports.WebHookSubscriptionFilterEventTypesEnum = exports.WebHookSubscriptionFilterResourceTypeEnum = void 0;
exports.LocationsCsvLocationTypeEnum = exports.LocationsApi = exports.LocationsApiFactory = exports.LocationsApiFp = exports.LocationsApiAxiosParamCreator = exports.LoadpointsListSortByEnum = exports.LoadpointsListAreaTypeEnum = exports.LoadpointsLabelDataFormatEnum = exports.LoadpointsApi = exports.LoadpointsApiFactory = exports.LoadpointsApiFp = exports.LoadpointsApiAxiosParamCreator = exports.LoadplansApi = exports.LoadplansApiFactory = exports.LoadplansApiFp = exports.LoadplansApiAxiosParamCreator = exports.InboundloadsListSortByEnum = exports.InboundloadsListInboundLoadStatusEnum = exports.InboundloadsApi = exports.InboundloadsApiFactory = exports.InboundloadsApiFp = exports.InboundloadsApiAxiosParamCreator = exports.FmcsApi = exports.FmcsApiFactory = exports.FmcsApiFp = exports.FmcsApiAxiosParamCreator = exports.EventsListEventTypeEnum = exports.EventsListSortByEnum = exports.EventsListResourceTypeEnum = exports.EventsApi = exports.EventsApiFactory = exports.EventsApiFp = exports.EventsApiAxiosParamCreator = exports.DockdoorsLabelDataFormatEnum = exports.DockdoorsApi = exports.DockdoorsApiFactory = exports.DockdoorsApiFp = exports.DockdoorsApiAxiosParamCreator = exports.DevicesListSortByEnum = exports.DevicesListVersionStatusEnum = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.DataAnalyticsPackageCountsListCutOffEventTypesEnum = exports.DataAnalyticsPackageCountsForEventTypesListEventTypesEnum = exports.DataAnalyticsApi = exports.DataAnalyticsApiFactory = exports.DataAnalyticsApiFp = exports.DataAnalyticsApiAxiosParamCreator = void 0;
exports.PackagesHoldReasonsStatsSortByEnum = exports.PackagesHoldReasonsStatsScopeEnum = exports.PackagesHoldReasonsStatsSourceEnum = exports.PackagesHoldReasonsListStatusEnum = exports.PackagesHoldReasonsListSortByEnum = exports.PackagesHoldReasonsListScopeEnum = exports.PackagesHoldReasonsListSourceEnum = exports.PackagesHoldReasonsCsvStatusEnum = exports.PackagesHoldReasonsCsvSortByEnum = exports.PackagesHoldReasonsCsvScopeEnum = exports.PackagesHoldReasonsCsvSourceEnum = exports.PackagesCsvExcludeProcessStepEnum = exports.PackagesCsvProcessStepEnum = exports.PackagesCsvDefectsEnum = exports.PackagesCsvSortByEnum = exports.PackagesAggregatedataExcludeProcessStepEnum = exports.PackagesAggregatedataProcessStepEnum = exports.PackagesAggregatedataDefectsEnum = exports.PackagesAggregatedataSortByEnum = exports.PackagesApi = exports.PackagesApiFactory = exports.PackagesApiFp = exports.PackagesApiAxiosParamCreator = exports.OutboundloadsListDefectsEnum = exports.OutboundloadsListSortByEnum = exports.OutboundloadsListOutboundLoadStatusEnum = exports.OutboundloadsApi = exports.OutboundloadsApiFactory = exports.OutboundloadsApiFp = exports.OutboundloadsApiAxiosParamCreator = exports.OrganizationsApi = exports.OrganizationsApiFactory = exports.OrganizationsApiFp = exports.OrganizationsApiAxiosParamCreator = exports.ModulesListSortByEnum = exports.ModulesListAreaTypeEnum = exports.ModulesApi = exports.ModulesApiFactory = exports.ModulesApiFp = exports.ModulesApiAxiosParamCreator = exports.ManifestsListManifestTypeEnum = exports.ManifestsListSortByEnum = exports.ManifestsCsvManifestTypeEnum = exports.ManifestsApi = exports.ManifestsApiFactory = exports.ManifestsApiFp = exports.ManifestsApiAxiosParamCreator = exports.LocationsListSortByEnum = exports.LocationsListLocationTypeEnum = exports.LocationsCsvSortByEnum = void 0;
exports.ShippersApiFp = exports.ShippersApiAxiosParamCreator = exports.ShiftPlansTimelineShiftPlanTypeEnum = exports.ShiftPlansListShiftPlanTypeEnum = exports.ShiftPlansApi = exports.ShiftPlansApiFactory = exports.ShiftPlansApiFp = exports.ShiftPlansApiAxiosParamCreator = exports.ShiftPlanPresetsApi = exports.ShiftPlanPresetsApiFactory = exports.ShiftPlanPresetsApiFp = exports.ShiftPlanPresetsApiAxiosParamCreator = exports.SchemesListSortByEnum = exports.SchemesApi = exports.SchemesApiFactory = exports.SchemesApiFp = exports.SchemesApiAxiosParamCreator = exports.RoutesApi = exports.RoutesApiFactory = exports.RoutesApiFp = exports.RoutesApiAxiosParamCreator = exports.Route2stationsApi = exports.Route2stationsApiFactory = exports.Route2stationsApiFp = exports.Route2stationsApiAxiosParamCreator = exports.ReportsDatasetsProcessstepsListProcessStepsEnum = exports.ReportsDatasetsProcessstepsListMetricEnum = exports.ReportsDatasetsProcessstepsListResourceEnum = exports.ReportsDatasetsPerformanceListTimeEnum = exports.ReportsDatasetsPerformanceListMetricEnum = exports.ReportsDatasetsExpectedinfluxListInfluxTypeEnum = exports.ReportsDatasetsEventintervalsListTargetEventEnum = exports.ReportsDatasetsEventintervalsListOriginEventEnum = exports.ReportsApi = exports.ReportsApiFactory = exports.ReportsApiFp = exports.ReportsApiAxiosParamCreator = exports.PublicApi = exports.PublicApiFactory = exports.PublicApiFp = exports.PublicApiAxiosParamCreator = exports.ProbesApi = exports.ProbesApiFactory = exports.ProbesApiFp = exports.ProbesApiAxiosParamCreator = exports.PackagesListExcludeProcessStepEnum = exports.PackagesListProcessStepEnum = exports.PackagesListDefectsEnum = exports.PackagesListSortByEnum = exports.PackagesHoldReasonsStatsStatusEnum = void 0;
exports.ZonesApiFp = exports.ZonesApiAxiosParamCreator = exports.WebhooksInboundApi = exports.WebhooksInboundApiFactory = exports.WebhooksInboundApiFp = exports.WebhooksInboundApiAxiosParamCreator = exports.WebhooksApi = exports.WebhooksApiFactory = exports.WebhooksApiFp = exports.WebhooksApiAxiosParamCreator = exports.WeatherListUnitsEnum = exports.WeatherApi = exports.WeatherApiFactory = exports.WeatherApiFp = exports.WeatherApiAxiosParamCreator = exports.TrackingApi = exports.TrackingApiFactory = exports.TrackingApiFp = exports.TrackingApiAxiosParamCreator = exports.TrackableContainersApi = exports.TrackableContainersApiFactory = exports.TrackableContainersApiFp = exports.TrackableContainersApiAxiosParamCreator = exports.TaskApi = exports.TaskApiFactory = exports.TaskApiFp = exports.TaskApiAxiosParamCreator = exports.SystemApi = exports.SystemApiFactory = exports.SystemApiFp = exports.SystemApiAxiosParamCreator = exports.StationsListStationTypeEnum = exports.StationsLabelsPrecacheDataFormatEnum = exports.StationsLabelsDataFormatEnum = exports.StationsApi = exports.StationsApiFactory = exports.StationsApiFp = exports.StationsApiAxiosParamCreator = exports.Station2schemeApi = exports.Station2schemeApiFactory = exports.Station2schemeApiFp = exports.Station2schemeApiAxiosParamCreator = exports.StaffListRoleTypeEnum = exports.StaffListSortByEnum = exports.StaffApi = exports.StaffApiFactory = exports.StaffApiFp = exports.StaffApiAxiosParamCreator = exports.ShippersApi = exports.ShippersApiFactory = void 0;
exports.ZonesListSortByEnum = exports.ZonesLabelDataFormatEnum = exports.ZonesApi = exports.ZonesApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.APIExceptionErrorCodeEnum = {
    NOT_SPECIFIED: 'not_specified',
    LIMIT_EXCEEDED: 'limit_exceeded',
    THIRD_PARTY_FAILURE: 'third_party_failure',
    TARGET_NOT_FOUND: 'target_not_found',
    INVALID_TARGET: 'invalid_target',
    RESOURCE_CONFLICT: 'resource_conflict',
    INVALID_PERMISSIONS: 'invalid_permissions',
    REDUNDANT_ACTION: 'redundant_action',
    UNAVAILABLE_EMAIL: 'unavailable_email',
    INVALID_CONTAINER_STATUS: 'invalid_container_status',
    MISSING_ROUTE: 'missing_route',
    INVALID_CREDENTIALS: 'invalid_credentials',
    INVALID_DEVICE_ID: 'invalid_device_id',
    IMPORT_FAILURE: 'import_failure',
    MISSING_DATA_FOR_DISPATCH: 'missing_data_for_dispatch',
    REQUIRES_MEASUREMENT: 'requires_measurement',
    DOWNSTREAM_INTEGRATION_COMMUNICATION_FAILURE: 'downstream_integration_communication_failure',
    CUSTOMER_CONFIGURATION_CONSTRAINT_FAILURE: 'customer_configuration_constraint_failure',
    ACTIVE_HOLD_FOR_RESOURCE: 'active_hold_for_resource',
    INVALID_STATUS_FOR_UPDATE: 'invalid_status_for_update'
};
exports.AreaAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
exports.AreaByQueryAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
exports.AreaDetailsAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
exports.BulkImportIssueLevelEnum = {
    WARNING: 'warning',
    ERROR: 'error'
};
exports.ChaosFlagKindEnum = {
    INTERNAL_SERVER_ERROR: 'internal_server_error',
    PROCESS_KILL: 'process_kill'
};
exports.ContainerContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.ContainerContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
exports.ContainerProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ContainerLastProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ContainerStateEnum = {
    OPEN: 'OPEN',
    CLOSING: 'CLOSING',
    CLOSED: 'CLOSED'
};
exports.ContainerCreationMethodEnum = {
    SCAN: 'SCAN',
    MANUAL: 'MANUAL',
    SYSTEM: 'SYSTEM'
};
exports.ContainerByQueryContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.ContainerByQueryContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
exports.ContainerDetailsContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.ContainerDetailsContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
exports.ContainerDetailsProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ContainerDetailsLastProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ContainerDetailsStateEnum = {
    OPEN: 'OPEN',
    CLOSING: 'CLOSING',
    CLOSED: 'CLOSED'
};
exports.ContainerOpsBehaviorConfigRequireLabeledMoveEnum = {
    NEVER: 'NEVER',
    ALWAYS: 'ALWAYS',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
exports.CorporateRolesDependenciesPermissionEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT'
};
exports.CorporateRolesDependenciesParentsEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT'
};
exports.CorporateRolesDependenciesChildrenEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT'
};
exports.CorporateRolesDependenciesGroupEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT'
};
exports.CustomerPermissionRoleTypeEnum = {
    CUSTOMER: 'CUSTOMER'
};
exports.CustomerPermissionPermissionsEnum = {
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ'
};
exports.DeviceVersionStatusEnum = {
    LIVE: 'LIVE',
    OUTDATED: 'OUTDATED',
    DEPRECATED: 'DEPRECATED'
};
exports.DeviceStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
exports.DeviceDetailsVersionStatusEnum = {
    LIVE: 'LIVE',
    OUTDATED: 'OUTDATED',
    DEPRECATED: 'DEPRECATED'
};
exports.DeviceDetailsAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
exports.DeviceDetailsStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
exports.EnrollmentTokenSerializarFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
exports.EventEventTypeEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.EventEventSourceEnum = {
    SYSTEM: 'SYSTEM',
    USPS: 'USPS',
    ROUTE4_ME: 'ROUTE4ME',
    FDC: 'FDC'
};
exports.GenericErrorErrorCodeEnum = {
    NOT_SPECIFIED: 'not_specified',
    LIMIT_EXCEEDED: 'limit_exceeded',
    THIRD_PARTY_FAILURE: 'third_party_failure',
    TARGET_NOT_FOUND: 'target_not_found',
    INVALID_TARGET: 'invalid_target',
    RESOURCE_CONFLICT: 'resource_conflict',
    INVALID_PERMISSIONS: 'invalid_permissions',
    REDUNDANT_ACTION: 'redundant_action',
    UNAVAILABLE_EMAIL: 'unavailable_email',
    INVALID_CONTAINER_STATUS: 'invalid_container_status',
    MISSING_ROUTE: 'missing_route',
    INVALID_CREDENTIALS: 'invalid_credentials',
    INVALID_DEVICE_ID: 'invalid_device_id',
    IMPORT_FAILURE: 'import_failure',
    MISSING_DATA_FOR_DISPATCH: 'missing_data_for_dispatch',
    REQUIRES_MEASUREMENT: 'requires_measurement',
    DOWNSTREAM_INTEGRATION_COMMUNICATION_FAILURE: 'downstream_integration_communication_failure',
    CUSTOMER_CONFIGURATION_CONSTRAINT_FAILURE: 'customer_configuration_constraint_failure',
    ACTIVE_HOLD_FOR_RESOURCE: 'active_hold_for_resource',
    INVALID_STATUS_FOR_UPDATE: 'invalid_status_for_update'
};
exports.HoldReasonDeviceTypeEnum = {
    OT: 'OT',
    WEB: 'WEB'
};
exports.HoldReasonSourceEnum = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
};
exports.HoldReasonScopeEnum = {
    SYSTEM: 'SYSTEM',
    CUSTOMER: 'CUSTOMER'
};
exports.InboundLoadLoadStatusEnum = {
    PLANNED: 'PLANNED',
    ARRIVED: 'ARRIVED',
    CHECKED_IN: 'CHECKED_IN'
};
exports.InboundManifestStatusEnum = {
    NEW: 'NEW',
    EDITED: 'EDITED',
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    TRANSMISSION_ERROR: 'TRANSMISSION_ERROR',
    ARRIVED: 'ARRIVED'
};
exports.InboundManifestIssueLevelEnum = {
    WARNING: 'warning',
    ERROR: 'error'
};
exports.InboundManifestIssueItemEnum = {
    CONTAINER: 'container',
    PACKAGE: 'package'
};
exports.InboundManifestResponseStatusEnum = {
    NEW: 'NEW',
    EDITED: 'EDITED',
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    TRANSMISSION_ERROR: 'TRANSMISSION_ERROR',
    ARRIVED: 'ARRIVED'
};
exports.IntegrationLabelFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
exports.LoadPointDefaultContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.LoadPointByQueryContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.LoadPointDetailsDefaultContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.LocationStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
exports.LogoutReasonEnum = {
    NOT_SPECIFIED: 'NOT_SPECIFIED',
    INACTIVITY: 'INACTIVITY'
};
exports.ManifestStatusEnum = {
    NEW: 'NEW',
    EDITED: 'EDITED',
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    TRANSMISSION_ERROR: 'TRANSMISSION_ERROR',
    ARRIVED: 'ARRIVED'
};
exports.ManifestSerializerDetailsStatusEnum = {
    NEW: 'NEW',
    EDITED: 'EDITED',
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    TRANSMISSION_ERROR: 'TRANSMISSION_ERROR',
    ARRIVED: 'ARRIVED'
};
exports.NestedContainerContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
exports.NestedCreatePackageHoldReasonScopeEnum = {
    SYSTEM: 'SYSTEM',
    CUSTOMER: 'CUSTOMER'
};
exports.NestedEventEventTypeEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.NestedInboundManifestContainerContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.NestedOutboundLoadLoadStatusEnum = {
    OPEN: 'OPEN',
    LOADING: 'LOADING',
    DISPATCHED: 'DISPATCHED'
};
exports.NestedProcessStepSerializerContainerProcessStepEnum = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
exports.NestedProcessStepSerializerPackageProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
exports.OutboundIntegrationUSPSProtocolEnum = {
    GSS: 'GSS',
    EVS: 'EVS'
};
exports.OutboundLoadLoadStatusEnum = {
    OPEN: 'OPEN',
    LOADING: 'LOADING',
    DISPATCHED: 'DISPATCHED'
};
exports.OutboundLoadReportStatusEnum = {
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};
exports.PackageProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.PackageLastProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.PackageDetailsProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.PackageDetailsLastProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.PatchRoleRoleTypeEnum = {
    BLANK: 'BLANK',
    OPERATOR_I: 'OPERATOR_I',
    OPERATOR_II: 'OPERATOR_II',
    OPERATOR_III: 'OPERATOR_III',
    STATION_ADMIN: 'STATION_ADMIN',
    ORG_ADMIN: 'ORG_ADMIN',
    SUPER_USER: 'SUPER_USER'
};
exports.PatchRolePermissionsEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE'
};
exports.PermissionsRoleTypeEnum = {
    BLANK: 'BLANK',
    OPERATOR_I: 'OPERATOR_I',
    OPERATOR_II: 'OPERATOR_II',
    OPERATOR_III: 'OPERATOR_III',
    STATION_ADMIN: 'STATION_ADMIN',
    ORG_ADMIN: 'ORG_ADMIN',
    SUPER_USER: 'SUPER_USER',
    CUSTOMER: 'CUSTOMER'
};
exports.PermissionsPermissionsEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE: 'EXT_CUSTOMER_MANIFEST_WRITE',
    EXT_CUSTOMER_MANIFEST_WRITE_SILENT: 'EXT_CUSTOMER_MANIFEST_WRITE_SILENT',
    EXT_CUSTOMER_PACKAGE_WRITE: 'EXT_CUSTOMER_PACKAGE_WRITE',
    EXT_CUSTOMER_PACKAGE_WRITE_SILENT: 'EXT_CUSTOMER_PACKAGE_WRITE_SILENT'
};
exports.ProcessStepDatasetRowColumnsEnum = {
    TIMESTAMP: 'timestamp',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.PublicContainerSerializerContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
exports.RelabelOptionsConfigProvidersEnum = {
    FDC: 'FDC',
    USPS: 'USPS',
    PSPRT_V1: 'psprt.v1'
};
exports.ReportDatasetEventIntervalsOriginEventEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ReportDatasetEventIntervalsTargetEventEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.ReportDatasetExpectedInfluxInfluxTypeEnum = {
    COUNT: 'COUNT',
    WEIGHT: 'WEIGHT',
    VOLUME: 'VOLUME'
};
exports.ReportDatasetPerformanceMetricEnum = {
    PACKAGES: 'PACKAGES',
    VOLUME: 'VOLUME'
};
exports.ReportDatasetPerformanceTimeEnum = {
    SECONDS: 'SECONDS',
    MINUTES: 'MINUTES',
    HOURS: 'HOURS'
};
exports.ReportDatasetProcessStepProcessStepsEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
exports.ReportDatasetProcessStepResourceEnum = {
    PACKAGES: 'PACKAGES'
};
exports.ReportDatasetProcessStepMetricEnum = {
    COUNT: 'COUNT',
    WEIGHT: 'WEIGHT',
    VOLUME: 'VOLUME'
};
exports.ShiftPlanShiftPlanTypeEnum = {
    DEFAULT: 'DEFAULT',
    PRESET: 'PRESET'
};
exports.ShiftPlanPresetShiftPlanTypeEnum = {
    DEFAULT: 'DEFAULT',
    PRESET: 'PRESET'
};
exports.ShiftPlanPresetRecurrenceEnum = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
};
exports.StaffPermissionRoleTypeEnum = {
    BLANK: 'BLANK',
    OPERATOR_I: 'OPERATOR_I',
    OPERATOR_II: 'OPERATOR_II',
    OPERATOR_III: 'OPERATOR_III',
    STATION_ADMIN: 'STATION_ADMIN',
    ORG_ADMIN: 'ORG_ADMIN',
    SUPER_USER: 'SUPER_USER'
};
exports.StaffPermissionPermissionsEnum = {
    STATION_READ: 'STATION_READ',
    STATION_WRITE: 'STATION_WRITE',
    STATION_QRCODE_READ: 'STATION_QRCODE_READ',
    STATION_REPORT_READ: 'STATION_REPORT_READ',
    STATION_USER_SELF_READ: 'STATION_USER_SELF_READ',
    STATION_USER_SELF_WRITE: 'STATION_USER_SELF_WRITE',
    STATION_LAYOUT_READ: 'STATION_LAYOUT_READ',
    STATION_LAYOUT_WRITE: 'STATION_LAYOUT_WRITE',
    STATION_PLANNER_READ: 'STATION_PLANNER_READ',
    STATION_PLANNER_WRITE: 'STATION_PLANNER_WRITE',
    ORGANIZATION_READ: 'ORGANIZATION_READ',
    ORGANIZATION_MODIFY: 'ORGANIZATION_MODIFY',
    ORGANIZATION_WRITE: 'ORGANIZATION_WRITE',
    OUTBOUNDLOAD_READ: 'OUTBOUNDLOAD_READ',
    OUTBOUNDLOAD_WRITE: 'OUTBOUNDLOAD_WRITE',
    OUTBOUNDLOAD_REPORT_READ: 'OUTBOUNDLOAD_REPORT_READ',
    PACKAGE_READ: 'PACKAGE_READ',
    PACKAGE_REPORT_READ: 'PACKAGE_REPORT_READ',
    PACKAGE_LABEL_READ: 'PACKAGE_LABEL_READ',
    PACKAGE_WRITE: 'PACKAGE_WRITE',
    LOADPLAN_READ: 'LOADPLAN_READ',
    LOADPLAN_WRITE: 'LOADPLAN_WRITE',
    LOADPLAN_REPORT_READ: 'LOADPLAN_REPORT_READ',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    USER_BADGE_READ: 'USER_BADGE_READ',
    USER_BADGE_INVALIDATE: 'USER_BADGE_INVALIDATE',
    USER_LOCK: 'USER_LOCK',
    DEVICE_READ: 'DEVICE_READ',
    DEVICE_WRITE: 'DEVICE_WRITE',
    CONTAINER_READ: 'CONTAINER_READ',
    CONTAINER_REPORT_READ: 'CONTAINER_REPORT_READ',
    CONTAINER_LABEL_READ: 'CONTAINER_LABEL_READ',
    CONTAINER_WRITE: 'CONTAINER_WRITE',
    MANIFEST_READ: 'MANIFEST_READ',
    MANIFEST_WRITE: 'MANIFEST_WRITE',
    MANIFEST_REPORT_READ: 'MANIFEST_REPORT_READ',
    ROUTE_READ: 'ROUTE_READ',
    ROUTE_WRITE: 'ROUTE_WRITE',
    OPERATORTOOL_SORTATION: 'OPERATORTOOL_SORTATION',
    OPERATORTOOL_MISSORT: 'OPERATORTOOL_MISSORT',
    OPERATORTOOL_LOADING: 'OPERATORTOOL_LOADING',
    OPERATORTOOL_MISLOAD: 'OPERATORTOOL_MISLOAD',
    OPERATORTOOL_CONTAINERS: 'OPERATORTOOL_CONTAINERS',
    OPERATORTOOL_LOADS: 'OPERATORTOOL_LOADS',
    OPERATORTOOL_MISMOVE: 'OPERATORTOOL_MISMOVE',
    OPERATORTOOL_TROUBLESHOOTING: 'OPERATORTOOL_TROUBLESHOOTING',
    OPERATORTOOL_RELABEL: 'OPERATORTOOL_RELABEL',
    OPERATORTOOL_RETURNING: 'OPERATORTOOL_RETURNING',
    OPERATORTOOL_INBOUNDLOADS: 'OPERATORTOOL_INBOUNDLOADS',
    OPERATORTOOL_MEASURING: 'OPERATORTOOL_MEASURING',
    WEBHOOK_READ: 'WEBHOOK_READ',
    WEBHOOK_WRITE: 'WEBHOOK_WRITE',
    MASTER_READ: 'MASTER_READ',
    MASTER_WRITE: 'MASTER_WRITE',
    USER_LOOKUP: 'USER_LOOKUP',
    TECHNICAL_ASSETS_READ: 'TECHNICAL_ASSETS_READ',
    INBOUNDLOAD_READ: 'INBOUNDLOAD_READ',
    INBOUNDLOAD_WRITE: 'INBOUNDLOAD_WRITE'
};
exports.StationStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
exports.StationDetailsStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
exports.StationPackageCountCutOffEventTypesEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.StationPackageCountForEventTypeEventTypesEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.TaskStatusEnum = {
    CREATED: 'CREATED',
    STARTED: 'STARTED',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};
exports.TaskFailureReasonEnum = {
    NOT_SPECIFIED: 'NOT_SPECIFIED',
    INVALID_MACHINEID: 'INVALID_MACHINEID',
    MEASUREMENT_FAILED: 'MEASUREMENT_FAILED',
    DIMENSIONS_EXCEEDED: 'DIMENSIONS_EXCEEDED',
    NO_OBJECT_DETECTED: 'NO_OBJECT_DETECTED',
    ML_TRIGGER_FAIL: 'ML_TRIGGER_FAIL',
    ML_POLL_FAIL: 'ML_POLL_FAIL',
    MANIFEST_NOT_FOUND: 'MANIFEST_NOT_FOUND',
    MANIFEST_NOT_ACCEPTED: 'MANIFEST_NOT_ACCEPTED',
    UNHANDLED: 'UNHANDLED',
    FILE_NOT_FOUND: 'FILE_NOT_FOUND',
    ADD_PACKAGES_RECEPTACLE: 'ADD_PACKAGES_RECEPTACLE',
    PROCESS_DISPATCH: 'PROCESS_DISPATCH',
    GSS_REQUEST_TIMEOUT: 'GSS_REQUEST_TIMEOUT',
    DIMENSIONS_ZERO: 'DIMENSIONS_ZERO',
    CLOSE_CONTAINER: 'CLOSE_CONTAINER',
    CARRIER_NOT_FOUND: 'CARRIER_NOT_FOUND'
};
exports.TrackingStatusEnum = {
    FOUND: 'FOUND',
    NOT_FOUND: 'NOT_FOUND'
};
exports.TrackingEventEventTypeEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.TrackingEventEventSourceEnum = {
    SYSTEM: 'SYSTEM',
    LINEHAUL: 'LINEHAUL',
    CARRIER: 'CARRIER'
};
exports.UserUserTypeEnum = {
    STAFF: 'STAFF',
    FMC: 'FMC',
    CUSTOMER: 'CUSTOMER'
};
exports.ValidationErrorErrorCodeEnum = {
    NOT_SPECIFIED: 'not_specified',
    LIMIT_EXCEEDED: 'limit_exceeded',
    THIRD_PARTY_FAILURE: 'third_party_failure',
    TARGET_NOT_FOUND: 'target_not_found',
    INVALID_TARGET: 'invalid_target',
    RESOURCE_CONFLICT: 'resource_conflict',
    INVALID_PERMISSIONS: 'invalid_permissions',
    REDUNDANT_ACTION: 'redundant_action',
    UNAVAILABLE_EMAIL: 'unavailable_email',
    INVALID_CONTAINER_STATUS: 'invalid_container_status',
    MISSING_ROUTE: 'missing_route',
    INVALID_CREDENTIALS: 'invalid_credentials',
    INVALID_DEVICE_ID: 'invalid_device_id',
    IMPORT_FAILURE: 'import_failure',
    MISSING_DATA_FOR_DISPATCH: 'missing_data_for_dispatch',
    REQUIRES_MEASUREMENT: 'requires_measurement',
    DOWNSTREAM_INTEGRATION_COMMUNICATION_FAILURE: 'downstream_integration_communication_failure',
    CUSTOMER_CONFIGURATION_CONSTRAINT_FAILURE: 'customer_configuration_constraint_failure',
    ACTIVE_HOLD_FOR_RESOURCE: 'active_hold_for_resource',
    INVALID_STATUS_FOR_UPDATE: 'invalid_status_for_update'
};
exports.WebHookGenerateApiTokenIntegrationRefEnum = {
    EASYPOST: 'EASYPOST',
    USPS: 'USPS',
    ROUTE_4_ME: 'ROUTE_4_ME',
    FDC: 'FDC',
    SENDGRID: 'SENDGRID'
};
exports.WebHookSubscriptionMethodEnum = {
    POST: 'POST',
    PUT: 'PUT'
};
exports.WebHookSubscriptionFormatEnum = {
    JSON: 'JSON',
    CSV: 'CSV'
};
exports.WebHookSubscriptionFilterFilterTypeEnum = {
    STAR: '*',
    TRACKING_UPDATE: 'TRACKING_UPDATE',
    OUTBOUND_MANIFEST: 'OUTBOUND_MANIFEST'
};
exports.WebHookSubscriptionFilterResourceTypeEnum = {
    STAR: '*',
    CONTAINER: 'CONTAINER',
    PACKAGE: 'PACKAGE'
};
exports.WebHookSubscriptionFilterEventTypesEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
exports.WebHookSubscriptionHistoryStatusEnum = {
    CREATED: 'CREATED',
    STARTED: 'STARTED',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};
exports.WebHookSubscriptionHistoryTypeEnum = {
    STAR: '*',
    TRACKING_UPDATE: 'TRACKING_UPDATE',
    OUTBOUND_MANIFEST: 'OUTBOUND_MANIFEST'
};
exports.WebHookSubscriptionHistoryResourceTypeEnum = {
    CONTAINER: 'CONTAINER',
    PACKAGE: 'PACKAGE'
};
exports.WebHookSubscriptionHistoryTrackingUpdateEventTypeEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * AreasApi - axios parameter creator
 * @export
 */
var AreasApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns the Area using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an Area by query
         * @param {number} [id] Area ID
         * @param {string} [name] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasByquery: function (id, name, station, stationName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/areas/byquery/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (stationName !== undefined) {
                                localVarQueryParameter['station_name'] = stationName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Area*
         * @summary Create Area
         * @param {Area} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('areasCreate', 'data', data);
                            localVarPath = "/areas/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Area with specified id*
         * @summary Delete Area
         * @param {number} id A unique integer value identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('areasDelete', 'id', id);
                            localVarPath = "/areas/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Area by ID.
         * @summary Get the PNG label for a Area
         * @param {number} id A unique integer value identifying this area.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('areasLabelLabelPng', 'id', id);
                            localVarPath = "/areas/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label for a Area in JSON.
         * @summary Get the ZPL label for a Area
         * @param {number} id A unique integer value identifying this area.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('areasLabelLabelZpl', 'id', id);
                            localVarPath = "/areas/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * An area is a named location for work or preparation for work. Activity Areas include Load Points, Unload Points, Staging Areas, etc. Activity Areas are potentially assignable to Operators, Packages, and Containers.  *This endpoint returns a list of Areas*
         * @summary Get Areas
         * @param {number} [station] Station ID
         * @param {Array<AreasListAreaTypeEnum>} [areaType] Area Type
         * @param {AreasListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasList: function (station, areaType, sortBy, search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/areas/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (areaType) {
                                localVarQueryParameter['area_type'] = areaType.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Area with specified id*
         * @summary Patch Area
         * @param {number} id A unique integer value identifying this area.
         * @param {AreaDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('areasPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('areasPartialUpdate', 'data', data);
                            localVarPath = "/areas/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Area with specified id*
         * @summary Retrieve Area
         * @param {number} id A unique integer value identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('areasRead', 'id', id);
                            localVarPath = "/areas/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AreasApiAxiosParamCreator = AreasApiAxiosParamCreator;
/**
 * AreasApi - functional programming interface
 * @export
 */
var AreasApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AreasApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns the Area using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an Area by query
         * @param {number} [id] Area ID
         * @param {string} [name] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasByquery: function (id, name, station, stationName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasByquery(id, name, station, stationName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasByquery']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Area*
         * @summary Create Area
         * @param {Area} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Area with specified id*
         * @summary Delete Area
         * @param {number} id A unique integer value identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Area by ID.
         * @summary Get the PNG label for a Area
         * @param {number} id A unique integer value identifying this area.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label for a Area in JSON.
         * @summary Get the ZPL label for a Area
         * @param {number} id A unique integer value identifying this area.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * An area is a named location for work or preparation for work. Activity Areas include Load Points, Unload Points, Staging Areas, etc. Activity Areas are potentially assignable to Operators, Packages, and Containers.  *This endpoint returns a list of Areas*
         * @summary Get Areas
         * @param {number} [station] Station ID
         * @param {Array<AreasListAreaTypeEnum>} [areaType] Area Type
         * @param {AreasListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasList: function (station, areaType, sortBy, search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasList(station, areaType, sortBy, search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Area with specified id*
         * @summary Patch Area
         * @param {number} id A unique integer value identifying this area.
         * @param {AreaDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Area with specified id*
         * @summary Retrieve Area
         * @param {number} id A unique integer value identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areasRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AreasApi.areasRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AreasApiFp = AreasApiFp;
/**
 * AreasApi - factory interface
 * @export
 */
var AreasApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AreasApiFp)(configuration);
    return {
        /**
         * This endpoint returns the Area using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an Area by query
         * @param {AreasApiAreasByqueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasByquery: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.areasByquery(requestParameters.id, requestParameters.name, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Area*
         * @summary Create Area
         * @param {AreasApiAreasCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasCreate: function (requestParameters, options) {
            return localVarFp.areasCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Area with specified id*
         * @summary Delete Area
         * @param {AreasApiAreasDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasDelete: function (requestParameters, options) {
            return localVarFp.areasDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Area by ID.
         * @summary Get the PNG label for a Area
         * @param {AreasApiAreasLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelPng: function (requestParameters, options) {
            return localVarFp.areasLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label for a Area in JSON.
         * @summary Get the ZPL label for a Area
         * @param {AreasApiAreasLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.areasLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * An area is a named location for work or preparation for work. Activity Areas include Load Points, Unload Points, Staging Areas, etc. Activity Areas are potentially assignable to Operators, Packages, and Containers.  *This endpoint returns a list of Areas*
         * @summary Get Areas
         * @param {AreasApiAreasListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.areasList(requestParameters.station, requestParameters.areaType, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Area with specified id*
         * @summary Patch Area
         * @param {AreasApiAreasPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasPartialUpdate: function (requestParameters, options) {
            return localVarFp.areasPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Area with specified id*
         * @summary Retrieve Area
         * @param {AreasApiAreasReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasRead: function (requestParameters, options) {
            return localVarFp.areasRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AreasApiFactory = AreasApiFactory;
/**
 * AreasApi - object-oriented interface
 * @export
 * @class AreasApi
 * @extends {BaseAPI}
 */
var AreasApi = /** @class */ (function (_super) {
    __extends(AreasApi, _super);
    function AreasApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns the Area using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
     * @summary Get an Area by query
     * @param {AreasApiAreasByqueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasByquery = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AreasApiFp)(this.configuration).areasByquery(requestParameters.id, requestParameters.name, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Area*
     * @summary Create Area
     * @param {AreasApiAreasCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Area with specified id*
     * @summary Delete Area
     * @param {AreasApiAreasDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Area by ID.
     * @summary Get the PNG label for a Area
     * @param {AreasApiAreasLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label for a Area in JSON.
     * @summary Get the ZPL label for a Area
     * @param {AreasApiAreasLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * An area is a named location for work or preparation for work. Activity Areas include Load Points, Unload Points, Staging Areas, etc. Activity Areas are potentially assignable to Operators, Packages, and Containers.  *This endpoint returns a list of Areas*
     * @summary Get Areas
     * @param {AreasApiAreasListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AreasApiFp)(this.configuration).areasList(requestParameters.station, requestParameters.areaType, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Area with specified id*
     * @summary Patch Area
     * @param {AreasApiAreasPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Area with specified id*
     * @summary Retrieve Area
     * @param {AreasApiAreasReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    AreasApi.prototype.areasRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AreasApiFp)(this.configuration).areasRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AreasApi;
}(base_1.BaseAPI));
exports.AreasApi = AreasApi;
/**
 * @export
 */
exports.AreasListAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
/**
 * @export
 */
exports.AreasListSortByEnum = {
    NAME: 'name',
    NAME2: '-name'
};
/**
 * AuthApi - axios parameter creator
 * @export
 */
var AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * If the provided token is valid, and the associated user has a pending email to be confirmed, this action will perform the confirmation and finalise the change. After this action, the user must login with the new email.
         * @summary Confirms a pending email change
         * @param {EmailChange} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailChangeCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('authEmailChangeCreate', 'data', data);
                            localVarPath = "/auth/email_change";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint provides a JWT pair (access and refresh token) for the provided user data. When logging in with a `device_id` different from `web`, the endpoint initiates a session for the operator, that is reflected in event and other related data.  This endpoint is used to sign-in via badge tokens, which are available to be generated for each user in the system, permitting a more operator-friendly sign-in process.  Access tokens are valid for 24h and refresh tokens for 72h. It is possible to automatically obtain a new JWT pair via the [refresh endpoint](#operation/auth_refresh_create) within the expiration period of the refresh token.
         * @summary Obtain JWT and Login
         * @param {ObtainToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'data' is not null or undefined
                    (0, common_1.assertParamExists)('authLoginCreate', 'data', data);
                    localVarPath = "/auth/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This endpoint terminates the user\'s session explicitly, while the authentication token used for this session continues to be valid, the operator\'s session data is closed and it is expected that the token is no longer used.  It is not required to use this endpoint for web-based access to the system. Only device-based access should use the endpoint to signal de-authentication in the app and provide the reason for the logout.
         * @summary Logout
         * @param {Logout} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('authLogoutCreate', 'data', data);
                            localVarPath = "/auth/logout";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This changes the users password to the given value if the token provided is valid and not expired.
         * @summary Changes user password
         * @param {PasswordChange} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordChangeCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('authPasswordChangeCreate', 'data', data);
                            localVarPath = "/auth/password_change";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows users to request a password reset email in instances where the user\'s password is lost. If this endpoint is used and a valid email is provided, the user receives an email requesting to reset the password via the CloudSort Web Application. The email contains a link that permits you to overwrite the password.  Note that the link is valid only 24h, afterwards a new email has to be requested.
         * @summary Reset Password
         * @param {PasswordReset} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'data' is not null or undefined
                    (0, common_1.assertParamExists)('authPasswordResetCreate', 'data', data);
                    localVarPath = "/auth/password_reset";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Similar to the [login endpoint](#operation/auth_login_create), this API allows to refresh a users authentication via the provided refresh token. It is typically used when the users access token is expired, but should not be prompted to login again. This endpoint allows to re-authenticate such a user automatically, without an interaction.  Once the refresh token is expired, the user is re-prompted for their credentials. Each refresh request returns a new JWT pair, providing a new refresh token with the expiration date reset.
         * @summary Refresh JWT and Re-Login
         * @param {RefreshToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'data' is not null or undefined
                    (0, common_1.assertParamExists)('authRefreshCreate', 'data', data);
                    localVarPath = "/auth/refresh/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthApiAxiosParamCreator = AuthApiAxiosParamCreator;
/**
 * AuthApi - functional programming interface
 * @export
 */
var AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthApiAxiosParamCreator)(configuration);
    return {
        /**
         * If the provided token is valid, and the associated user has a pending email to be confirmed, this action will perform the confirmation and finalise the change. After this action, the user must login with the new email.
         * @summary Confirms a pending email change
         * @param {EmailChange} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailChangeCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authEmailChangeCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authEmailChangeCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint provides a JWT pair (access and refresh token) for the provided user data. When logging in with a `device_id` different from `web`, the endpoint initiates a session for the operator, that is reflected in event and other related data.  This endpoint is used to sign-in via badge tokens, which are available to be generated for each user in the system, permitting a more operator-friendly sign-in process.  Access tokens are valid for 24h and refresh tokens for 72h. It is possible to automatically obtain a new JWT pair via the [refresh endpoint](#operation/auth_refresh_create) within the expiration period of the refresh token.
         * @summary Obtain JWT and Login
         * @param {ObtainToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authLoginCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authLoginCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint terminates the user\'s session explicitly, while the authentication token used for this session continues to be valid, the operator\'s session data is closed and it is expected that the token is no longer used.  It is not required to use this endpoint for web-based access to the system. Only device-based access should use the endpoint to signal de-authentication in the app and provide the reason for the logout.
         * @summary Logout
         * @param {Logout} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authLogoutCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authLogoutCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This changes the users password to the given value if the token provided is valid and not expired.
         * @summary Changes user password
         * @param {PasswordChange} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordChangeCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authPasswordChangeCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authPasswordChangeCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows users to request a password reset email in instances where the user\'s password is lost. If this endpoint is used and a valid email is provided, the user receives an email requesting to reset the password via the CloudSort Web Application. The email contains a link that permits you to overwrite the password.  Note that the link is valid only 24h, afterwards a new email has to be requested.
         * @summary Reset Password
         * @param {PasswordReset} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authPasswordResetCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authPasswordResetCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Similar to the [login endpoint](#operation/auth_login_create), this API allows to refresh a users authentication via the provided refresh token. It is typically used when the users access token is expired, but should not be prompted to login again. This endpoint allows to re-authenticate such a user automatically, without an interaction.  Once the refresh token is expired, the user is re-prompted for their credentials. Each refresh request returns a new JWT pair, providing a new refresh token with the expiration date reset.
         * @summary Refresh JWT and Re-Login
         * @param {RefreshToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authRefreshCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthApi.authRefreshCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthApiFp = AuthApiFp;
/**
 * AuthApi - factory interface
 * @export
 */
var AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthApiFp)(configuration);
    return {
        /**
         * If the provided token is valid, and the associated user has a pending email to be confirmed, this action will perform the confirmation and finalise the change. After this action, the user must login with the new email.
         * @summary Confirms a pending email change
         * @param {AuthApiAuthEmailChangeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailChangeCreate: function (requestParameters, options) {
            return localVarFp.authEmailChangeCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint provides a JWT pair (access and refresh token) for the provided user data. When logging in with a `device_id` different from `web`, the endpoint initiates a session for the operator, that is reflected in event and other related data.  This endpoint is used to sign-in via badge tokens, which are available to be generated for each user in the system, permitting a more operator-friendly sign-in process.  Access tokens are valid for 24h and refresh tokens for 72h. It is possible to automatically obtain a new JWT pair via the [refresh endpoint](#operation/auth_refresh_create) within the expiration period of the refresh token.
         * @summary Obtain JWT and Login
         * @param {AuthApiAuthLoginCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginCreate: function (requestParameters, options) {
            return localVarFp.authLoginCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint terminates the user\'s session explicitly, while the authentication token used for this session continues to be valid, the operator\'s session data is closed and it is expected that the token is no longer used.  It is not required to use this endpoint for web-based access to the system. Only device-based access should use the endpoint to signal de-authentication in the app and provide the reason for the logout.
         * @summary Logout
         * @param {AuthApiAuthLogoutCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutCreate: function (requestParameters, options) {
            return localVarFp.authLogoutCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This changes the users password to the given value if the token provided is valid and not expired.
         * @summary Changes user password
         * @param {AuthApiAuthPasswordChangeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordChangeCreate: function (requestParameters, options) {
            return localVarFp.authPasswordChangeCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows users to request a password reset email in instances where the user\'s password is lost. If this endpoint is used and a valid email is provided, the user receives an email requesting to reset the password via the CloudSort Web Application. The email contains a link that permits you to overwrite the password.  Note that the link is valid only 24h, afterwards a new email has to be requested.
         * @summary Reset Password
         * @param {AuthApiAuthPasswordResetCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetCreate: function (requestParameters, options) {
            return localVarFp.authPasswordResetCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Similar to the [login endpoint](#operation/auth_login_create), this API allows to refresh a users authentication via the provided refresh token. It is typically used when the users access token is expired, but should not be prompted to login again. This endpoint allows to re-authenticate such a user automatically, without an interaction.  Once the refresh token is expired, the user is re-prompted for their credentials. Each refresh request returns a new JWT pair, providing a new refresh token with the expiration date reset.
         * @summary Refresh JWT and Re-Login
         * @param {AuthApiAuthRefreshCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshCreate: function (requestParameters, options) {
            return localVarFp.authRefreshCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthApiFactory = AuthApiFactory;
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If the provided token is valid, and the associated user has a pending email to be confirmed, this action will perform the confirmation and finalise the change. After this action, the user must login with the new email.
     * @summary Confirms a pending email change
     * @param {AuthApiAuthEmailChangeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authEmailChangeCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authEmailChangeCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint provides a JWT pair (access and refresh token) for the provided user data. When logging in with a `device_id` different from `web`, the endpoint initiates a session for the operator, that is reflected in event and other related data.  This endpoint is used to sign-in via badge tokens, which are available to be generated for each user in the system, permitting a more operator-friendly sign-in process.  Access tokens are valid for 24h and refresh tokens for 72h. It is possible to automatically obtain a new JWT pair via the [refresh endpoint](#operation/auth_refresh_create) within the expiration period of the refresh token.
     * @summary Obtain JWT and Login
     * @param {AuthApiAuthLoginCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authLoginCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authLoginCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint terminates the user\'s session explicitly, while the authentication token used for this session continues to be valid, the operator\'s session data is closed and it is expected that the token is no longer used.  It is not required to use this endpoint for web-based access to the system. Only device-based access should use the endpoint to signal de-authentication in the app and provide the reason for the logout.
     * @summary Logout
     * @param {AuthApiAuthLogoutCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authLogoutCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authLogoutCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This changes the users password to the given value if the token provided is valid and not expired.
     * @summary Changes user password
     * @param {AuthApiAuthPasswordChangeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authPasswordChangeCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authPasswordChangeCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows users to request a password reset email in instances where the user\'s password is lost. If this endpoint is used and a valid email is provided, the user receives an email requesting to reset the password via the CloudSort Web Application. The email contains a link that permits you to overwrite the password.  Note that the link is valid only 24h, afterwards a new email has to be requested.
     * @summary Reset Password
     * @param {AuthApiAuthPasswordResetCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authPasswordResetCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authPasswordResetCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Similar to the [login endpoint](#operation/auth_login_create), this API allows to refresh a users authentication via the provided refresh token. It is typically used when the users access token is expired, but should not be prompted to login again. This endpoint allows to re-authenticate such a user automatically, without an interaction.  Once the refresh token is expired, the user is re-prompted for their credentials. Each refresh request returns a new JWT pair, providing a new refresh token with the expiration date reset.
     * @summary Refresh JWT and Re-Login
     * @param {AuthApiAuthRefreshCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.authRefreshCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration).authRefreshCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * ContainersApi - axios parameter creator
 * @export
 */
var ContainersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Container*
         * @summary Create Container
         * @param {Container} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('containersCreate', 'data', data);
                            localVarPath = "/containers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing containers with all their data.
         * @summary Get container list as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [targetOutboundLoad] Target Outbound Load
         * @param {number} [outboundLoad] Outbound Load
         * @param {number} [targetOrCurrentOutboundLoad] Target or Current OutboundLoad
         * @param {ContainersCsvContainerTypeEnum} [containerType] Container Type
         * @param {boolean} [outbound] Outbound Container
         * @param {boolean} [includeGhostResources] Show Ghost containers
         * @param {boolean} [includeOwnerConfiguration] Expose the container owner configuration
         * @param {boolean} [hidePending] Include only containers with events in from/to range.
         * @param {Array<number>} [manifest] Manifest ID
         * @param {number} [area] Area ID
         * @param {number} [zone] Zone ID
         * @param {number} [loadPoint] Load Point ID
         * @param {number} [module] Module ID
         * @param {number} [station] Station ID
         * @param {ContainersCsvSortByEnum} [sortBy] Sort By
         * @param {Array<ContainersCsvProcessStepEnum>} [processStep] Process Step
         * @param {Array<ContainersCsvExcludeProcessStepEnum>} [excludeProcessStep] Exclude Process Step
         * @param {Array<ContainersCsvContainerStatusEnum>} [containerStatus] Container Status
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {Array<ContainersCsvDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {number} [parentContainer] Parent container ID
         * @param {boolean} [excludeNestedContainers] Exclude nested containers
         * @param {boolean} [excludeParentContainers] Exclude parent containers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCsv: function (fromDate, toDate, page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fromDate' is not null or undefined
                            (0, common_1.assertParamExists)('containersCsv', 'fromDate', fromDate);
                            // verify required parameter 'toDate' is not null or undefined
                            (0, common_1.assertParamExists)('containersCsv', 'toDate', toDate);
                            localVarPath = "/containers/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (targetOutboundLoad !== undefined) {
                                localVarQueryParameter['target_outbound_load'] = targetOutboundLoad;
                            }
                            if (outboundLoad !== undefined) {
                                localVarQueryParameter['outbound_load'] = outboundLoad;
                            }
                            if (targetOrCurrentOutboundLoad !== undefined) {
                                localVarQueryParameter['target_or_current_outbound_load'] = targetOrCurrentOutboundLoad;
                            }
                            if (containerType !== undefined) {
                                localVarQueryParameter['container_type'] = containerType;
                            }
                            if (outbound !== undefined) {
                                localVarQueryParameter['outbound'] = outbound;
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (includeOwnerConfiguration !== undefined) {
                                localVarQueryParameter['include_owner_configuration'] = includeOwnerConfiguration;
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (manifest) {
                                localVarQueryParameter['manifest'] = manifest.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (loadPoint !== undefined) {
                                localVarQueryParameter['load_point'] = loadPoint;
                            }
                            if (module !== undefined) {
                                localVarQueryParameter['module'] = module;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (processStep) {
                                localVarQueryParameter['process_step'] = processStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeProcessStep) {
                                localVarQueryParameter['exclude_process_step'] = excludeProcessStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (containerStatus) {
                                localVarQueryParameter['container_status'] = containerStatus.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (parentContainer !== undefined) {
                                localVarQueryParameter['parent_container'] = parentContainer;
                            }
                            if (excludeNestedContainers !== undefined) {
                                localVarQueryParameter['exclude_nested_containers'] = excludeNestedContainers;
                            }
                            if (excludeParentContainers !== undefined) {
                                localVarQueryParameter['exclude_parent_containers'] = excludeParentContainers;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Container with specified id*
         * @summary Delete Container
         * @param {number} id A unique integer value identifying this container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('containersDelete', 'id', id);
                            localVarPath = "/containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Allow to perform container actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {ContainerGeneric} data
         * @param {boolean} [force] Force action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersGeneric: function (data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('containersGeneric', 'data', data);
                            localVarPath = "/containers/generic/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Container by ID.
         * @summary Get the PNG label for a Container
         * @param {number} id A unique integer value identifying this container.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('containersLabelLabelPng', 'id', id);
                            localVarPath = "/containers/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label for a Container in JSON.
         * @summary Get the ZPL label for a Container
         * @param {number} id A unique integer value identifying this container.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('containersLabelLabelZpl', 'id', id);
                            localVarPath = "/containers/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A container is a physical device that is acted on (loaded, moved, unloaded) Can be a package, bag, pallet, Gaylord, CloudSort Container, trailer, etc.  *This endpoint returns a list of Containers*
         * @summary Get Containers
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [targetOutboundLoad] Target Outbound Load
         * @param {number} [outboundLoad] Outbound Load
         * @param {number} [targetOrCurrentOutboundLoad] Target or Current OutboundLoad
         * @param {ContainersListContainerTypeEnum} [containerType] Container Type
         * @param {boolean} [outbound] Outbound Container
         * @param {boolean} [includeGhostResources] Show Ghost containers
         * @param {boolean} [includeOwnerConfiguration] Expose the container owner configuration
         * @param {boolean} [hidePending] Include only containers with events in from/to range.
         * @param {Array<number>} [manifest] Manifest ID
         * @param {number} [area] Area ID
         * @param {number} [zone] Zone ID
         * @param {number} [loadPoint] Load Point ID
         * @param {number} [module] Module ID
         * @param {number} [station] Station ID
         * @param {ContainersListSortByEnum} [sortBy] Sort By
         * @param {Array<ContainersListProcessStepEnum>} [processStep] Process Step
         * @param {Array<ContainersListExcludeProcessStepEnum>} [excludeProcessStep] Exclude Process Step
         * @param {Array<ContainersListContainerStatusEnum>} [containerStatus] Container Status
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {Array<ContainersListDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {number} [parentContainer] Parent container ID
         * @param {boolean} [excludeNestedContainers] Exclude nested containers
         * @param {boolean} [excludeParentContainers] Exclude parent containers
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {number} [inboundLoad] Inbound Load
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersList: function (page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, fromDate, toDate, inboundLoad, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/containers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (targetOutboundLoad !== undefined) {
                                localVarQueryParameter['target_outbound_load'] = targetOutboundLoad;
                            }
                            if (outboundLoad !== undefined) {
                                localVarQueryParameter['outbound_load'] = outboundLoad;
                            }
                            if (targetOrCurrentOutboundLoad !== undefined) {
                                localVarQueryParameter['target_or_current_outbound_load'] = targetOrCurrentOutboundLoad;
                            }
                            if (containerType !== undefined) {
                                localVarQueryParameter['container_type'] = containerType;
                            }
                            if (outbound !== undefined) {
                                localVarQueryParameter['outbound'] = outbound;
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (includeOwnerConfiguration !== undefined) {
                                localVarQueryParameter['include_owner_configuration'] = includeOwnerConfiguration;
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (manifest) {
                                localVarQueryParameter['manifest'] = manifest.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (loadPoint !== undefined) {
                                localVarQueryParameter['load_point'] = loadPoint;
                            }
                            if (module !== undefined) {
                                localVarQueryParameter['module'] = module;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (processStep) {
                                localVarQueryParameter['process_step'] = processStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeProcessStep) {
                                localVarQueryParameter['exclude_process_step'] = excludeProcessStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (containerStatus) {
                                localVarQueryParameter['container_status'] = containerStatus.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (parentContainer !== undefined) {
                                localVarQueryParameter['parent_container'] = parentContainer;
                            }
                            if (excludeNestedContainers !== undefined) {
                                localVarQueryParameter['exclude_nested_containers'] = excludeNestedContainers;
                            }
                            if (excludeParentContainers !== undefined) {
                                localVarQueryParameter['exclude_parent_containers'] = excludeParentContainers;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (inboundLoad !== undefined) {
                                localVarQueryParameter['inbound_load'] = inboundLoad;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Container with specified id*
         * @summary Patch Container
         * @param {number} id A unique integer value identifying this container.
         * @param {ContainerDetails} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersPartialUpdate: function (id, data, force, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('containersPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('containersPartialUpdate', 'data', data);
                            localVarPath = "/containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Container with specified id*
         * @summary Retrieve Container
         * @param {number} id A unique integer value identifying this container.
         * @param {boolean} [scan] Scan Action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersRead: function (id, scan, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('containersRead', 'id', id);
                            localVarPath = "/containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (scan !== undefined) {
                                localVarQueryParameter['scan'] = scan;
                            }
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ContainersApiAxiosParamCreator = ContainersApiAxiosParamCreator;
/**
 * ContainersApi - functional programming interface
 * @export
 */
var ContainersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContainersApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Container*
         * @summary Create Container
         * @param {Container} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing containers with all their data.
         * @summary Get container list as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [targetOutboundLoad] Target Outbound Load
         * @param {number} [outboundLoad] Outbound Load
         * @param {number} [targetOrCurrentOutboundLoad] Target or Current OutboundLoad
         * @param {ContainersCsvContainerTypeEnum} [containerType] Container Type
         * @param {boolean} [outbound] Outbound Container
         * @param {boolean} [includeGhostResources] Show Ghost containers
         * @param {boolean} [includeOwnerConfiguration] Expose the container owner configuration
         * @param {boolean} [hidePending] Include only containers with events in from/to range.
         * @param {Array<number>} [manifest] Manifest ID
         * @param {number} [area] Area ID
         * @param {number} [zone] Zone ID
         * @param {number} [loadPoint] Load Point ID
         * @param {number} [module] Module ID
         * @param {number} [station] Station ID
         * @param {ContainersCsvSortByEnum} [sortBy] Sort By
         * @param {Array<ContainersCsvProcessStepEnum>} [processStep] Process Step
         * @param {Array<ContainersCsvExcludeProcessStepEnum>} [excludeProcessStep] Exclude Process Step
         * @param {Array<ContainersCsvContainerStatusEnum>} [containerStatus] Container Status
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {Array<ContainersCsvDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {number} [parentContainer] Parent container ID
         * @param {boolean} [excludeNestedContainers] Exclude nested containers
         * @param {boolean} [excludeParentContainers] Exclude parent containers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCsv: function (fromDate, toDate, page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersCsv(fromDate, toDate, page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Container with specified id*
         * @summary Delete Container
         * @param {number} id A unique integer value identifying this container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Allow to perform container actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {ContainerGeneric} data
         * @param {boolean} [force] Force action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersGeneric: function (data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersGeneric(data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersGeneric']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Container by ID.
         * @summary Get the PNG label for a Container
         * @param {number} id A unique integer value identifying this container.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label for a Container in JSON.
         * @summary Get the ZPL label for a Container
         * @param {number} id A unique integer value identifying this container.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A container is a physical device that is acted on (loaded, moved, unloaded) Can be a package, bag, pallet, Gaylord, CloudSort Container, trailer, etc.  *This endpoint returns a list of Containers*
         * @summary Get Containers
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [targetOutboundLoad] Target Outbound Load
         * @param {number} [outboundLoad] Outbound Load
         * @param {number} [targetOrCurrentOutboundLoad] Target or Current OutboundLoad
         * @param {ContainersListContainerTypeEnum} [containerType] Container Type
         * @param {boolean} [outbound] Outbound Container
         * @param {boolean} [includeGhostResources] Show Ghost containers
         * @param {boolean} [includeOwnerConfiguration] Expose the container owner configuration
         * @param {boolean} [hidePending] Include only containers with events in from/to range.
         * @param {Array<number>} [manifest] Manifest ID
         * @param {number} [area] Area ID
         * @param {number} [zone] Zone ID
         * @param {number} [loadPoint] Load Point ID
         * @param {number} [module] Module ID
         * @param {number} [station] Station ID
         * @param {ContainersListSortByEnum} [sortBy] Sort By
         * @param {Array<ContainersListProcessStepEnum>} [processStep] Process Step
         * @param {Array<ContainersListExcludeProcessStepEnum>} [excludeProcessStep] Exclude Process Step
         * @param {Array<ContainersListContainerStatusEnum>} [containerStatus] Container Status
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {Array<ContainersListDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {number} [parentContainer] Parent container ID
         * @param {boolean} [excludeNestedContainers] Exclude nested containers
         * @param {boolean} [excludeParentContainers] Exclude parent containers
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {number} [inboundLoad] Inbound Load
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersList: function (page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, fromDate, toDate, inboundLoad, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersList(page, pageSize, targetOutboundLoad, outboundLoad, targetOrCurrentOutboundLoad, containerType, outbound, includeGhostResources, includeOwnerConfiguration, hidePending, manifest, area, zone, loadPoint, module, station, sortBy, processStep, excludeProcessStep, containerStatus, owner, carrier, destination, route, defects, parentContainer, excludeNestedContainers, excludeParentContainers, fromDate, toDate, inboundLoad, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Container with specified id*
         * @summary Patch Container
         * @param {number} id A unique integer value identifying this container.
         * @param {ContainerDetails} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersPartialUpdate: function (id, data, force, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersPartialUpdate(id, data, force, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Container with specified id*
         * @summary Retrieve Container
         * @param {number} id A unique integer value identifying this container.
         * @param {boolean} [scan] Scan Action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersRead: function (id, scan, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.containersRead(id, scan, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContainersApi.containersRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContainersApiFp = ContainersApiFp;
/**
 * ContainersApi - factory interface
 * @export
 */
var ContainersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContainersApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Container*
         * @summary Create Container
         * @param {ContainersApiContainersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCreate: function (requestParameters, options) {
            return localVarFp.containersCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single csv file with rows representing containers with all their data.
         * @summary Get container list as CSV
         * @param {ContainersApiContainersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersCsv: function (requestParameters, options) {
            return localVarFp.containersCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.targetOutboundLoad, requestParameters.outboundLoad, requestParameters.targetOrCurrentOutboundLoad, requestParameters.containerType, requestParameters.outbound, requestParameters.includeGhostResources, requestParameters.includeOwnerConfiguration, requestParameters.hidePending, requestParameters.manifest, requestParameters.area, requestParameters.zone, requestParameters.loadPoint, requestParameters.module, requestParameters.station, requestParameters.sortBy, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.containerStatus, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.defects, requestParameters.parentContainer, requestParameters.excludeNestedContainers, requestParameters.excludeParentContainers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Container with specified id*
         * @summary Delete Container
         * @param {ContainersApiContainersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersDelete: function (requestParameters, options) {
            return localVarFp.containersDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Allow to perform container actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {ContainersApiContainersGenericRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersGeneric: function (requestParameters, options) {
            return localVarFp.containersGeneric(requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Container by ID.
         * @summary Get the PNG label for a Container
         * @param {ContainersApiContainersLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelPng: function (requestParameters, options) {
            return localVarFp.containersLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label for a Container in JSON.
         * @summary Get the ZPL label for a Container
         * @param {ContainersApiContainersLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.containersLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A container is a physical device that is acted on (loaded, moved, unloaded) Can be a package, bag, pallet, Gaylord, CloudSort Container, trailer, etc.  *This endpoint returns a list of Containers*
         * @summary Get Containers
         * @param {ContainersApiContainersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.containersList(requestParameters.page, requestParameters.pageSize, requestParameters.targetOutboundLoad, requestParameters.outboundLoad, requestParameters.targetOrCurrentOutboundLoad, requestParameters.containerType, requestParameters.outbound, requestParameters.includeGhostResources, requestParameters.includeOwnerConfiguration, requestParameters.hidePending, requestParameters.manifest, requestParameters.area, requestParameters.zone, requestParameters.loadPoint, requestParameters.module, requestParameters.station, requestParameters.sortBy, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.containerStatus, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.defects, requestParameters.parentContainer, requestParameters.excludeNestedContainers, requestParameters.excludeParentContainers, requestParameters.fromDate, requestParameters.toDate, requestParameters.inboundLoad, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Container with specified id*
         * @summary Patch Container
         * @param {ContainersApiContainersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersPartialUpdate: function (requestParameters, options) {
            return localVarFp.containersPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Container with specified id*
         * @summary Retrieve Container
         * @param {ContainersApiContainersReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containersRead: function (requestParameters, options) {
            return localVarFp.containersRead(requestParameters.id, requestParameters.scan, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContainersApiFactory = ContainersApiFactory;
/**
 * ContainersApi - object-oriented interface
 * @export
 * @class ContainersApi
 * @extends {BaseAPI}
 */
var ContainersApi = /** @class */ (function (_super) {
    __extends(ContainersApi, _super);
    function ContainersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Container*
     * @summary Create Container
     * @param {ContainersApiContainersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single csv file with rows representing containers with all their data.
     * @summary Get container list as CSV
     * @param {ContainersApiContainersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersCsv = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.targetOutboundLoad, requestParameters.outboundLoad, requestParameters.targetOrCurrentOutboundLoad, requestParameters.containerType, requestParameters.outbound, requestParameters.includeGhostResources, requestParameters.includeOwnerConfiguration, requestParameters.hidePending, requestParameters.manifest, requestParameters.area, requestParameters.zone, requestParameters.loadPoint, requestParameters.module, requestParameters.station, requestParameters.sortBy, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.containerStatus, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.defects, requestParameters.parentContainer, requestParameters.excludeNestedContainers, requestParameters.excludeParentContainers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Container with specified id*
     * @summary Delete Container
     * @param {ContainersApiContainersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Allow to perform container actions, independent from their nature with a single PATCH.
     * @summary Generic patch endpoint.
     * @param {ContainersApiContainersGenericRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersGeneric = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersGeneric(requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Container by ID.
     * @summary Get the PNG label for a Container
     * @param {ContainersApiContainersLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label for a Container in JSON.
     * @summary Get the ZPL label for a Container
     * @param {ContainersApiContainersLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A container is a physical device that is acted on (loaded, moved, unloaded) Can be a package, bag, pallet, Gaylord, CloudSort Container, trailer, etc.  *This endpoint returns a list of Containers*
     * @summary Get Containers
     * @param {ContainersApiContainersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ContainersApiFp)(this.configuration).containersList(requestParameters.page, requestParameters.pageSize, requestParameters.targetOutboundLoad, requestParameters.outboundLoad, requestParameters.targetOrCurrentOutboundLoad, requestParameters.containerType, requestParameters.outbound, requestParameters.includeGhostResources, requestParameters.includeOwnerConfiguration, requestParameters.hidePending, requestParameters.manifest, requestParameters.area, requestParameters.zone, requestParameters.loadPoint, requestParameters.module, requestParameters.station, requestParameters.sortBy, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.containerStatus, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.defects, requestParameters.parentContainer, requestParameters.excludeNestedContainers, requestParameters.excludeParentContainers, requestParameters.fromDate, requestParameters.toDate, requestParameters.inboundLoad, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Container with specified id*
     * @summary Patch Container
     * @param {ContainersApiContainersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Container with specified id*
     * @summary Retrieve Container
     * @param {ContainersApiContainersReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    ContainersApi.prototype.containersRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContainersApiFp)(this.configuration).containersRead(requestParameters.id, requestParameters.scan, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContainersApi;
}(base_1.BaseAPI));
exports.ContainersApi = ContainersApi;
/**
 * @export
 */
exports.ContainersCsvContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
/**
 * @export
 */
exports.ContainersCsvSortByEnum = {
    ID: 'id',
    OUTBOUND_LOAD_TIME: 'outbound_load_time',
    CRITICAL_ACTIVITY_TIME: 'critical_activity_time',
    PROCESS_STEP_TIME: 'process_step_time',
    ROUTE_ORDER: 'route_order',
    ID2: '-id',
    OUTBOUND_LOAD_TIME2: '-outbound_load_time',
    CRITICAL_ACTIVITY_TIME2: '-critical_activity_time',
    PROCESS_STEP_TIME2: '-process_step_time',
    ROUTE_ORDER2: '-route_order'
};
/**
 * @export
 */
exports.ContainersCsvProcessStepEnum = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.ContainersCsvExcludeProcessStepEnum = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.ContainersCsvContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
/**
 * @export
 */
exports.ContainersCsvDefectsEnum = {
    MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED'
};
/**
 * @export
 */
exports.ContainersListContainerTypeEnum = {
    BOX: 'BOX',
    BAG: 'BAG',
    GAYLORD: 'GAYLORD',
    PALLET: 'PALLET',
    EH: 'EH'
};
/**
 * @export
 */
exports.ContainersListSortByEnum = {
    ID: 'id',
    OUTBOUND_LOAD_TIME: 'outbound_load_time',
    CRITICAL_ACTIVITY_TIME: 'critical_activity_time',
    PROCESS_STEP_TIME: 'process_step_time',
    ROUTE_ORDER: 'route_order',
    ID2: '-id',
    OUTBOUND_LOAD_TIME2: '-outbound_load_time',
    CRITICAL_ACTIVITY_TIME2: '-critical_activity_time',
    PROCESS_STEP_TIME2: '-process_step_time',
    ROUTE_ORDER2: '-route_order'
};
/**
 * @export
 */
exports.ContainersListProcessStepEnum = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.ContainersListExcludeProcessStepEnum = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.ContainersListContainerStatusEnum = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED'
};
/**
 * @export
 */
exports.ContainersListDefectsEnum = {
    MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED'
};
/**
 * CorporateApi - axios parameter creator
 * @export
 */
var CorporateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Fetch Corporate Master Configuration This endpoint returns the master configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/corporate/config";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the values of Corporate Master Configuration This endpoint updates the values of master configuration
         * @param {CorporateConfig} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigPartialUpdate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('corporateConfigPartialUpdate', 'data', data);
                            localVarPath = "/corporate/config";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Overwrite the Corporate Master Configuration This endpoint overwrites the master configuration
         * @param {CorporateConfig} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigUpdate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('corporateConfigUpdate', 'data', data);
                            localVarPath = "/corporate/config";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * CloudSort Corp. provided configurations of zone modules in various shapes and sizes to be used in CloudSort facilities.  *This endpoint returns a list of Corporate Modules*
         * @summary Get Corporate Modules
         * @param {CorporateModulesListAreaTypeEnum} [areaType] Area Type
         * @param {CorporateModulesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateModulesList: function (areaType, sortBy, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/corporate/modules/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (areaType !== undefined) {
                                localVarQueryParameter['area_type'] = areaType;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of dictionaries. Each dictionary has the following 4 fields: - `permission`: the permission name.The following fields will reference this permission;  - `parents`: permissions that it depends on;  - `children`: permissions that depend on it;  - `group`: group of permissions that the permission can represent. If the permission is active, it will be equivalent to using all of the permissions in this field.
         * @summary Get permissions dependencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsDependenciesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/corporate/permissions/dependencies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of corporate permissions
         * @summary Fetch Corporate Roles and permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/corporate/permissions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates corporate roles and permissions.
         * @summary Update Corporate Roles and permissions
         * @param {PatchCorporateRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsPartialUpdate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('corporatePermissionsPartialUpdate', 'data', data);
                            localVarPath = "/corporate/permissions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CorporateApiAxiosParamCreator = CorporateApiAxiosParamCreator;
/**
 * CorporateApi - functional programming interface
 * @export
 */
var CorporateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CorporateApiAxiosParamCreator)(configuration);
    return {
        /**
         * Fetch Corporate Master Configuration This endpoint returns the master configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigList: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporateConfigList(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporateConfigList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the values of Corporate Master Configuration This endpoint updates the values of master configuration
         * @param {CorporateConfig} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigPartialUpdate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporateConfigPartialUpdate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporateConfigPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Overwrite the Corporate Master Configuration This endpoint overwrites the master configuration
         * @param {CorporateConfig} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigUpdate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporateConfigUpdate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporateConfigUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * CloudSort Corp. provided configurations of zone modules in various shapes and sizes to be used in CloudSort facilities.  *This endpoint returns a list of Corporate Modules*
         * @summary Get Corporate Modules
         * @param {CorporateModulesListAreaTypeEnum} [areaType] Area Type
         * @param {CorporateModulesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateModulesList: function (areaType, sortBy, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporateModulesList(areaType, sortBy, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporateModulesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of dictionaries. Each dictionary has the following 4 fields: - `permission`: the permission name.The following fields will reference this permission;  - `parents`: permissions that it depends on;  - `children`: permissions that depend on it;  - `group`: group of permissions that the permission can represent. If the permission is active, it will be equivalent to using all of the permissions in this field.
         * @summary Get permissions dependencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsDependenciesList: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporatePermissionsDependenciesList(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporatePermissionsDependenciesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of corporate permissions
         * @summary Fetch Corporate Roles and permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsList: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporatePermissionsList(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporatePermissionsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates corporate roles and permissions.
         * @summary Update Corporate Roles and permissions
         * @param {PatchCorporateRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsPartialUpdate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.corporatePermissionsPartialUpdate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CorporateApi.corporatePermissionsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CorporateApiFp = CorporateApiFp;
/**
 * CorporateApi - factory interface
 * @export
 */
var CorporateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CorporateApiFp)(configuration);
    return {
        /**
         * Fetch Corporate Master Configuration This endpoint returns the master configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigList: function (options) {
            return localVarFp.corporateConfigList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the values of Corporate Master Configuration This endpoint updates the values of master configuration
         * @param {CorporateApiCorporateConfigPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigPartialUpdate: function (requestParameters, options) {
            return localVarFp.corporateConfigPartialUpdate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Overwrite the Corporate Master Configuration This endpoint overwrites the master configuration
         * @param {CorporateApiCorporateConfigUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateConfigUpdate: function (requestParameters, options) {
            return localVarFp.corporateConfigUpdate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * CloudSort Corp. provided configurations of zone modules in various shapes and sizes to be used in CloudSort facilities.  *This endpoint returns a list of Corporate Modules*
         * @summary Get Corporate Modules
         * @param {CorporateApiCorporateModulesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateModulesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.corporateModulesList(requestParameters.areaType, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of dictionaries. Each dictionary has the following 4 fields: - `permission`: the permission name.The following fields will reference this permission;  - `parents`: permissions that it depends on;  - `children`: permissions that depend on it;  - `group`: group of permissions that the permission can represent. If the permission is active, it will be equivalent to using all of the permissions in this field.
         * @summary Get permissions dependencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsDependenciesList: function (options) {
            return localVarFp.corporatePermissionsDependenciesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of corporate permissions
         * @summary Fetch Corporate Roles and permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsList: function (options) {
            return localVarFp.corporatePermissionsList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates corporate roles and permissions.
         * @summary Update Corporate Roles and permissions
         * @param {CorporateApiCorporatePermissionsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporatePermissionsPartialUpdate: function (requestParameters, options) {
            return localVarFp.corporatePermissionsPartialUpdate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CorporateApiFactory = CorporateApiFactory;
/**
 * CorporateApi - object-oriented interface
 * @export
 * @class CorporateApi
 * @extends {BaseAPI}
 */
var CorporateApi = /** @class */ (function (_super) {
    __extends(CorporateApi, _super);
    function CorporateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch Corporate Master Configuration This endpoint returns the master configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporateConfigList = function (options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporateConfigList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the values of Corporate Master Configuration This endpoint updates the values of master configuration
     * @param {CorporateApiCorporateConfigPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporateConfigPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporateConfigPartialUpdate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Overwrite the Corporate Master Configuration This endpoint overwrites the master configuration
     * @param {CorporateApiCorporateConfigUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporateConfigUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporateConfigUpdate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * CloudSort Corp. provided configurations of zone modules in various shapes and sizes to be used in CloudSort facilities.  *This endpoint returns a list of Corporate Modules*
     * @summary Get Corporate Modules
     * @param {CorporateApiCorporateModulesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporateModulesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CorporateApiFp)(this.configuration).corporateModulesList(requestParameters.areaType, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of dictionaries. Each dictionary has the following 4 fields: - `permission`: the permission name.The following fields will reference this permission;  - `parents`: permissions that it depends on;  - `children`: permissions that depend on it;  - `group`: group of permissions that the permission can represent. If the permission is active, it will be equivalent to using all of the permissions in this field.
     * @summary Get permissions dependencies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporatePermissionsDependenciesList = function (options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporatePermissionsDependenciesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of corporate permissions
     * @summary Fetch Corporate Roles and permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporatePermissionsList = function (options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporatePermissionsList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates corporate roles and permissions.
     * @summary Update Corporate Roles and permissions
     * @param {CorporateApiCorporatePermissionsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.corporatePermissionsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CorporateApiFp)(this.configuration).corporatePermissionsPartialUpdate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CorporateApi;
}(base_1.BaseAPI));
exports.CorporateApi = CorporateApi;
/**
 * @export
 */
exports.CorporateModulesListAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
/**
 * @export
 */
exports.CorporateModulesListSortByEnum = {
    LOAD_POINT_COUNT: 'load_point_count',
    NAME: 'name',
    LOAD_POINT_COUNT2: '-load_point_count',
    NAME2: '-name'
};
/**
 * CountriesApi - axios parameter creator
 * @export
 */
var CountriesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns the Countries in the System.
         * @summary List Countries
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesList: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/countries/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CountriesApiAxiosParamCreator = CountriesApiAxiosParamCreator;
/**
 * CountriesApi - functional programming interface
 * @export
 */
var CountriesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CountriesApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns the Countries in the System.
         * @summary List Countries
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesList: function (page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countriesList(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CountriesApi.countriesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CountriesApiFp = CountriesApiFp;
/**
 * CountriesApi - factory interface
 * @export
 */
var CountriesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CountriesApiFp)(configuration);
    return {
        /**
         * This endpoint returns the Countries in the System.
         * @summary List Countries
         * @param {CountriesApiCountriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.countriesList(requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CountriesApiFactory = CountriesApiFactory;
/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
var CountriesApi = /** @class */ (function (_super) {
    __extends(CountriesApi, _super);
    function CountriesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns the Countries in the System.
     * @summary List Countries
     * @param {CountriesApiCountriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    CountriesApi.prototype.countriesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CountriesApiFp)(this.configuration).countriesList(requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CountriesApi;
}(base_1.BaseAPI));
exports.CountriesApi = CountriesApi;
/**
 * CustomerConfigsApi - axios parameter creator
 * @export
 */
var CustomerConfigsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Costumer Configuration*
         * @summary Create Costumer Configuration
         * @param {CustomerConfig} data
         * @param {boolean} [force] Force Station attribution for Customer Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsCreate: function (data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('customerConfigsCreate', 'data', data);
                            localVarPath = "/customer_configs/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Costumer Configuration with specified id*
         * @summary Delete Costumer Configuration
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customerConfigsDelete', 'id', id);
                            localVarPath = "/customer_configs/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A Customer Configuration is meant to enable specific configurations per Customer in a certain Station/s or Organization.  *This endpoint returns a list of Costumer Configurations*
         * @summary Get Costumer Configurations
         * @param {Array<number>} [station] Filter the result to the given Station IDs.
         * @param {number} [customer] Filter the result by the given Customer ID.
         * @param {number} [organization]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsList: function (station, customer, organization, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/customer_configs/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station) {
                                localVarQueryParameter['station'] = station.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (organization !== undefined) {
                                localVarQueryParameter['organization'] = organization;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Costumer Configuration with specified id*
         * @summary Patch Costumer Configuration
         * @param {string} id
         * @param {CustomerConfig} data
         * @param {boolean} [force] Force Station attribution for Customer Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsPartialUpdate: function (id, data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customerConfigsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('customerConfigsPartialUpdate', 'data', data);
                            localVarPath = "/customer_configs/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Costumer Configuration with specified id*
         * @summary Retrieve Costumer Configuration
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customerConfigsRead', 'id', id);
                            localVarPath = "/customer_configs/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CustomerConfigsApiAxiosParamCreator = CustomerConfigsApiAxiosParamCreator;
/**
 * CustomerConfigsApi - functional programming interface
 * @export
 */
var CustomerConfigsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerConfigsApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Costumer Configuration*
         * @summary Create Costumer Configuration
         * @param {CustomerConfig} data
         * @param {boolean} [force] Force Station attribution for Customer Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsCreate: function (data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerConfigsCreate(data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerConfigsApi.customerConfigsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Costumer Configuration with specified id*
         * @summary Delete Costumer Configuration
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerConfigsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerConfigsApi.customerConfigsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A Customer Configuration is meant to enable specific configurations per Customer in a certain Station/s or Organization.  *This endpoint returns a list of Costumer Configurations*
         * @summary Get Costumer Configurations
         * @param {Array<number>} [station] Filter the result to the given Station IDs.
         * @param {number} [customer] Filter the result by the given Customer ID.
         * @param {number} [organization]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsList: function (station, customer, organization, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerConfigsList(station, customer, organization, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerConfigsApi.customerConfigsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Costumer Configuration with specified id*
         * @summary Patch Costumer Configuration
         * @param {string} id
         * @param {CustomerConfig} data
         * @param {boolean} [force] Force Station attribution for Customer Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsPartialUpdate: function (id, data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerConfigsPartialUpdate(id, data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerConfigsApi.customerConfigsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Costumer Configuration with specified id*
         * @summary Retrieve Costumer Configuration
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerConfigsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerConfigsApi.customerConfigsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CustomerConfigsApiFp = CustomerConfigsApiFp;
/**
 * CustomerConfigsApi - factory interface
 * @export
 */
var CustomerConfigsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerConfigsApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Costumer Configuration*
         * @summary Create Costumer Configuration
         * @param {CustomerConfigsApiCustomerConfigsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsCreate: function (requestParameters, options) {
            return localVarFp.customerConfigsCreate(requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Costumer Configuration with specified id*
         * @summary Delete Costumer Configuration
         * @param {CustomerConfigsApiCustomerConfigsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsDelete: function (requestParameters, options) {
            return localVarFp.customerConfigsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A Customer Configuration is meant to enable specific configurations per Customer in a certain Station/s or Organization.  *This endpoint returns a list of Costumer Configurations*
         * @summary Get Costumer Configurations
         * @param {CustomerConfigsApiCustomerConfigsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.customerConfigsList(requestParameters.station, requestParameters.customer, requestParameters.organization, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Costumer Configuration with specified id*
         * @summary Patch Costumer Configuration
         * @param {CustomerConfigsApiCustomerConfigsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsPartialUpdate: function (requestParameters, options) {
            return localVarFp.customerConfigsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Costumer Configuration with specified id*
         * @summary Retrieve Costumer Configuration
         * @param {CustomerConfigsApiCustomerConfigsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerConfigsRead: function (requestParameters, options) {
            return localVarFp.customerConfigsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerConfigsApiFactory = CustomerConfigsApiFactory;
/**
 * CustomerConfigsApi - object-oriented interface
 * @export
 * @class CustomerConfigsApi
 * @extends {BaseAPI}
 */
var CustomerConfigsApi = /** @class */ (function (_super) {
    __extends(CustomerConfigsApi, _super);
    function CustomerConfigsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Costumer Configuration*
     * @summary Create Costumer Configuration
     * @param {CustomerConfigsApiCustomerConfigsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerConfigsApi
     */
    CustomerConfigsApi.prototype.customerConfigsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerConfigsApiFp)(this.configuration).customerConfigsCreate(requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Costumer Configuration with specified id*
     * @summary Delete Costumer Configuration
     * @param {CustomerConfigsApiCustomerConfigsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerConfigsApi
     */
    CustomerConfigsApi.prototype.customerConfigsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerConfigsApiFp)(this.configuration).customerConfigsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A Customer Configuration is meant to enable specific configurations per Customer in a certain Station/s or Organization.  *This endpoint returns a list of Costumer Configurations*
     * @summary Get Costumer Configurations
     * @param {CustomerConfigsApiCustomerConfigsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerConfigsApi
     */
    CustomerConfigsApi.prototype.customerConfigsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CustomerConfigsApiFp)(this.configuration).customerConfigsList(requestParameters.station, requestParameters.customer, requestParameters.organization, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Costumer Configuration with specified id*
     * @summary Patch Costumer Configuration
     * @param {CustomerConfigsApiCustomerConfigsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerConfigsApi
     */
    CustomerConfigsApi.prototype.customerConfigsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerConfigsApiFp)(this.configuration).customerConfigsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Costumer Configuration with specified id*
     * @summary Retrieve Costumer Configuration
     * @param {CustomerConfigsApiCustomerConfigsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerConfigsApi
     */
    CustomerConfigsApi.prototype.customerConfigsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerConfigsApiFp)(this.configuration).customerConfigsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerConfigsApi;
}(base_1.BaseAPI));
exports.CustomerConfigsApi = CustomerConfigsApi;
/**
 * CustomersApi - axios parameter creator
 * @export
 */
var CustomersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint allows to create a new Customer in the system and associate it with the given permission data. It is expected that the customer is created in a station, or organization context.
         * @summary Create Customer
         * @param {Customer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('customersCreate', 'data', data);
                            localVarPath = "/customers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint removes the customer from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the customer will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDelete: function (id, stationId, organizationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customersDelete', 'id', id);
                            localVarPath = "/customers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Provides a list of the registered & integrated customers that tender packages and containers to a CloudSort station.
         * @summary List Customer
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersList: function (search, page, pageSize, stationId, organizationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/customers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns customer ID if email exists.
         * @summary Lookup customer by email
         * @param {CustomerLookup} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLookup: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('customersLookup', 'data', data);
                            localVarPath = "/customers/lookup/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to update the customer with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {Customer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customersPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('customersPartialUpdate', 'data', data);
                            localVarPath = "/customers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Customer by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the customer for the respective entity.
         * @summary Retrieve Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRead: function (id, stationId, organizationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('customersRead', 'id', id);
                            localVarPath = "/customers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CustomersApiAxiosParamCreator = CustomersApiAxiosParamCreator;
/**
 * CustomersApi - functional programming interface
 * @export
 */
var CustomersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomersApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint allows to create a new Customer in the system and associate it with the given permission data. It is expected that the customer is created in a station, or organization context.
         * @summary Create Customer
         * @param {Customer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint removes the customer from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the customer will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDelete: function (id, stationId, organizationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersDelete(id, stationId, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Provides a list of the registered & integrated customers that tender packages and containers to a CloudSort station.
         * @summary List Customer
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersList: function (search, page, pageSize, stationId, organizationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersList(search, page, pageSize, stationId, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns customer ID if email exists.
         * @summary Lookup customer by email
         * @param {CustomerLookup} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLookup: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersLookup(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersLookup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to update the customer with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {Customer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Customer by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the customer for the respective entity.
         * @summary Retrieve Customer
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRead: function (id, stationId, organizationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRead(id, stationId, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomersApi.customersRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CustomersApiFp = CustomersApiFp;
/**
 * CustomersApi - factory interface
 * @export
 */
var CustomersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomersApiFp)(configuration);
    return {
        /**
         * This endpoint allows to create a new Customer in the system and associate it with the given permission data. It is expected that the customer is created in a station, or organization context.
         * @summary Create Customer
         * @param {CustomersApiCustomersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCreate: function (requestParameters, options) {
            return localVarFp.customersCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint removes the customer from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the customer will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Customer
         * @param {CustomersApiCustomersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersDelete: function (requestParameters, options) {
            return localVarFp.customersDelete(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Provides a list of the registered & integrated customers that tender packages and containers to a CloudSort station.
         * @summary List Customer
         * @param {CustomersApiCustomersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.customersList(requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns customer ID if email exists.
         * @summary Lookup customer by email
         * @param {CustomersApiCustomersLookupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLookup: function (requestParameters, options) {
            return localVarFp.customersLookup(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows to update the customer with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Customer
         * @param {CustomersApiCustomersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPartialUpdate: function (requestParameters, options) {
            return localVarFp.customersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Customer by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the customer for the respective entity.
         * @summary Retrieve Customer
         * @param {CustomersApiCustomersReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRead: function (requestParameters, options) {
            return localVarFp.customersRead(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomersApiFactory = CustomersApiFactory;
/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
var CustomersApi = /** @class */ (function (_super) {
    __extends(CustomersApi, _super);
    function CustomersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint allows to create a new Customer in the system and associate it with the given permission data. It is expected that the customer is created in a station, or organization context.
     * @summary Create Customer
     * @param {CustomersApiCustomersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomersApiFp)(this.configuration).customersCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint removes the customer from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the customer will be dissassociated from all organizations and stations that the requesting user has access to.
     * @summary Remove Customer
     * @param {CustomersApiCustomersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomersApiFp)(this.configuration).customersDelete(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Provides a list of the registered & integrated customers that tender packages and containers to a CloudSort station.
     * @summary List Customer
     * @param {CustomersApiCustomersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CustomersApiFp)(this.configuration).customersList(requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns customer ID if email exists.
     * @summary Lookup customer by email
     * @param {CustomersApiCustomersLookupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersLookup = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomersApiFp)(this.configuration).customersLookup(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows to update the customer with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
     * @summary Update Customer
     * @param {CustomersApiCustomersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomersApiFp)(this.configuration).customersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Customer by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the customer for the respective entity.
     * @summary Retrieve Customer
     * @param {CustomersApiCustomersReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    CustomersApi.prototype.customersRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomersApiFp)(this.configuration).customersRead(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomersApi;
}(base_1.BaseAPI));
exports.CustomersApi = CustomersApi;
/**
 * DataAnalyticsApi - axios parameter creator
 * @export
 */
var DataAnalyticsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a dict with package counts, i.e. number of packages that have events with those events types in the period from date_time - duration to date_time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {number} [duration] Duration of period for counting package flow in minutes.If not provided, defaults to 6.
         * @param {Array<DataAnalyticsPackageCountsForEventTypesListEventTypesEnum>} [eventTypes] Event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsForEventTypesList: function (stationId, dateTime, duration, eventTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stationId' is not null or undefined
                            (0, common_1.assertParamExists)('dataAnalyticsPackageCountsForEventTypesList', 'stationId', stationId);
                            localVarPath = "/data-analytics/package-counts-for-event-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dateTime !== undefined) {
                                localVarQueryParameter['date_time'] = (dateTime instanceof Date) ?
                                    dateTime.toISOString() :
                                    dateTime;
                            }
                            if (duration !== undefined) {
                                localVarQueryParameter['duration'] = duration;
                            }
                            if (eventTypes) {
                                localVarQueryParameter['event_types'] = eventTypes.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a dict with package count, accumulated count and percentage  for station specified by station_id for given date and time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {Array<DataAnalyticsPackageCountsListCutOffEventTypesEnum>} [cutOffEventTypes] Event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsList: function (stationId, dateTime, cutOffEventTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stationId' is not null or undefined
                            (0, common_1.assertParamExists)('dataAnalyticsPackageCountsList', 'stationId', stationId);
                            localVarPath = "/data-analytics/package-counts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dateTime !== undefined) {
                                localVarQueryParameter['date_time'] = (dateTime instanceof Date) ?
                                    dateTime.toISOString() :
                                    dateTime;
                            }
                            if (cutOffEventTypes) {
                                localVarQueryParameter['cut_off_event_types'] = cutOffEventTypes.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a dict with package flow, i.e. number of packages transferred from one location to another in the period from date_time - duration to date_time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {number} [duration] Duration of period for counting package flow in minutes.If not provided, defaults to 6.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageFlowList: function (stationId, dateTime, duration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stationId' is not null or undefined
                            (0, common_1.assertParamExists)('dataAnalyticsPackageFlowList', 'stationId', stationId);
                            localVarPath = "/data-analytics/package-flow";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dateTime !== undefined) {
                                localVarQueryParameter['date_time'] = (dateTime instanceof Date) ?
                                    dateTime.toISOString() :
                                    dateTime;
                            }
                            if (duration !== undefined) {
                                localVarQueryParameter['duration'] = duration;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a earliest time for dispatch an outboundload at staging area and loadpoints at secondary area. It also for each dockdoor returns the load time for the earliest outboundload that\'s going to be dispatch.
         * @summary Get a Report on the Dispatch Time
         * @param {number} station Scope: Station
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsStationLiveViewDispatchTimeList: function (station, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'station' is not null or undefined
                            (0, common_1.assertParamExists)('dataAnalyticsStationLiveViewDispatchTimeList', 'station', station);
                            localVarPath = "/data-analytics/station-live-view-dispatch-time";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DataAnalyticsApiAxiosParamCreator = DataAnalyticsApiAxiosParamCreator;
/**
 * DataAnalyticsApi - functional programming interface
 * @export
 */
var DataAnalyticsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DataAnalyticsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a dict with package counts, i.e. number of packages that have events with those events types in the period from date_time - duration to date_time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {number} [duration] Duration of period for counting package flow in minutes.If not provided, defaults to 6.
         * @param {Array<DataAnalyticsPackageCountsForEventTypesListEventTypesEnum>} [eventTypes] Event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsForEventTypesList: function (stationId, dateTime, duration, eventTypes, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataAnalyticsPackageCountsForEventTypesList(stationId, dateTime, duration, eventTypes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DataAnalyticsApi.dataAnalyticsPackageCountsForEventTypesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a dict with package count, accumulated count and percentage  for station specified by station_id for given date and time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {Array<DataAnalyticsPackageCountsListCutOffEventTypesEnum>} [cutOffEventTypes] Event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsList: function (stationId, dateTime, cutOffEventTypes, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataAnalyticsPackageCountsList(stationId, dateTime, cutOffEventTypes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DataAnalyticsApi.dataAnalyticsPackageCountsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a dict with package flow, i.e. number of packages transferred from one location to another in the period from date_time - duration to date_time
         * @param {number} stationId Station Id
         * @param {string} [dateTime] Date and time. If not provided, defaults to now.
         * @param {number} [duration] Duration of period for counting package flow in minutes.If not provided, defaults to 6.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageFlowList: function (stationId, dateTime, duration, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataAnalyticsPackageFlowList(stationId, dateTime, duration, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DataAnalyticsApi.dataAnalyticsPackageFlowList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a earliest time for dispatch an outboundload at staging area and loadpoints at secondary area. It also for each dockdoor returns the load time for the earliest outboundload that\'s going to be dispatch.
         * @summary Get a Report on the Dispatch Time
         * @param {number} station Scope: Station
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsStationLiveViewDispatchTimeList: function (station, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dataAnalyticsStationLiveViewDispatchTimeList(station, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DataAnalyticsApi.dataAnalyticsStationLiveViewDispatchTimeList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DataAnalyticsApiFp = DataAnalyticsApiFp;
/**
 * DataAnalyticsApi - factory interface
 * @export
 */
var DataAnalyticsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DataAnalyticsApiFp)(configuration);
    return {
        /**
         * Returns a dict with package counts, i.e. number of packages that have events with those events types in the period from date_time - duration to date_time
         * @param {DataAnalyticsApiDataAnalyticsPackageCountsForEventTypesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsForEventTypesList: function (requestParameters, options) {
            return localVarFp.dataAnalyticsPackageCountsForEventTypesList(requestParameters.stationId, requestParameters.dateTime, requestParameters.duration, requestParameters.eventTypes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a dict with package count, accumulated count and percentage  for station specified by station_id for given date and time
         * @param {DataAnalyticsApiDataAnalyticsPackageCountsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageCountsList: function (requestParameters, options) {
            return localVarFp.dataAnalyticsPackageCountsList(requestParameters.stationId, requestParameters.dateTime, requestParameters.cutOffEventTypes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a dict with package flow, i.e. number of packages transferred from one location to another in the period from date_time - duration to date_time
         * @param {DataAnalyticsApiDataAnalyticsPackageFlowListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsPackageFlowList: function (requestParameters, options) {
            return localVarFp.dataAnalyticsPackageFlowList(requestParameters.stationId, requestParameters.dateTime, requestParameters.duration, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a earliest time for dispatch an outboundload at staging area and loadpoints at secondary area. It also for each dockdoor returns the load time for the earliest outboundload that\'s going to be dispatch.
         * @summary Get a Report on the Dispatch Time
         * @param {DataAnalyticsApiDataAnalyticsStationLiveViewDispatchTimeListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataAnalyticsStationLiveViewDispatchTimeList: function (requestParameters, options) {
            return localVarFp.dataAnalyticsStationLiveViewDispatchTimeList(requestParameters.station, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DataAnalyticsApiFactory = DataAnalyticsApiFactory;
/**
 * DataAnalyticsApi - object-oriented interface
 * @export
 * @class DataAnalyticsApi
 * @extends {BaseAPI}
 */
var DataAnalyticsApi = /** @class */ (function (_super) {
    __extends(DataAnalyticsApi, _super);
    function DataAnalyticsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a dict with package counts, i.e. number of packages that have events with those events types in the period from date_time - duration to date_time
     * @param {DataAnalyticsApiDataAnalyticsPackageCountsForEventTypesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyticsApi
     */
    DataAnalyticsApi.prototype.dataAnalyticsPackageCountsForEventTypesList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DataAnalyticsApiFp)(this.configuration).dataAnalyticsPackageCountsForEventTypesList(requestParameters.stationId, requestParameters.dateTime, requestParameters.duration, requestParameters.eventTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a dict with package count, accumulated count and percentage  for station specified by station_id for given date and time
     * @param {DataAnalyticsApiDataAnalyticsPackageCountsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyticsApi
     */
    DataAnalyticsApi.prototype.dataAnalyticsPackageCountsList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DataAnalyticsApiFp)(this.configuration).dataAnalyticsPackageCountsList(requestParameters.stationId, requestParameters.dateTime, requestParameters.cutOffEventTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a dict with package flow, i.e. number of packages transferred from one location to another in the period from date_time - duration to date_time
     * @param {DataAnalyticsApiDataAnalyticsPackageFlowListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyticsApi
     */
    DataAnalyticsApi.prototype.dataAnalyticsPackageFlowList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DataAnalyticsApiFp)(this.configuration).dataAnalyticsPackageFlowList(requestParameters.stationId, requestParameters.dateTime, requestParameters.duration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a earliest time for dispatch an outboundload at staging area and loadpoints at secondary area. It also for each dockdoor returns the load time for the earliest outboundload that\'s going to be dispatch.
     * @summary Get a Report on the Dispatch Time
     * @param {DataAnalyticsApiDataAnalyticsStationLiveViewDispatchTimeListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataAnalyticsApi
     */
    DataAnalyticsApi.prototype.dataAnalyticsStationLiveViewDispatchTimeList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DataAnalyticsApiFp)(this.configuration).dataAnalyticsStationLiveViewDispatchTimeList(requestParameters.station, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataAnalyticsApi;
}(base_1.BaseAPI));
exports.DataAnalyticsApi = DataAnalyticsApi;
/**
 * @export
 */
exports.DataAnalyticsPackageCountsForEventTypesListEventTypesEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * @export
 */
exports.DataAnalyticsPackageCountsListCutOffEventTypesEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Device*
         * @summary Create Device
         * @param {Device} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('devicesCreate', 'data', data);
                            localVarPath = "/devices/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Device by ID*
         * @summary Delete Device
         * @param {number} id A unique integer value identifying this device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('devicesDelete', 'id', id);
                            localVarPath = "/devices/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} station Station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesEnrollmenttoken: function (station, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'station' is not null or undefined
                            (0, common_1.assertParamExists)('devicesEnrollmenttoken', 'station', station);
                            localVarPath = "/devices/enrollmenttoken/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Devices are Operator tools assigned to Staff TODO  *This endpoint returns a list of Devices*
         * @summary Get Devices
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [deviceId] device external ID
         * @param {number} [stationId] Station ID
         * @param {DevicesListVersionStatusEnum} [versionStatus] Version status of the device software
         * @param {DevicesListSortByEnum} [sortBy] Sort By
         * @param {boolean} [excludeNullVersion] Exclude devices with a null App Version
         * @param {boolean} [deviceDetails] Include device details data in response (ADM)
         * @param {string} [fromDate] DEPRECATED: From Date
         * @param {string} [toDate] DEPRECATED: To Date
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60;, &#x60;area&#x60;,&#x60;area_name&#x60;, &#x60;last_event&#x60;, &#x60;device_info&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesList: function (page, pageSize, deviceId, stationId, versionStatus, sortBy, excludeNullVersion, deviceDetails, fromDate, toDate, extendData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/devices/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (deviceId !== undefined) {
                                localVarQueryParameter['device_id'] = deviceId;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (versionStatus !== undefined) {
                                localVarQueryParameter['version_status'] = versionStatus;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (excludeNullVersion !== undefined) {
                                localVarQueryParameter['exclude_null_version'] = excludeNullVersion;
                            }
                            if (deviceDetails !== undefined) {
                                localVarQueryParameter['device_details'] = deviceDetails;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (extendData !== undefined) {
                                localVarQueryParameter['extend_data'] = extendData;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Device by ID*
         * @summary Patch Device
         * @param {number} id A unique integer value identifying this device.
         * @param {DeviceDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('devicesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('devicesPartialUpdate', 'data', data);
                            localVarPath = "/devices/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Device by ID*
         * @summary Retrieve Device
         * @param {number} id A unique integer value identifying this device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('devicesRead', 'id', id);
                            localVarPath = "/devices/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Device*
         * @summary Create Device
         * @param {Device} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Device by ID*
         * @summary Delete Device
         * @param {number} id A unique integer value identifying this device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} station Station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesEnrollmenttoken: function (station, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesEnrollmenttoken(station, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesEnrollmenttoken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Devices are Operator tools assigned to Staff TODO  *This endpoint returns a list of Devices*
         * @summary Get Devices
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [deviceId] device external ID
         * @param {number} [stationId] Station ID
         * @param {DevicesListVersionStatusEnum} [versionStatus] Version status of the device software
         * @param {DevicesListSortByEnum} [sortBy] Sort By
         * @param {boolean} [excludeNullVersion] Exclude devices with a null App Version
         * @param {boolean} [deviceDetails] Include device details data in response (ADM)
         * @param {string} [fromDate] DEPRECATED: From Date
         * @param {string} [toDate] DEPRECATED: To Date
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60;, &#x60;area&#x60;,&#x60;area_name&#x60;, &#x60;last_event&#x60;, &#x60;device_info&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesList: function (page, pageSize, deviceId, stationId, versionStatus, sortBy, excludeNullVersion, deviceDetails, fromDate, toDate, extendData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesList(page, pageSize, deviceId, stationId, versionStatus, sortBy, excludeNullVersion, deviceDetails, fromDate, toDate, extendData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Device by ID*
         * @summary Patch Device
         * @param {number} id A unique integer value identifying this device.
         * @param {DeviceDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Device by ID*
         * @summary Retrieve Device
         * @param {number} id A unique integer value identifying this device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Device*
         * @summary Create Device
         * @param {DevicesApiDevicesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesCreate: function (requestParameters, options) {
            return localVarFp.devicesCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Device by ID*
         * @summary Delete Device
         * @param {DevicesApiDevicesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDelete: function (requestParameters, options) {
            return localVarFp.devicesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DevicesApiDevicesEnrollmenttokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesEnrollmenttoken: function (requestParameters, options) {
            return localVarFp.devicesEnrollmenttoken(requestParameters.station, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Devices are Operator tools assigned to Staff TODO  *This endpoint returns a list of Devices*
         * @summary Get Devices
         * @param {DevicesApiDevicesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.devicesList(requestParameters.page, requestParameters.pageSize, requestParameters.deviceId, requestParameters.stationId, requestParameters.versionStatus, requestParameters.sortBy, requestParameters.excludeNullVersion, requestParameters.deviceDetails, requestParameters.fromDate, requestParameters.toDate, requestParameters.extendData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Device by ID*
         * @summary Patch Device
         * @param {DevicesApiDevicesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPartialUpdate: function (requestParameters, options) {
            return localVarFp.devicesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Device by ID*
         * @summary Retrieve Device
         * @param {DevicesApiDevicesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesRead: function (requestParameters, options) {
            return localVarFp.devicesRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Device*
     * @summary Create Device
     * @param {DevicesApiDevicesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Device by ID*
     * @summary Delete Device
     * @param {DevicesApiDevicesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DevicesApiDevicesEnrollmenttokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesEnrollmenttoken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesEnrollmenttoken(requestParameters.station, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Devices are Operator tools assigned to Staff TODO  *This endpoint returns a list of Devices*
     * @summary Get Devices
     * @param {DevicesApiDevicesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DevicesApiFp)(this.configuration).devicesList(requestParameters.page, requestParameters.pageSize, requestParameters.deviceId, requestParameters.stationId, requestParameters.versionStatus, requestParameters.sortBy, requestParameters.excludeNullVersion, requestParameters.deviceDetails, requestParameters.fromDate, requestParameters.toDate, requestParameters.extendData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Device by ID*
     * @summary Patch Device
     * @param {DevicesApiDevicesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Device by ID*
     * @summary Retrieve Device
     * @param {DevicesApiDevicesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * @export
 */
exports.DevicesListVersionStatusEnum = {
    LIVE: 'LIVE',
    OUTDATED: 'OUTDATED',
    DEPRECATED: 'DEPRECATED'
};
/**
 * @export
 */
exports.DevicesListSortByEnum = {
    ID: 'id',
    VERSION: 'version',
    ID2: '-id',
    VERSION2: '-version'
};
/**
 * DockdoorsApi - axios parameter creator
 * @export
 */
var DockdoorsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns the Dock Door using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Dock Door by query
         * @param {number} [id] Dock Door ID
         * @param {string} [name] Dock Door Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsByquery: function (id, name, station, stationName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/dockdoors/byquery/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (stationName !== undefined) {
                                localVarQueryParameter['station_name'] = stationName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Dock Door*
         * @summary Create Dock Door
         * @param {DockDoor} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsCreate', 'data', data);
                            localVarPath = "/dockdoors/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Dock Door by ID*
         * @summary Delete Dock Door
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsDelete', 'id', id);
                            localVarPath = "/dockdoors/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Dock Door, which is contains a human-readable name of the dock door and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Dock Door
         * @param {number} id
         * @param {DockdoorsLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabel: function (id, dataFormat, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsLabel', 'id', id);
                            localVarPath = "/dockdoors/{id}/label/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dataFormat !== undefined) {
                                localVarQueryParameter['data_format'] = dataFormat;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Dock Door by ID.
         * @summary Get the PNG label for a Dock Door
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsLabelLabelPng', 'id', id);
                            localVarPath = "/dockdoors/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Dock Door by ID.
         * @summary Get the ZPL label for a Dock Door
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsLabelLabelZpl', 'id', id);
                            localVarPath = "/dockdoors/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Dock Doors are an Activity Area in the Station where containers and packages are received from transportation assets (e.g. inbound trucks), as well as dispatched via other transportation assets (e.g. outbound trucks). The Dock Doors form the physical border between Station and transportation asset.  *This endpoint returns a list of Dock Doors*
         * @summary Get Dock Doors
         * @param {number} [station] Station ID
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsList: function (station, search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/dockdoors/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Dock Door by ID*
         * @summary Patch Dock Door
         * @param {number} id
         * @param {DockDoorDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsPartialUpdate', 'data', data);
                            localVarPath = "/dockdoors/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Dock Door by ID*
         * @summary Retrieve Dock Door
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('dockdoorsRead', 'id', id);
                            localVarPath = "/dockdoors/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DockdoorsApiAxiosParamCreator = DockdoorsApiAxiosParamCreator;
/**
 * DockdoorsApi - functional programming interface
 * @export
 */
var DockdoorsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DockdoorsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns the Dock Door using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Dock Door by query
         * @param {number} [id] Dock Door ID
         * @param {string} [name] Dock Door Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsByquery: function (id, name, station, stationName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsByquery(id, name, station, stationName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsByquery']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Dock Door*
         * @summary Create Dock Door
         * @param {DockDoor} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Dock Door by ID*
         * @summary Delete Dock Door
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Dock Door, which is contains a human-readable name of the dock door and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Dock Door
         * @param {number} id
         * @param {DockdoorsLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabel: function (id, dataFormat, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsLabel(id, dataFormat, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsLabel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Dock Door by ID.
         * @summary Get the PNG label for a Dock Door
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Dock Door by ID.
         * @summary Get the ZPL label for a Dock Door
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Dock Doors are an Activity Area in the Station where containers and packages are received from transportation assets (e.g. inbound trucks), as well as dispatched via other transportation assets (e.g. outbound trucks). The Dock Doors form the physical border between Station and transportation asset.  *This endpoint returns a list of Dock Doors*
         * @summary Get Dock Doors
         * @param {number} [station] Station ID
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsList: function (station, search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsList(station, search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Dock Door by ID*
         * @summary Patch Dock Door
         * @param {number} id
         * @param {DockDoorDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Dock Door by ID*
         * @summary Retrieve Dock Door
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dockdoorsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DockdoorsApi.dockdoorsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DockdoorsApiFp = DockdoorsApiFp;
/**
 * DockdoorsApi - factory interface
 * @export
 */
var DockdoorsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DockdoorsApiFp)(configuration);
    return {
        /**
         * This endpoint returns the Dock Door using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Dock Door by query
         * @param {DockdoorsApiDockdoorsByqueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsByquery: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.dockdoorsByquery(requestParameters.id, requestParameters.name, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Dock Door*
         * @summary Create Dock Door
         * @param {DockdoorsApiDockdoorsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsCreate: function (requestParameters, options) {
            return localVarFp.dockdoorsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Dock Door by ID*
         * @summary Delete Dock Door
         * @param {DockdoorsApiDockdoorsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsDelete: function (requestParameters, options) {
            return localVarFp.dockdoorsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the printable label for a Dock Door, which is contains a human-readable name of the dock door and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Dock Door
         * @param {DockdoorsApiDockdoorsLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabel: function (requestParameters, options) {
            return localVarFp.dockdoorsLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Dock Door by ID.
         * @summary Get the PNG label for a Dock Door
         * @param {DockdoorsApiDockdoorsLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelPng: function (requestParameters, options) {
            return localVarFp.dockdoorsLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Dock Door by ID.
         * @summary Get the ZPL label for a Dock Door
         * @param {DockdoorsApiDockdoorsLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.dockdoorsLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Dock Doors are an Activity Area in the Station where containers and packages are received from transportation assets (e.g. inbound trucks), as well as dispatched via other transportation assets (e.g. outbound trucks). The Dock Doors form the physical border between Station and transportation asset.  *This endpoint returns a list of Dock Doors*
         * @summary Get Dock Doors
         * @param {DockdoorsApiDockdoorsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.dockdoorsList(requestParameters.station, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Dock Door by ID*
         * @summary Patch Dock Door
         * @param {DockdoorsApiDockdoorsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsPartialUpdate: function (requestParameters, options) {
            return localVarFp.dockdoorsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Dock Door by ID*
         * @summary Retrieve Dock Door
         * @param {DockdoorsApiDockdoorsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockdoorsRead: function (requestParameters, options) {
            return localVarFp.dockdoorsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DockdoorsApiFactory = DockdoorsApiFactory;
/**
 * DockdoorsApi - object-oriented interface
 * @export
 * @class DockdoorsApi
 * @extends {BaseAPI}
 */
var DockdoorsApi = /** @class */ (function (_super) {
    __extends(DockdoorsApi, _super);
    function DockdoorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns the Dock Door using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
     * @summary Get a Dock Door by query
     * @param {DockdoorsApiDockdoorsByqueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsByquery = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsByquery(requestParameters.id, requestParameters.name, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Dock Door*
     * @summary Create Dock Door
     * @param {DockdoorsApiDockdoorsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Dock Door by ID*
     * @summary Delete Dock Door
     * @param {DockdoorsApiDockdoorsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the printable label for a Dock Door, which is contains a human-readable name of the dock door and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
     * @summary DEPRECATED Get the label for a Dock Door
     * @param {DockdoorsApiDockdoorsLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsLabel = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Dock Door by ID.
     * @summary Get the PNG label for a Dock Door
     * @param {DockdoorsApiDockdoorsLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label as JSON for a Dock Door by ID.
     * @summary Get the ZPL label for a Dock Door
     * @param {DockdoorsApiDockdoorsLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Dock Doors are an Activity Area in the Station where containers and packages are received from transportation assets (e.g. inbound trucks), as well as dispatched via other transportation assets (e.g. outbound trucks). The Dock Doors form the physical border between Station and transportation asset.  *This endpoint returns a list of Dock Doors*
     * @summary Get Dock Doors
     * @param {DockdoorsApiDockdoorsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsList(requestParameters.station, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Dock Door by ID*
     * @summary Patch Dock Door
     * @param {DockdoorsApiDockdoorsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Dock Door by ID*
     * @summary Retrieve Dock Door
     * @param {DockdoorsApiDockdoorsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockdoorsApi
     */
    DockdoorsApi.prototype.dockdoorsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DockdoorsApiFp)(this.configuration).dockdoorsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DockdoorsApi;
}(base_1.BaseAPI));
exports.DockdoorsApi = DockdoorsApi;
/**
 * @export
 */
exports.DockdoorsLabelDataFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
/**
 * EventsApi - axios parameter creator
 * @export
 */
var EventsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Event if event type allowed*
         * @summary Create Event
         * @param {Event} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('eventsCreate', 'data', data);
                            localVarPath = "/events/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Events are used to trace transactions or determine states and ownership.  *This endpoint returns a list of Events*
         * @summary Get Events
         * @param {number} [user] User ID
         * @param {EventsListResourceTypeEnum} [resourceType] Event Resource Type
         * @param {number} [container] Container ID
         * @param {number} [device] Device ID
         * @param {number} [_package] Package ID
         * @param {number} [zone] Zone ID
         * @param {number} [area] Area ID
         * @param {number} [station] Station ID
         * @param {number} [outboundLoad] OutboundLoad ID
         * @param {number} [inboundLoad] InboundLoad ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {EventsListSortByEnum} [sortBy] Sort By
         * @param {EventsListEventTypeEnum} [eventType] Event Type
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsList: function (user, resourceType, container, device, _package, zone, area, station, outboundLoad, inboundLoad, fromDate, toDate, sortBy, eventType, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/events/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (user !== undefined) {
                                localVarQueryParameter['user'] = user;
                            }
                            if (resourceType !== undefined) {
                                localVarQueryParameter['resource_type'] = resourceType;
                            }
                            if (container !== undefined) {
                                localVarQueryParameter['container'] = container;
                            }
                            if (device !== undefined) {
                                localVarQueryParameter['device'] = device;
                            }
                            if (_package !== undefined) {
                                localVarQueryParameter['package'] = _package;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (outboundLoad !== undefined) {
                                localVarQueryParameter['outbound_load'] = outboundLoad;
                            }
                            if (inboundLoad !== undefined) {
                                localVarQueryParameter['inbound_load'] = inboundLoad;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (eventType !== undefined) {
                                localVarQueryParameter['event_type'] = eventType;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Event by ID*
         * @summary Retrieve Event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('eventsRead', 'id', id);
                            localVarPath = "/events/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EventsApiAxiosParamCreator = EventsApiAxiosParamCreator;
/**
 * EventsApi - functional programming interface
 * @export
 */
var EventsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EventsApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Event if event type allowed*
         * @summary Create Event
         * @param {Event} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.eventsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EventsApi.eventsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Events are used to trace transactions or determine states and ownership.  *This endpoint returns a list of Events*
         * @summary Get Events
         * @param {number} [user] User ID
         * @param {EventsListResourceTypeEnum} [resourceType] Event Resource Type
         * @param {number} [container] Container ID
         * @param {number} [device] Device ID
         * @param {number} [_package] Package ID
         * @param {number} [zone] Zone ID
         * @param {number} [area] Area ID
         * @param {number} [station] Station ID
         * @param {number} [outboundLoad] OutboundLoad ID
         * @param {number} [inboundLoad] InboundLoad ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {EventsListSortByEnum} [sortBy] Sort By
         * @param {EventsListEventTypeEnum} [eventType] Event Type
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsList: function (user, resourceType, container, device, _package, zone, area, station, outboundLoad, inboundLoad, fromDate, toDate, sortBy, eventType, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.eventsList(user, resourceType, container, device, _package, zone, area, station, outboundLoad, inboundLoad, fromDate, toDate, sortBy, eventType, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EventsApi.eventsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Event by ID*
         * @summary Retrieve Event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.eventsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EventsApi.eventsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EventsApiFp = EventsApiFp;
/**
 * EventsApi - factory interface
 * @export
 */
var EventsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EventsApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Event if event type allowed*
         * @summary Create Event
         * @param {EventsApiEventsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsCreate: function (requestParameters, options) {
            return localVarFp.eventsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Events are used to trace transactions or determine states and ownership.  *This endpoint returns a list of Events*
         * @summary Get Events
         * @param {EventsApiEventsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.eventsList(requestParameters.user, requestParameters.resourceType, requestParameters.container, requestParameters.device, requestParameters._package, requestParameters.zone, requestParameters.area, requestParameters.station, requestParameters.outboundLoad, requestParameters.inboundLoad, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.eventType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Event by ID*
         * @summary Retrieve Event
         * @param {EventsApiEventsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsRead: function (requestParameters, options) {
            return localVarFp.eventsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EventsApiFactory = EventsApiFactory;
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
var EventsApi = /** @class */ (function (_super) {
    __extends(EventsApi, _super);
    function EventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Event if event type allowed*
     * @summary Create Event
     * @param {EventsApiEventsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.eventsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EventsApiFp)(this.configuration).eventsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Events are used to trace transactions or determine states and ownership.  *This endpoint returns a list of Events*
     * @summary Get Events
     * @param {EventsApiEventsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.eventsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EventsApiFp)(this.configuration).eventsList(requestParameters.user, requestParameters.resourceType, requestParameters.container, requestParameters.device, requestParameters._package, requestParameters.zone, requestParameters.area, requestParameters.station, requestParameters.outboundLoad, requestParameters.inboundLoad, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.eventType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Event by ID*
     * @summary Retrieve Event
     * @param {EventsApiEventsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.eventsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EventsApiFp)(this.configuration).eventsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EventsApi;
}(base_1.BaseAPI));
exports.EventsApi = EventsApi;
/**
 * @export
 */
exports.EventsListResourceTypeEnum = {
    ALL: 'ALL',
    PACKAGES: 'PACKAGES',
    CONTAINERS: 'CONTAINERS',
    OUTBOUNDLOADS: 'OUTBOUNDLOADS',
    INBOUNDLOADS: 'INBOUNDLOADS'
};
/**
 * @export
 */
exports.EventsListSortByEnum = {
    TIMESTAMP: 'timestamp',
    AREA__NAME: 'area__name',
    TIMESTAMP2: '-timestamp',
    AREA__NAME2: '-area__name'
};
/**
 * @export
 */
exports.EventsListEventTypeEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * FmcsApi - axios parameter creator
 * @export
 */
var FmcsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Provides a list of the registered & integrated Carriers that CloudSort tenders sorted packages and containers to.
         * @summary List Carriers
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {boolean} [canUseRelabelMode] If True returns the carriers authorized to use the OT relabel mode (\&#39;USPS\&#39;, \&#39;FDC\&#39;). If False, returns all of the carriers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmcsList: function (search, page, pageSize, canUseRelabelMode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/fmcs/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (canUseRelabelMode !== undefined) {
                                localVarQueryParameter['can_use_relabel_mode'] = canUseRelabelMode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FmcsApiAxiosParamCreator = FmcsApiAxiosParamCreator;
/**
 * FmcsApi - functional programming interface
 * @export
 */
var FmcsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FmcsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Provides a list of the registered & integrated Carriers that CloudSort tenders sorted packages and containers to.
         * @summary List Carriers
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {boolean} [canUseRelabelMode] If True returns the carriers authorized to use the OT relabel mode (\&#39;USPS\&#39;, \&#39;FDC\&#39;). If False, returns all of the carriers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmcsList: function (search, page, pageSize, canUseRelabelMode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fmcsList(search, page, pageSize, canUseRelabelMode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FmcsApi.fmcsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FmcsApiFp = FmcsApiFp;
/**
 * FmcsApi - factory interface
 * @export
 */
var FmcsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FmcsApiFp)(configuration);
    return {
        /**
         * Provides a list of the registered & integrated Carriers that CloudSort tenders sorted packages and containers to.
         * @summary List Carriers
         * @param {FmcsApiFmcsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fmcsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.fmcsList(requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.canUseRelabelMode, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FmcsApiFactory = FmcsApiFactory;
/**
 * FmcsApi - object-oriented interface
 * @export
 * @class FmcsApi
 * @extends {BaseAPI}
 */
var FmcsApi = /** @class */ (function (_super) {
    __extends(FmcsApi, _super);
    function FmcsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Provides a list of the registered & integrated Carriers that CloudSort tenders sorted packages and containers to.
     * @summary List Carriers
     * @param {FmcsApiFmcsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsApi
     */
    FmcsApi.prototype.fmcsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FmcsApiFp)(this.configuration).fmcsList(requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.canUseRelabelMode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FmcsApi;
}(base_1.BaseAPI));
exports.FmcsApi = FmcsApi;
/**
 * InboundloadsApi - axios parameter creator
 * @export
 */
var InboundloadsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint will create a new Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Create Inbound Load
         * @param {InboundLoad} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsCreate', 'data', data);
                            localVarPath = "/inboundloads/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint deletes an Inbound Load. In order to make the request, the user needs to have the following permissions:  * `INBOUNDLOAD_WRITE`.
         * @summary Delete Inbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsDelete', 'id', id);
                            localVarPath = "/inboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Inbound Loads. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Get Inbound Loads
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {InboundloadsListInboundLoadStatusEnum} [inboundLoadStatus] Inbound Load Status
         * @param {number} [dockdoor] DockDoor ID
         * @param {number} [station] Target Station ID
         * @param {Array<number>} [owner] Filter by the owner of the InboundLoads or any objects that are inside and are owned by this user
         * @param {number} [manifest] Filter by the Manifest ID associated to the InboundLoad
         * @param {string} [bol] Filter by the BOL associated to the InboundLoad
         * @param {InboundloadsListSortByEnum} [sortBy] Sort By
         * @param {boolean} [hidePending] Include only loads with events in from/to range.
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {string} [loadName] Filter by load name, if matches any part of the string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsList: function (page, pageSize, inboundLoadStatus, dockdoor, station, owner, manifest, bol, sortBy, hidePending, fromDate, toDate, loadName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/inboundloads/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (inboundLoadStatus !== undefined) {
                                localVarQueryParameter['inbound_load_status'] = inboundLoadStatus;
                            }
                            if (dockdoor !== undefined) {
                                localVarQueryParameter['dockdoor'] = dockdoor;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (manifest !== undefined) {
                                localVarQueryParameter['manifest'] = manifest;
                            }
                            if (bol !== undefined) {
                                localVarQueryParameter['bol'] = bol;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (loadName !== undefined) {
                                localVarQueryParameter['load_name'] = loadName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add a container to the inbound load.  The container can be identified by its tracking number or by its barcode data (`hex`).  If the container is not found in the system, it will be created. If the container is already in the system, it will be added to the inbound load.
         * @summary Add a container to the inbound load. If the container is not found in the system, it will be created and added to the inbound load.
         * @param {AddContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsOperationsAddContainerCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsOperationsAddContainerCreate', 'data', data);
                            localVarPath = "/inboundloads/operations/add_container";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Update Inbound Load
         * @param {number} id
         * @param {InboundLoad} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsPartialUpdate: function (id, data, force, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsPartialUpdate', 'data', data);
                            localVarPath = "/inboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Inbound Load with specified id. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Retrieve Inbound Load
         * @param {number} id
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsRead: function (id, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('inboundloadsRead', 'id', id);
                            localVarPath = "/inboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.InboundloadsApiAxiosParamCreator = InboundloadsApiAxiosParamCreator;
/**
 * InboundloadsApi - functional programming interface
 * @export
 */
var InboundloadsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InboundloadsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint will create a new Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Create Inbound Load
         * @param {InboundLoad} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint deletes an Inbound Load. In order to make the request, the user needs to have the following permissions:  * `INBOUNDLOAD_WRITE`.
         * @summary Delete Inbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Inbound Loads. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Get Inbound Loads
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {InboundloadsListInboundLoadStatusEnum} [inboundLoadStatus] Inbound Load Status
         * @param {number} [dockdoor] DockDoor ID
         * @param {number} [station] Target Station ID
         * @param {Array<number>} [owner] Filter by the owner of the InboundLoads or any objects that are inside and are owned by this user
         * @param {number} [manifest] Filter by the Manifest ID associated to the InboundLoad
         * @param {string} [bol] Filter by the BOL associated to the InboundLoad
         * @param {InboundloadsListSortByEnum} [sortBy] Sort By
         * @param {boolean} [hidePending] Include only loads with events in from/to range.
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {string} [loadName] Filter by load name, if matches any part of the string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsList: function (page, pageSize, inboundLoadStatus, dockdoor, station, owner, manifest, bol, sortBy, hidePending, fromDate, toDate, loadName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsList(page, pageSize, inboundLoadStatus, dockdoor, station, owner, manifest, bol, sortBy, hidePending, fromDate, toDate, loadName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add a container to the inbound load.  The container can be identified by its tracking number or by its barcode data (`hex`).  If the container is not found in the system, it will be created. If the container is already in the system, it will be added to the inbound load.
         * @summary Add a container to the inbound load. If the container is not found in the system, it will be created and added to the inbound load.
         * @param {AddContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsOperationsAddContainerCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsOperationsAddContainerCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsOperationsAddContainerCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Update Inbound Load
         * @param {number} id
         * @param {InboundLoad} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsPartialUpdate: function (id, data, force, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsPartialUpdate(id, data, force, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Inbound Load with specified id. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Retrieve Inbound Load
         * @param {number} id
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsRead: function (id, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboundloadsRead(id, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InboundloadsApi.inboundloadsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.InboundloadsApiFp = InboundloadsApiFp;
/**
 * InboundloadsApi - factory interface
 * @export
 */
var InboundloadsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InboundloadsApiFp)(configuration);
    return {
        /**
         * This endpoint will create a new Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Create Inbound Load
         * @param {InboundloadsApiInboundloadsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsCreate: function (requestParameters, options) {
            return localVarFp.inboundloadsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint deletes an Inbound Load. In order to make the request, the user needs to have the following permissions:  * `INBOUNDLOAD_WRITE`.
         * @summary Delete Inbound Load
         * @param {InboundloadsApiInboundloadsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsDelete: function (requestParameters, options) {
            return localVarFp.inboundloadsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of Inbound Loads. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Get Inbound Loads
         * @param {InboundloadsApiInboundloadsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.inboundloadsList(requestParameters.page, requestParameters.pageSize, requestParameters.inboundLoadStatus, requestParameters.dockdoor, requestParameters.station, requestParameters.owner, requestParameters.manifest, requestParameters.bol, requestParameters.sortBy, requestParameters.hidePending, requestParameters.fromDate, requestParameters.toDate, requestParameters.loadName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add a container to the inbound load.  The container can be identified by its tracking number or by its barcode data (`hex`).  If the container is not found in the system, it will be created. If the container is already in the system, it will be added to the inbound load.
         * @summary Add a container to the inbound load. If the container is not found in the system, it will be created and added to the inbound load.
         * @param {InboundloadsApiInboundloadsOperationsAddContainerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsOperationsAddContainerCreate: function (requestParameters, options) {
            return localVarFp.inboundloadsOperationsAddContainerCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates an existing Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Update Inbound Load
         * @param {InboundloadsApiInboundloadsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsPartialUpdate: function (requestParameters, options) {
            return localVarFp.inboundloadsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Inbound Load with specified id. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
         * @summary Retrieve Inbound Load
         * @param {InboundloadsApiInboundloadsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboundloadsRead: function (requestParameters, options) {
            return localVarFp.inboundloadsRead(requestParameters.id, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InboundloadsApiFactory = InboundloadsApiFactory;
/**
 * InboundloadsApi - object-oriented interface
 * @export
 * @class InboundloadsApi
 * @extends {BaseAPI}
 */
var InboundloadsApi = /** @class */ (function (_super) {
    __extends(InboundloadsApi, _super);
    function InboundloadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint will create a new Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
     * @summary Create Inbound Load
     * @param {InboundloadsApiInboundloadsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint deletes an Inbound Load. In order to make the request, the user needs to have the following permissions:  * `INBOUNDLOAD_WRITE`.
     * @summary Delete Inbound Load
     * @param {InboundloadsApiInboundloadsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of Inbound Loads. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
     * @summary Get Inbound Loads
     * @param {InboundloadsApiInboundloadsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsList(requestParameters.page, requestParameters.pageSize, requestParameters.inboundLoadStatus, requestParameters.dockdoor, requestParameters.station, requestParameters.owner, requestParameters.manifest, requestParameters.bol, requestParameters.sortBy, requestParameters.hidePending, requestParameters.fromDate, requestParameters.toDate, requestParameters.loadName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add a container to the inbound load.  The container can be identified by its tracking number or by its barcode data (`hex`).  If the container is not found in the system, it will be created. If the container is already in the system, it will be added to the inbound load.
     * @summary Add a container to the inbound load. If the container is not found in the system, it will be created and added to the inbound load.
     * @param {InboundloadsApiInboundloadsOperationsAddContainerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsOperationsAddContainerCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsOperationsAddContainerCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates an existing Inbound Load. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_WRITE`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
     * @summary Update Inbound Load
     * @param {InboundloadsApiInboundloadsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Inbound Load with specified id. In order to make the request, the user needs to have one of the following permissions:  * `INBOUNDLOAD_READ`; * `OPERATORTOOL_TROUBLESHOOTING`; * `OPERATORTOOL_INBOUNDLOADS`.
     * @summary Retrieve Inbound Load
     * @param {InboundloadsApiInboundloadsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundloadsApi
     */
    InboundloadsApi.prototype.inboundloadsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InboundloadsApiFp)(this.configuration).inboundloadsRead(requestParameters.id, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InboundloadsApi;
}(base_1.BaseAPI));
exports.InboundloadsApi = InboundloadsApi;
/**
 * @export
 */
exports.InboundloadsListInboundLoadStatusEnum = {
    PLANNED: 'PLANNED',
    ARRIVED: 'ARRIVED',
    CHECKED_IN: 'CHECKED_IN'
};
/**
 * @export
 */
exports.InboundloadsListSortByEnum = {
    ID: 'id',
    LOAD_TIME: 'load_time',
    ROUTE_NAME: 'route_name',
    LOAD_STATUS: 'load_status',
    ID2: '-id',
    LOAD_TIME2: '-load_time',
    ROUTE_NAME2: '-route_name',
    LOAD_STATUS2: '-load_status'
};
/**
 * LoadplansApi - axios parameter creator
 * @export
 */
var LoadplansApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint creates a new, empty load plan in the given station. It can be activated right away by providing the `active=true` flag, yet it is not recommended, as an empty load plan may disrupt ongoing package operations.
         * @summary Create Load Plan
         * @param {LoadPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansCreate', 'data', data);
                            localVarPath = "/loadplans/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete a load plan*
         * @summary Delete Load Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansDelete', 'id', id);
                            localVarPath = "/loadplans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This deletes the schemes of the Loadplan.  If a `carrier` is provided in the query parameters, only the schemes of the given carrier will be deleted. Likewise, if a `owner` is provided only schemes of the given owner will be deleted. The two parameters can be used at the same time to delete specific schemes of a specific carrier and owner.  This action is permanent, make sure to back-up the Loadplan before running the request.
         * @summary Delete Loadplan Schemes
         * @param {number} id
         * @param {string} [carrier] The string/integer identifier of the Carrier (e.g. USPS or 140) to delete the scheme set for. If left empty, will delete all scheme sets of the given load plan.
         * @param {string} [owner] The string/integer identifier of the Owner (Customer)to delete the scheme set for. If left empty, will delete all scheme sets of the given load plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDeleteSchemes: function (id, carrier, owner, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansDeleteSchemes', 'id', id);
                            localVarPath = "/loadplans/{id}/schemes/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (carrier !== undefined) {
                                localVarQueryParameter['carrier'] = carrier;
                            }
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Export the selected Load Plan as a `.csv`-file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The file is compatible with the [Import API](#operation/loadplans_loadplan_import) and can therefore be used for backing up data.
         * @summary Export Load Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileExport: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansFileExport', 'id', id);
                            localVarPath = "/loadplans/{id}/export/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This imports the given partial Load Plan file into the specified load plan and overwrites **all** entries for the given carrier and owner.  The expected file is a CSV-file, requiring comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ``` If provided, the `carrier`-column is entirely overwritten by the `carrier`-parameter.  If provided, the `owner`-column is entirely overwritten by the `owner`-parameter.  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the changes to the load plan.
         * @summary Import Partial Load Plan File
         * @param {number} id
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {string} [carrier] The string/integer identifier of the Carrier (e.g. USPS or 140) to import the file for. This overwrites the carrier present in the uploaded file. If not provided the file may contain data for multiple carriers to be patched into the loadplan.
         * @param {string} [owner] The string/integer identifier of the Customer to import the file for. This overwrites the owner present in the uploaded file. If not provided the file may contain data for multiple owners to be patched into the loadplan.
         * @param {string} [fileId] The File ID received from a previous dry-run upload. Either &#x60;file&#x60; or &#x60;file_id&#x60; should be specified , not both.
         * @param {File} [file] The Load Plan File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileImport: function (id, dryRun, carrier, owner, fileId, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansFileImport', 'id', id);
                            // verify required parameter 'dryRun' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansFileImport', 'dryRun', dryRun);
                            localVarPath = "/loadplans/{id}/import/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dryRun !== undefined) {
                                localVarQueryParameter['dry_run'] = dryRun;
                            }
                            if (carrier !== undefined) {
                                localVarQueryParameter['carrier'] = carrier;
                            }
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (fileId !== undefined) {
                                localVarQueryParameter['file_id'] = fileId;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Load Plans in the system, filtered to the given parameters.
         * @summary List Load Plans
         * @param {boolean} [active] Filter the result to only contain the currently active Load Plans.
         * @param {number} [station] Filter the result to only contain Load Plans assigned to the given station.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [search] Search for a specific Load Plan by carrier, scheme, stop name, or ZIP Code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansList: function (active, station, page, pageSize, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadplans/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (active !== undefined) {
                                localVarQueryParameter['active'] = active;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Import a full Load Plan by automatically creating a new load plan and subsequently importing the .csv file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the load plan.  If the `set_active` flag was provided, the Load Plan is activated immediately, changing package operations in the given station from the moment the request concludes.
         * @summary Import Full Load Plan File
         * @param {number} stationId The station for which to import the load plan.
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {boolean} [setActive] Activate the load plan immediately after the import succeeds.
         * @param {string} [fileId] The File ID received from a previous dry-run upload. Note that either &#x60;file&#x60; or &#x60;file_id&#x60; should be specified, not both.
         * @param {number} [compareTo] The &#x60;id&#x60; for an existing loadplan in the system that the imported loadplan will be compared to. If left empty it will be compared to the currently active plan.
         * @param {File} [file] The Load Plan File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansLoadplanImport: function (stationId, dryRun, setActive, fileId, compareTo, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stationId' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansLoadplanImport', 'stationId', stationId);
                            // verify required parameter 'dryRun' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansLoadplanImport', 'dryRun', dryRun);
                            localVarPath = "/loadplans/import/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (setActive !== undefined) {
                                localVarQueryParameter['set_active'] = setActive;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (dryRun !== undefined) {
                                localVarQueryParameter['dry_run'] = dryRun;
                            }
                            if (fileId !== undefined) {
                                localVarQueryParameter['file_id'] = fileId;
                            }
                            if (compareTo !== undefined) {
                                localVarQueryParameter['compare_to'] = compareTo;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates the Load Plan, mainly used to activate or deactivate the Load Plan. This endpoint allows partial data, only modifying the properties specified in the request body.
         * @summary Update Load Plan
         * @param {number} id
         * @param {LoadPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansPartialUpdate', 'data', data);
                            localVarPath = "/loadplans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a load plan with specified id*
         * @summary Retrieve load plan by Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadplansRead', 'id', id);
                            localVarPath = "/loadplans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LoadplansApiAxiosParamCreator = LoadplansApiAxiosParamCreator;
/**
 * LoadplansApi - functional programming interface
 * @export
 */
var LoadplansApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoadplansApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint creates a new, empty load plan in the given station. It can be activated right away by providing the `active=true` flag, yet it is not recommended, as an empty load plan may disrupt ongoing package operations.
         * @summary Create Load Plan
         * @param {LoadPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete a load plan*
         * @summary Delete Load Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This deletes the schemes of the Loadplan.  If a `carrier` is provided in the query parameters, only the schemes of the given carrier will be deleted. Likewise, if a `owner` is provided only schemes of the given owner will be deleted. The two parameters can be used at the same time to delete specific schemes of a specific carrier and owner.  This action is permanent, make sure to back-up the Loadplan before running the request.
         * @summary Delete Loadplan Schemes
         * @param {number} id
         * @param {string} [carrier] The string/integer identifier of the Carrier (e.g. USPS or 140) to delete the scheme set for. If left empty, will delete all scheme sets of the given load plan.
         * @param {string} [owner] The string/integer identifier of the Owner (Customer)to delete the scheme set for. If left empty, will delete all scheme sets of the given load plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDeleteSchemes: function (id, carrier, owner, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansDeleteSchemes(id, carrier, owner, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansDeleteSchemes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Export the selected Load Plan as a `.csv`-file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The file is compatible with the [Import API](#operation/loadplans_loadplan_import) and can therefore be used for backing up data.
         * @summary Export Load Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileExport: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansFileExport(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansFileExport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This imports the given partial Load Plan file into the specified load plan and overwrites **all** entries for the given carrier and owner.  The expected file is a CSV-file, requiring comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ``` If provided, the `carrier`-column is entirely overwritten by the `carrier`-parameter.  If provided, the `owner`-column is entirely overwritten by the `owner`-parameter.  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the changes to the load plan.
         * @summary Import Partial Load Plan File
         * @param {number} id
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {string} [carrier] The string/integer identifier of the Carrier (e.g. USPS or 140) to import the file for. This overwrites the carrier present in the uploaded file. If not provided the file may contain data for multiple carriers to be patched into the loadplan.
         * @param {string} [owner] The string/integer identifier of the Customer to import the file for. This overwrites the owner present in the uploaded file. If not provided the file may contain data for multiple owners to be patched into the loadplan.
         * @param {string} [fileId] The File ID received from a previous dry-run upload. Either &#x60;file&#x60; or &#x60;file_id&#x60; should be specified , not both.
         * @param {File} [file] The Load Plan File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileImport: function (id, dryRun, carrier, owner, fileId, file, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansFileImport(id, dryRun, carrier, owner, fileId, file, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansFileImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Load Plans in the system, filtered to the given parameters.
         * @summary List Load Plans
         * @param {boolean} [active] Filter the result to only contain the currently active Load Plans.
         * @param {number} [station] Filter the result to only contain Load Plans assigned to the given station.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [search] Search for a specific Load Plan by carrier, scheme, stop name, or ZIP Code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansList: function (active, station, page, pageSize, search, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansList(active, station, page, pageSize, search, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Import a full Load Plan by automatically creating a new load plan and subsequently importing the .csv file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the load plan.  If the `set_active` flag was provided, the Load Plan is activated immediately, changing package operations in the given station from the moment the request concludes.
         * @summary Import Full Load Plan File
         * @param {number} stationId The station for which to import the load plan.
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {boolean} [setActive] Activate the load plan immediately after the import succeeds.
         * @param {string} [fileId] The File ID received from a previous dry-run upload. Note that either &#x60;file&#x60; or &#x60;file_id&#x60; should be specified, not both.
         * @param {number} [compareTo] The &#x60;id&#x60; for an existing loadplan in the system that the imported loadplan will be compared to. If left empty it will be compared to the currently active plan.
         * @param {File} [file] The Load Plan File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansLoadplanImport: function (stationId, dryRun, setActive, fileId, compareTo, file, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansLoadplanImport(stationId, dryRun, setActive, fileId, compareTo, file, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansLoadplanImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates the Load Plan, mainly used to activate or deactivate the Load Plan. This endpoint allows partial data, only modifying the properties specified in the request body.
         * @summary Update Load Plan
         * @param {number} id
         * @param {LoadPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a load plan with specified id*
         * @summary Retrieve load plan by Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadplansRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadplansApi.loadplansRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LoadplansApiFp = LoadplansApiFp;
/**
 * LoadplansApi - factory interface
 * @export
 */
var LoadplansApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoadplansApiFp)(configuration);
    return {
        /**
         * This endpoint creates a new, empty load plan in the given station. It can be activated right away by providing the `active=true` flag, yet it is not recommended, as an empty load plan may disrupt ongoing package operations.
         * @summary Create Load Plan
         * @param {LoadplansApiLoadplansCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansCreate: function (requestParameters, options) {
            return localVarFp.loadplansCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete a load plan*
         * @summary Delete Load Plan
         * @param {LoadplansApiLoadplansDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDelete: function (requestParameters, options) {
            return localVarFp.loadplansDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This deletes the schemes of the Loadplan.  If a `carrier` is provided in the query parameters, only the schemes of the given carrier will be deleted. Likewise, if a `owner` is provided only schemes of the given owner will be deleted. The two parameters can be used at the same time to delete specific schemes of a specific carrier and owner.  This action is permanent, make sure to back-up the Loadplan before running the request.
         * @summary Delete Loadplan Schemes
         * @param {LoadplansApiLoadplansDeleteSchemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansDeleteSchemes: function (requestParameters, options) {
            return localVarFp.loadplansDeleteSchemes(requestParameters.id, requestParameters.carrier, requestParameters.owner, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Export the selected Load Plan as a `.csv`-file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The file is compatible with the [Import API](#operation/loadplans_loadplan_import) and can therefore be used for backing up data.
         * @summary Export Load Plan
         * @param {LoadplansApiLoadplansFileExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileExport: function (requestParameters, options) {
            return localVarFp.loadplansFileExport(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This imports the given partial Load Plan file into the specified load plan and overwrites **all** entries for the given carrier and owner.  The expected file is a CSV-file, requiring comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ``` If provided, the `carrier`-column is entirely overwritten by the `carrier`-parameter.  If provided, the `owner`-column is entirely overwritten by the `owner`-parameter.  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the changes to the load plan.
         * @summary Import Partial Load Plan File
         * @param {LoadplansApiLoadplansFileImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansFileImport: function (requestParameters, options) {
            return localVarFp.loadplansFileImport(requestParameters.id, requestParameters.dryRun, requestParameters.carrier, requestParameters.owner, requestParameters.fileId, requestParameters.file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of Load Plans in the system, filtered to the given parameters.
         * @summary List Load Plans
         * @param {LoadplansApiLoadplansListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.loadplansList(requestParameters.active, requestParameters.station, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Import a full Load Plan by automatically creating a new load plan and subsequently importing the .csv file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the load plan.  If the `set_active` flag was provided, the Load Plan is activated immediately, changing package operations in the given station from the moment the request concludes.
         * @summary Import Full Load Plan File
         * @param {LoadplansApiLoadplansLoadplanImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansLoadplanImport: function (requestParameters, options) {
            return localVarFp.loadplansLoadplanImport(requestParameters.stationId, requestParameters.dryRun, requestParameters.setActive, requestParameters.fileId, requestParameters.compareTo, requestParameters.file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates the Load Plan, mainly used to activate or deactivate the Load Plan. This endpoint allows partial data, only modifying the properties specified in the request body.
         * @summary Update Load Plan
         * @param {LoadplansApiLoadplansPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansPartialUpdate: function (requestParameters, options) {
            return localVarFp.loadplansPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a load plan with specified id*
         * @summary Retrieve load plan by Id
         * @param {LoadplansApiLoadplansReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadplansRead: function (requestParameters, options) {
            return localVarFp.loadplansRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoadplansApiFactory = LoadplansApiFactory;
/**
 * LoadplansApi - object-oriented interface
 * @export
 * @class LoadplansApi
 * @extends {BaseAPI}
 */
var LoadplansApi = /** @class */ (function (_super) {
    __extends(LoadplansApi, _super);
    function LoadplansApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint creates a new, empty load plan in the given station. It can be activated right away by providing the `active=true` flag, yet it is not recommended, as an empty load plan may disrupt ongoing package operations.
     * @summary Create Load Plan
     * @param {LoadplansApiLoadplansCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete a load plan*
     * @summary Delete Load Plan
     * @param {LoadplansApiLoadplansDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This deletes the schemes of the Loadplan.  If a `carrier` is provided in the query parameters, only the schemes of the given carrier will be deleted. Likewise, if a `owner` is provided only schemes of the given owner will be deleted. The two parameters can be used at the same time to delete specific schemes of a specific carrier and owner.  This action is permanent, make sure to back-up the Loadplan before running the request.
     * @summary Delete Loadplan Schemes
     * @param {LoadplansApiLoadplansDeleteSchemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansDeleteSchemes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansDeleteSchemes(requestParameters.id, requestParameters.carrier, requestParameters.owner, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Export the selected Load Plan as a `.csv`-file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The file is compatible with the [Import API](#operation/loadplans_loadplan_import) and can therefore be used for backing up data.
     * @summary Export Load Plan
     * @param {LoadplansApiLoadplansFileExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansFileExport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansFileExport(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This imports the given partial Load Plan file into the specified load plan and overwrites **all** entries for the given carrier and owner.  The expected file is a CSV-file, requiring comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ``` If provided, the `carrier`-column is entirely overwritten by the `carrier`-parameter.  If provided, the `owner`-column is entirely overwritten by the `owner`-parameter.  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the changes to the load plan.
     * @summary Import Partial Load Plan File
     * @param {LoadplansApiLoadplansFileImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansFileImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansFileImport(requestParameters.id, requestParameters.dryRun, requestParameters.carrier, requestParameters.owner, requestParameters.fileId, requestParameters.file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of Load Plans in the system, filtered to the given parameters.
     * @summary List Load Plans
     * @param {LoadplansApiLoadplansListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansList(requestParameters.active, requestParameters.station, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Import a full Load Plan by automatically creating a new load plan and subsequently importing the .csv file.  The .csv file requires comma-separation of the following shape: ``` stop_name,scheme_name,carrier,owner,zipcode,sort_param abcd,abcd,USPS,CustomerX,12021,XYZ ```  The `stop_name` and `sort_param` columns are optional. If the `stop_name` is not provided, the `scheme_name` will be used as the name of the stop to be created.  Upon import (including when using the `dry-run` flag), the API returns a summary of the load plan.  If the `set_active` flag was provided, the Load Plan is activated immediately, changing package operations in the given station from the moment the request concludes.
     * @summary Import Full Load Plan File
     * @param {LoadplansApiLoadplansLoadplanImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansLoadplanImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansLoadplanImport(requestParameters.stationId, requestParameters.dryRun, requestParameters.setActive, requestParameters.fileId, requestParameters.compareTo, requestParameters.file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates the Load Plan, mainly used to activate or deactivate the Load Plan. This endpoint allows partial data, only modifying the properties specified in the request body.
     * @summary Update Load Plan
     * @param {LoadplansApiLoadplansPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a load plan with specified id*
     * @summary Retrieve load plan by Id
     * @param {LoadplansApiLoadplansReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadplansApi
     */
    LoadplansApi.prototype.loadplansRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadplansApiFp)(this.configuration).loadplansRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoadplansApi;
}(base_1.BaseAPI));
exports.LoadplansApi = LoadplansApi;
/**
 * LoadpointsApi - axios parameter creator
 * @export
 */
var LoadpointsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns the Load Point using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an active LoadPoint by query
         * @param {number} [id] Loadpoint ID
         * @param {string} [name] Loadpoint Name
         * @param {number} [zone] Zone ID
         * @param {string} [zoneName] Zone Name
         * @param {number} [area] Area ID
         * @param {string} [areaName] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsByquery: function (id, name, zone, zoneName, area, areaName, station, stationName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadpoints/byquery/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (zoneName !== undefined) {
                                localVarQueryParameter['zone_name'] = zoneName;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (areaName !== undefined) {
                                localVarQueryParameter['area_name'] = areaName;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (stationName !== undefined) {
                                localVarQueryParameter['station_name'] = stationName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Load Point*
         * @summary Create Load Point
         * @param {LoadPoint} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsCreate', 'data', data);
                            localVarPath = "/loadpoints/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Load Point by ID*
         * @summary Delete Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsDelete', 'id', id);
                            localVarPath = "/loadpoints/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Load Point, which is contains a human-readable name of the load point and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {LoadpointsLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabel: function (id, dataFormat, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsLabel', 'id', id);
                            localVarPath = "/loadpoints/{id}/label/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dataFormat !== undefined) {
                                localVarQueryParameter['data_format'] = dataFormat;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Load Point by ID.
         * @summary Get the PNG label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsLabelLabelPng', 'id', id);
                            localVarPath = "/loadpoints/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Load Point by ID.
         * @summary Get the ZPL label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsLabelLabelZpl', 'id', id);
                            localVarPath = "/loadpoints/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Load Points Are an Activity Area in the Station where packages are Containerized or where Containers are hierarchically loaded (such as pallets into a trailer).  *This endpoint returns a list of Load Points*
         * @summary Get Load Points
         * @param {number} [station] Station ID
         * @param {number} [targetStation] Target Station ID
         * @param {LoadpointsListAreaTypeEnum} [areaType] Area Type
         * @param {boolean} [isActive] In Active Module
         * @param {number} [zone] Zone ID
         * @param {number} [module] Module ID
         * @param {number} [scheme]
         * @param {number} [fmc] FMC ID
         * @param {LoadpointsListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsList: function (station, targetStation, areaType, isActive, zone, module, scheme, fmc, sortBy, search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/loadpoints/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (targetStation !== undefined) {
                                localVarQueryParameter['target_station'] = targetStation;
                            }
                            if (areaType !== undefined) {
                                localVarQueryParameter['area_type'] = areaType;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (module !== undefined) {
                                localVarQueryParameter['module'] = module;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (fmc !== undefined) {
                                localVarQueryParameter['fmc'] = fmc;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Load Point by ID*
         * @summary Patch Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {LoadPointDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsPartialUpdate', 'data', data);
                            localVarPath = "/loadpoints/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Load Point by ID*
         * @summary Retrieve Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('loadpointsRead', 'id', id);
                            localVarPath = "/loadpoints/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LoadpointsApiAxiosParamCreator = LoadpointsApiAxiosParamCreator;
/**
 * LoadpointsApi - functional programming interface
 * @export
 */
var LoadpointsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoadpointsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns the Load Point using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an active LoadPoint by query
         * @param {number} [id] Loadpoint ID
         * @param {string} [name] Loadpoint Name
         * @param {number} [zone] Zone ID
         * @param {string} [zoneName] Zone Name
         * @param {number} [area] Area ID
         * @param {string} [areaName] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsByquery: function (id, name, zone, zoneName, area, areaName, station, stationName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsByquery(id, name, zone, zoneName, area, areaName, station, stationName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsByquery']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Load Point*
         * @summary Create Load Point
         * @param {LoadPoint} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Load Point by ID*
         * @summary Delete Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Load Point, which is contains a human-readable name of the load point and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {LoadpointsLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabel: function (id, dataFormat, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsLabel(id, dataFormat, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsLabel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Load Point by ID.
         * @summary Get the PNG label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Load Point by ID.
         * @summary Get the ZPL label for a Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Load Points Are an Activity Area in the Station where packages are Containerized or where Containers are hierarchically loaded (such as pallets into a trailer).  *This endpoint returns a list of Load Points*
         * @summary Get Load Points
         * @param {number} [station] Station ID
         * @param {number} [targetStation] Target Station ID
         * @param {LoadpointsListAreaTypeEnum} [areaType] Area Type
         * @param {boolean} [isActive] In Active Module
         * @param {number} [zone] Zone ID
         * @param {number} [module] Module ID
         * @param {number} [scheme]
         * @param {number} [fmc] FMC ID
         * @param {LoadpointsListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsList: function (station, targetStation, areaType, isActive, zone, module, scheme, fmc, sortBy, search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsList(station, targetStation, areaType, isActive, zone, module, scheme, fmc, sortBy, search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Load Point by ID*
         * @summary Patch Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {LoadPointDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Load Point by ID*
         * @summary Retrieve Load Point
         * @param {number} id A unique integer value identifying this load point.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadpointsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LoadpointsApi.loadpointsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LoadpointsApiFp = LoadpointsApiFp;
/**
 * LoadpointsApi - factory interface
 * @export
 */
var LoadpointsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoadpointsApiFp)(configuration);
    return {
        /**
         * This endpoint returns the Load Point using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get an active LoadPoint by query
         * @param {LoadpointsApiLoadpointsByqueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsByquery: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.loadpointsByquery(requestParameters.id, requestParameters.name, requestParameters.zone, requestParameters.zoneName, requestParameters.area, requestParameters.areaName, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Load Point*
         * @summary Create Load Point
         * @param {LoadpointsApiLoadpointsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsCreate: function (requestParameters, options) {
            return localVarFp.loadpointsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Load Point by ID*
         * @summary Delete Load Point
         * @param {LoadpointsApiLoadpointsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsDelete: function (requestParameters, options) {
            return localVarFp.loadpointsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the printable label for a Load Point, which is contains a human-readable name of the load point and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Load Point
         * @param {LoadpointsApiLoadpointsLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabel: function (requestParameters, options) {
            return localVarFp.loadpointsLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Load Point by ID.
         * @summary Get the PNG label for a Load Point
         * @param {LoadpointsApiLoadpointsLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelPng: function (requestParameters, options) {
            return localVarFp.loadpointsLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Load Point by ID.
         * @summary Get the ZPL label for a Load Point
         * @param {LoadpointsApiLoadpointsLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.loadpointsLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Load Points Are an Activity Area in the Station where packages are Containerized or where Containers are hierarchically loaded (such as pallets into a trailer).  *This endpoint returns a list of Load Points*
         * @summary Get Load Points
         * @param {LoadpointsApiLoadpointsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.loadpointsList(requestParameters.station, requestParameters.targetStation, requestParameters.areaType, requestParameters.isActive, requestParameters.zone, requestParameters.module, requestParameters.scheme, requestParameters.fmc, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Load Point by ID*
         * @summary Patch Load Point
         * @param {LoadpointsApiLoadpointsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsPartialUpdate: function (requestParameters, options) {
            return localVarFp.loadpointsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Load Point by ID*
         * @summary Retrieve Load Point
         * @param {LoadpointsApiLoadpointsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadpointsRead: function (requestParameters, options) {
            return localVarFp.loadpointsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoadpointsApiFactory = LoadpointsApiFactory;
/**
 * LoadpointsApi - object-oriented interface
 * @export
 * @class LoadpointsApi
 * @extends {BaseAPI}
 */
var LoadpointsApi = /** @class */ (function (_super) {
    __extends(LoadpointsApi, _super);
    function LoadpointsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns the Load Point using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
     * @summary Get an active LoadPoint by query
     * @param {LoadpointsApiLoadpointsByqueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsByquery = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsByquery(requestParameters.id, requestParameters.name, requestParameters.zone, requestParameters.zoneName, requestParameters.area, requestParameters.areaName, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Load Point*
     * @summary Create Load Point
     * @param {LoadpointsApiLoadpointsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Load Point by ID*
     * @summary Delete Load Point
     * @param {LoadpointsApiLoadpointsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the printable label for a Load Point, which is contains a human-readable name of the load point and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
     * @summary DEPRECATED Get the label for a Load Point
     * @param {LoadpointsApiLoadpointsLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsLabel = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Load Point by ID.
     * @summary Get the PNG label for a Load Point
     * @param {LoadpointsApiLoadpointsLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label as JSON for a Load Point by ID.
     * @summary Get the ZPL label for a Load Point
     * @param {LoadpointsApiLoadpointsLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Load Points Are an Activity Area in the Station where packages are Containerized or where Containers are hierarchically loaded (such as pallets into a trailer).  *This endpoint returns a list of Load Points*
     * @summary Get Load Points
     * @param {LoadpointsApiLoadpointsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsList(requestParameters.station, requestParameters.targetStation, requestParameters.areaType, requestParameters.isActive, requestParameters.zone, requestParameters.module, requestParameters.scheme, requestParameters.fmc, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Load Point by ID*
     * @summary Patch Load Point
     * @param {LoadpointsApiLoadpointsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Load Point by ID*
     * @summary Retrieve Load Point
     * @param {LoadpointsApiLoadpointsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadpointsApi
     */
    LoadpointsApi.prototype.loadpointsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LoadpointsApiFp)(this.configuration).loadpointsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoadpointsApi;
}(base_1.BaseAPI));
exports.LoadpointsApi = LoadpointsApi;
/**
 * @export
 */
exports.LoadpointsLabelDataFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
/**
 * @export
 */
exports.LoadpointsListAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
/**
 * @export
 */
exports.LoadpointsListSortByEnum = {
    NAME: 'name',
    NAME2: '-name'
};
/**
 * LocationsApi - axios parameter creator
 * @export
 */
var LocationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a single csv file with rows representing locations with all their data.
         * @summary Get location list as CSV
         * @param {string} [search] Use this filter to search the stops by their name.
         * @param {string} [geoSearch] Internal: Geo Search.
         * @param {LocationsCsvLocationTypeEnum} [locationType] Filter the returned locations by their type. The most common scenarios are to filter by &#x60;STOP&#x60; in order to list all stops, in combination with the &#x60;station_owner&#x60; filter, to receive all candidates of stops for a given &#x60;CLOUDSORT&#x60; station.
         * @param {number} [excludeRoute] Filter the locations excluding the stations that have the given route configured, or are part of the given routes stops.
         * @param {number} [station] Filter the returned locations by selecting only the ones placed on routes, whose parent station ID is the provided ID. This is typically used when listing all stops of a given &#x60;CLOUDSORT&#x60; station, currently being in use by a route on that station.
         * @param {number} [route] Filter the locations returning only the stations that are being used on the given route.
         * @param {string} [fmc] Filter the locations returning only the stations whose schemes are owned by the given FMC (carrier).
         * @param {number} [loadplan] Filter the locations returning only the stations whose schemes are created within the given Load Plan.
         * @param {number} [stationOwner] Filter the returned locations to contain only stations whose &#x60;owner&#x60; property matches this ID. This in combination with the &#x60;location_type&#x60; filter is typically used to list all stops of a given station.
         * @param {number} [scheme] Filter the locations returning only stations assigned to the given Scheme.
         * @param {LocationsCsvSortByEnum} [sortBy] Modify the sort order of the returned locations list.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsCsv: function (search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/locations/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (geoSearch !== undefined) {
                                localVarQueryParameter['geo_search'] = geoSearch;
                            }
                            if (locationType !== undefined) {
                                localVarQueryParameter['location_type'] = locationType;
                            }
                            if (excludeRoute !== undefined) {
                                localVarQueryParameter['exclude_route'] = excludeRoute;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (route !== undefined) {
                                localVarQueryParameter['route'] = route;
                            }
                            if (fmc !== undefined) {
                                localVarQueryParameter['fmc'] = fmc;
                            }
                            if (loadplan !== undefined) {
                                localVarQueryParameter['loadplan'] = loadplan;
                            }
                            if (stationOwner !== undefined) {
                                localVarQueryParameter['station_owner'] = stationOwner;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A location refers to a ground facility used within the system. Such stations can be of different types, the most common being `CLOUDSORT` and `STOP`. A `CLOUDSORT` station refers to a sortation facility using the CloudSort System to manage operations, while a `STOP` refers to a station to which a `CLOUDSORT` station would delivery sorted packages to.  Typical `STOP` stations will have an `owner` property declaring that this station is owned and sandboxed to the given owner. An `owner` is typically a station of type `CLOUDSORT`.  To manage routes, a `CLOUDSORT` station will create a [Route](#tag/Routes-API) object, and then place `STOP`-type station on the Route object, using the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Get Locations
         * @param {string} [search] Use this filter to search the stops by their name.
         * @param {string} [geoSearch] Internal: Geo Search.
         * @param {LocationsListLocationTypeEnum} [locationType] Filter the returned locations by their type. The most common scenarios are to filter by &#x60;STOP&#x60; in order to list all stops, in combination with the &#x60;station_owner&#x60; filter, to receive all candidates of stops for a given &#x60;CLOUDSORT&#x60; station.
         * @param {number} [excludeRoute] Filter the locations excluding the stations that have the given route configured, or are part of the given routes stops.
         * @param {number} [station] Filter the returned locations by selecting only the ones placed on routes, whose parent station ID is the provided ID. This is typically used when listing all stops of a given &#x60;CLOUDSORT&#x60; station, currently being in use by a route on that station.
         * @param {number} [route] Filter the locations returning only the stations that are being used on the given route.
         * @param {string} [fmc] Filter the locations returning only the stations whose schemes are owned by the given FMC (carrier).
         * @param {number} [loadplan] Filter the locations returning only the stations whose schemes are created within the given Load Plan.
         * @param {number} [stationOwner] Filter the returned locations to contain only stations whose &#x60;owner&#x60; property matches this ID. This in combination with the &#x60;location_type&#x60; filter is typically used to list all stops of a given station.
         * @param {number} [scheme] Filter the locations returning only stations assigned to the given Scheme.
         * @param {LocationsListSortByEnum} [sortBy] Modify the sort order of the returned locations list.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsList: function (search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/locations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (geoSearch !== undefined) {
                                localVarQueryParameter['geo_search'] = geoSearch;
                            }
                            if (locationType !== undefined) {
                                localVarQueryParameter['location_type'] = locationType;
                            }
                            if (excludeRoute !== undefined) {
                                localVarQueryParameter['exclude_route'] = excludeRoute;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (route !== undefined) {
                                localVarQueryParameter['route'] = route;
                            }
                            if (fmc !== undefined) {
                                localVarQueryParameter['fmc'] = fmc;
                            }
                            if (loadplan !== undefined) {
                                localVarQueryParameter['loadplan'] = loadplan;
                            }
                            if (stationOwner !== undefined) {
                                localVarQueryParameter['station_owner'] = stationOwner;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Location by ID*
         * @summary Retrieve Location
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('locationsRead', 'id', id);
                            localVarPath = "/locations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LocationsApiAxiosParamCreator = LocationsApiAxiosParamCreator;
/**
 * LocationsApi - functional programming interface
 * @export
 */
var LocationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LocationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a single csv file with rows representing locations with all their data.
         * @summary Get location list as CSV
         * @param {string} [search] Use this filter to search the stops by their name.
         * @param {string} [geoSearch] Internal: Geo Search.
         * @param {LocationsCsvLocationTypeEnum} [locationType] Filter the returned locations by their type. The most common scenarios are to filter by &#x60;STOP&#x60; in order to list all stops, in combination with the &#x60;station_owner&#x60; filter, to receive all candidates of stops for a given &#x60;CLOUDSORT&#x60; station.
         * @param {number} [excludeRoute] Filter the locations excluding the stations that have the given route configured, or are part of the given routes stops.
         * @param {number} [station] Filter the returned locations by selecting only the ones placed on routes, whose parent station ID is the provided ID. This is typically used when listing all stops of a given &#x60;CLOUDSORT&#x60; station, currently being in use by a route on that station.
         * @param {number} [route] Filter the locations returning only the stations that are being used on the given route.
         * @param {string} [fmc] Filter the locations returning only the stations whose schemes are owned by the given FMC (carrier).
         * @param {number} [loadplan] Filter the locations returning only the stations whose schemes are created within the given Load Plan.
         * @param {number} [stationOwner] Filter the returned locations to contain only stations whose &#x60;owner&#x60; property matches this ID. This in combination with the &#x60;location_type&#x60; filter is typically used to list all stops of a given station.
         * @param {number} [scheme] Filter the locations returning only stations assigned to the given Scheme.
         * @param {LocationsCsvSortByEnum} [sortBy] Modify the sort order of the returned locations list.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsCsv: function (search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationsCsv(search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationsApi.locationsCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A location refers to a ground facility used within the system. Such stations can be of different types, the most common being `CLOUDSORT` and `STOP`. A `CLOUDSORT` station refers to a sortation facility using the CloudSort System to manage operations, while a `STOP` refers to a station to which a `CLOUDSORT` station would delivery sorted packages to.  Typical `STOP` stations will have an `owner` property declaring that this station is owned and sandboxed to the given owner. An `owner` is typically a station of type `CLOUDSORT`.  To manage routes, a `CLOUDSORT` station will create a [Route](#tag/Routes-API) object, and then place `STOP`-type station on the Route object, using the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Get Locations
         * @param {string} [search] Use this filter to search the stops by their name.
         * @param {string} [geoSearch] Internal: Geo Search.
         * @param {LocationsListLocationTypeEnum} [locationType] Filter the returned locations by their type. The most common scenarios are to filter by &#x60;STOP&#x60; in order to list all stops, in combination with the &#x60;station_owner&#x60; filter, to receive all candidates of stops for a given &#x60;CLOUDSORT&#x60; station.
         * @param {number} [excludeRoute] Filter the locations excluding the stations that have the given route configured, or are part of the given routes stops.
         * @param {number} [station] Filter the returned locations by selecting only the ones placed on routes, whose parent station ID is the provided ID. This is typically used when listing all stops of a given &#x60;CLOUDSORT&#x60; station, currently being in use by a route on that station.
         * @param {number} [route] Filter the locations returning only the stations that are being used on the given route.
         * @param {string} [fmc] Filter the locations returning only the stations whose schemes are owned by the given FMC (carrier).
         * @param {number} [loadplan] Filter the locations returning only the stations whose schemes are created within the given Load Plan.
         * @param {number} [stationOwner] Filter the returned locations to contain only stations whose &#x60;owner&#x60; property matches this ID. This in combination with the &#x60;location_type&#x60; filter is typically used to list all stops of a given station.
         * @param {number} [scheme] Filter the locations returning only stations assigned to the given Scheme.
         * @param {LocationsListSortByEnum} [sortBy] Modify the sort order of the returned locations list.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsList: function (search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationsList(search, geoSearch, locationType, excludeRoute, station, route, fmc, loadplan, stationOwner, scheme, sortBy, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationsApi.locationsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Location by ID*
         * @summary Retrieve Location
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationsApi.locationsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LocationsApiFp = LocationsApiFp;
/**
 * LocationsApi - factory interface
 * @export
 */
var LocationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LocationsApiFp)(configuration);
    return {
        /**
         * Returns a single csv file with rows representing locations with all their data.
         * @summary Get location list as CSV
         * @param {LocationsApiLocationsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsCsv: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.locationsCsv(requestParameters.search, requestParameters.geoSearch, requestParameters.locationType, requestParameters.excludeRoute, requestParameters.station, requestParameters.route, requestParameters.fmc, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.scheme, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A location refers to a ground facility used within the system. Such stations can be of different types, the most common being `CLOUDSORT` and `STOP`. A `CLOUDSORT` station refers to a sortation facility using the CloudSort System to manage operations, while a `STOP` refers to a station to which a `CLOUDSORT` station would delivery sorted packages to.  Typical `STOP` stations will have an `owner` property declaring that this station is owned and sandboxed to the given owner. An `owner` is typically a station of type `CLOUDSORT`.  To manage routes, a `CLOUDSORT` station will create a [Route](#tag/Routes-API) object, and then place `STOP`-type station on the Route object, using the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Get Locations
         * @param {LocationsApiLocationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.locationsList(requestParameters.search, requestParameters.geoSearch, requestParameters.locationType, requestParameters.excludeRoute, requestParameters.station, requestParameters.route, requestParameters.fmc, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.scheme, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Location by ID*
         * @summary Retrieve Location
         * @param {LocationsApiLocationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsRead: function (requestParameters, options) {
            return localVarFp.locationsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LocationsApiFactory = LocationsApiFactory;
/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
var LocationsApi = /** @class */ (function (_super) {
    __extends(LocationsApi, _super);
    function LocationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a single csv file with rows representing locations with all their data.
     * @summary Get location list as CSV
     * @param {LocationsApiLocationsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationsCsv = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LocationsApiFp)(this.configuration).locationsCsv(requestParameters.search, requestParameters.geoSearch, requestParameters.locationType, requestParameters.excludeRoute, requestParameters.station, requestParameters.route, requestParameters.fmc, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.scheme, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A location refers to a ground facility used within the system. Such stations can be of different types, the most common being `CLOUDSORT` and `STOP`. A `CLOUDSORT` station refers to a sortation facility using the CloudSort System to manage operations, while a `STOP` refers to a station to which a `CLOUDSORT` station would delivery sorted packages to.  Typical `STOP` stations will have an `owner` property declaring that this station is owned and sandboxed to the given owner. An `owner` is typically a station of type `CLOUDSORT`.  To manage routes, a `CLOUDSORT` station will create a [Route](#tag/Routes-API) object, and then place `STOP`-type station on the Route object, using the [Routes to Stops API](#tag/Routes-to-Stops-API).
     * @summary Get Locations
     * @param {LocationsApiLocationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LocationsApiFp)(this.configuration).locationsList(requestParameters.search, requestParameters.geoSearch, requestParameters.locationType, requestParameters.excludeRoute, requestParameters.station, requestParameters.route, requestParameters.fmc, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.scheme, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Location by ID*
     * @summary Retrieve Location
     * @param {LocationsApiLocationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).locationsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LocationsApi;
}(base_1.BaseAPI));
exports.LocationsApi = LocationsApi;
/**
 * @export
 */
exports.LocationsCsvLocationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
/**
 * @export
 */
exports.LocationsCsvSortByEnum = {
    ROUTES_COUNT: 'routes_count',
    ROUTES_COUNT2: '-routes_count'
};
/**
 * @export
 */
exports.LocationsListLocationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
/**
 * @export
 */
exports.LocationsListSortByEnum = {
    ROUTES_COUNT: 'routes_count',
    ROUTES_COUNT2: '-routes_count'
};
/**
 * ManifestsApi - axios parameter creator
 * @export
 */
var ManifestsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns a single csv file with rows representing packages manifests with all their data. Note that if outbound_load is added to the filters, that will further filter down the individual packages and containers of the exported data.
         * @summary Gets Manifests as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [station] Station ID
         * @param {Array<string>} [manifestIds] Manifest ids
         * @param {Array<number>} [owner] Owner ID
         * @param {ManifestsCsvManifestTypeEnum} [manifestType] Either \&#39;inbound\&#39; or \&#39;outbound\&#39;, and shows the corresponding type of manifests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsCsv: function (fromDate, toDate, page, pageSize, station, manifestIds, owner, manifestType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fromDate' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsCsv', 'fromDate', fromDate);
                            // verify required parameter 'toDate' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsCsv', 'toDate', toDate);
                            localVarPath = "/manifests/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (manifestIds) {
                                localVarQueryParameter['manifest_ids'] = manifestIds.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (manifestType !== undefined) {
                                localVarQueryParameter['manifest_type'] = manifestType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Handler to receive an inbound manifest.  This API endpoint enables Users to create and address hold reasons associated with a Package. When a list of hold reasons is specified in the `hold_for` field, the CloudSort system checks for their existence. If they don\'t already exist, the system creates and assigns them to the specified Package. Consequently, the Package can only be sorted after resolving all the listed hold reasons.  Each time a new list of hold reasons is passed to the `hold_for` field, the system marks any previously unresolved hold reasons as resolved. If the `hold_for` field is left blank or not included in the request, the system assumes all existing hold reasons have been addressed and marks them as resolved.  In essence, this mechanism ensures that the Package\'s status reflects the most recent list of hold reasons provided via the `hold_for` field.
         * @summary Inbound manifest
         * @param {InboundManifest} data
         * @param {number} [owner] Internal: owner to use for the manifest.
         * @param {number} [defaultEntryStation] Internal: entry station to use for the manifest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInbound: function (data, owner, defaultEntryStation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsInbound', 'data', data);
                            localVarPath = "/manifests/inbound/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (defaultEntryStation !== undefined) {
                                localVarQueryParameter['default_entry_station'] = defaultEntryStation;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Handler to receive an inbound manifest.
         * @summary Inbound manifest with CSV File
         * @param {number} owner
         * @param {File} file
         * @param {number} [defaultEntryStation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInboundInboundUpload: function (owner, file, defaultEntryStation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'owner' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsInboundInboundUpload', 'owner', owner);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsInboundInboundUpload', 'file', file);
                            localVarPath = "/manifests/inbound/upload/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (defaultEntryStation !== undefined) {
                                localVarQueryParameter['default_entry_station'] = defaultEntryStation;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A manifest is a document listing the cargo of a vehicle. The manifest is used to ensure that cargo listed as having been placed on board the transport at the beginning of its passage continue to be on board when it arrives at its destination.  *This endpoint returns a list of Manifests*
         * @summary Get Manifests
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [id] Manifest ID
         * @param {number} [outboundLoad] Outbound Load ID
         * @param {number} [station] Station ID
         * @param {Array<number>} [owner] Owner ID
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {ManifestsListSortByEnum} [sortBy] Sort By
         * @param {ManifestsListManifestTypeEnum} [manifestType] Either \&#39;inbound\&#39; or \&#39;outbound\&#39;, and shows the corresponding type of manifests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsList: function (page, pageSize, id, outboundLoad, station, owner, fromDate, toDate, sortBy, manifestType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/manifests/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (outboundLoad !== undefined) {
                                localVarQueryParameter['outbound_load'] = outboundLoad;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (manifestType !== undefined) {
                                localVarQueryParameter['manifest_type'] = manifestType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Manifest by ID*
         * @summary Patch Manifest
         * @param {number} id
         * @param {ManifestSerializerDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsPartialUpdate', 'data', data);
                            localVarPath = "/manifests/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Manifest by ID*
         * @summary Retrieve Manifest
         * @param {number} id
         * @param {number} [version] Manifest Details Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsRead: function (id, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('manifestsRead', 'id', id);
                            localVarPath = "/manifests/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (version !== undefined) {
                                localVarQueryParameter['version'] = version;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ManifestsApiAxiosParamCreator = ManifestsApiAxiosParamCreator;
/**
 * ManifestsApi - functional programming interface
 * @export
 */
var ManifestsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ManifestsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a single csv file with rows representing packages manifests with all their data. Note that if outbound_load is added to the filters, that will further filter down the individual packages and containers of the exported data.
         * @summary Gets Manifests as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [station] Station ID
         * @param {Array<string>} [manifestIds] Manifest ids
         * @param {Array<number>} [owner] Owner ID
         * @param {ManifestsCsvManifestTypeEnum} [manifestType] Either \&#39;inbound\&#39; or \&#39;outbound\&#39;, and shows the corresponding type of manifests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsCsv: function (fromDate, toDate, page, pageSize, station, manifestIds, owner, manifestType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsCsv(fromDate, toDate, page, pageSize, station, manifestIds, owner, manifestType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Handler to receive an inbound manifest.  This API endpoint enables Users to create and address hold reasons associated with a Package. When a list of hold reasons is specified in the `hold_for` field, the CloudSort system checks for their existence. If they don\'t already exist, the system creates and assigns them to the specified Package. Consequently, the Package can only be sorted after resolving all the listed hold reasons.  Each time a new list of hold reasons is passed to the `hold_for` field, the system marks any previously unresolved hold reasons as resolved. If the `hold_for` field is left blank or not included in the request, the system assumes all existing hold reasons have been addressed and marks them as resolved.  In essence, this mechanism ensures that the Package\'s status reflects the most recent list of hold reasons provided via the `hold_for` field.
         * @summary Inbound manifest
         * @param {InboundManifest} data
         * @param {number} [owner] Internal: owner to use for the manifest.
         * @param {number} [defaultEntryStation] Internal: entry station to use for the manifest.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInbound: function (data, owner, defaultEntryStation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsInbound(data, owner, defaultEntryStation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsInbound']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Handler to receive an inbound manifest.
         * @summary Inbound manifest with CSV File
         * @param {number} owner
         * @param {File} file
         * @param {number} [defaultEntryStation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInboundInboundUpload: function (owner, file, defaultEntryStation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsInboundInboundUpload(owner, file, defaultEntryStation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsInboundInboundUpload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A manifest is a document listing the cargo of a vehicle. The manifest is used to ensure that cargo listed as having been placed on board the transport at the beginning of its passage continue to be on board when it arrives at its destination.  *This endpoint returns a list of Manifests*
         * @summary Get Manifests
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [id] Manifest ID
         * @param {number} [outboundLoad] Outbound Load ID
         * @param {number} [station] Station ID
         * @param {Array<number>} [owner] Owner ID
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {ManifestsListSortByEnum} [sortBy] Sort By
         * @param {ManifestsListManifestTypeEnum} [manifestType] Either \&#39;inbound\&#39; or \&#39;outbound\&#39;, and shows the corresponding type of manifests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsList: function (page, pageSize, id, outboundLoad, station, owner, fromDate, toDate, sortBy, manifestType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsList(page, pageSize, id, outboundLoad, station, owner, fromDate, toDate, sortBy, manifestType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Manifest by ID*
         * @summary Patch Manifest
         * @param {number} id
         * @param {ManifestSerializerDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a single Manifest by ID*
         * @summary Retrieve Manifest
         * @param {number} id
         * @param {number} [version] Manifest Details Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsRead: function (id, version, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manifestsRead(id, version, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ManifestsApi.manifestsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ManifestsApiFp = ManifestsApiFp;
/**
 * ManifestsApi - factory interface
 * @export
 */
var ManifestsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ManifestsApiFp)(configuration);
    return {
        /**
         * Returns a single csv file with rows representing packages manifests with all their data. Note that if outbound_load is added to the filters, that will further filter down the individual packages and containers of the exported data.
         * @summary Gets Manifests as CSV
         * @param {ManifestsApiManifestsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsCsv: function (requestParameters, options) {
            return localVarFp.manifestsCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.station, requestParameters.manifestIds, requestParameters.owner, requestParameters.manifestType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Handler to receive an inbound manifest.  This API endpoint enables Users to create and address hold reasons associated with a Package. When a list of hold reasons is specified in the `hold_for` field, the CloudSort system checks for their existence. If they don\'t already exist, the system creates and assigns them to the specified Package. Consequently, the Package can only be sorted after resolving all the listed hold reasons.  Each time a new list of hold reasons is passed to the `hold_for` field, the system marks any previously unresolved hold reasons as resolved. If the `hold_for` field is left blank or not included in the request, the system assumes all existing hold reasons have been addressed and marks them as resolved.  In essence, this mechanism ensures that the Package\'s status reflects the most recent list of hold reasons provided via the `hold_for` field.
         * @summary Inbound manifest
         * @param {ManifestsApiManifestsInboundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInbound: function (requestParameters, options) {
            return localVarFp.manifestsInbound(requestParameters.data, requestParameters.owner, requestParameters.defaultEntryStation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Handler to receive an inbound manifest.
         * @summary Inbound manifest with CSV File
         * @param {ManifestsApiManifestsInboundInboundUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsInboundInboundUpload: function (requestParameters, options) {
            return localVarFp.manifestsInboundInboundUpload(requestParameters.owner, requestParameters.file, requestParameters.defaultEntryStation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A manifest is a document listing the cargo of a vehicle. The manifest is used to ensure that cargo listed as having been placed on board the transport at the beginning of its passage continue to be on board when it arrives at its destination.  *This endpoint returns a list of Manifests*
         * @summary Get Manifests
         * @param {ManifestsApiManifestsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.manifestsList(requestParameters.page, requestParameters.pageSize, requestParameters.id, requestParameters.outboundLoad, requestParameters.station, requestParameters.owner, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.manifestType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Manifest by ID*
         * @summary Patch Manifest
         * @param {ManifestsApiManifestsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsPartialUpdate: function (requestParameters, options) {
            return localVarFp.manifestsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a single Manifest by ID*
         * @summary Retrieve Manifest
         * @param {ManifestsApiManifestsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestsRead: function (requestParameters, options) {
            return localVarFp.manifestsRead(requestParameters.id, requestParameters.version, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ManifestsApiFactory = ManifestsApiFactory;
/**
 * ManifestsApi - object-oriented interface
 * @export
 * @class ManifestsApi
 * @extends {BaseAPI}
 */
var ManifestsApi = /** @class */ (function (_super) {
    __extends(ManifestsApi, _super);
    function ManifestsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a single csv file with rows representing packages manifests with all their data. Note that if outbound_load is added to the filters, that will further filter down the individual packages and containers of the exported data.
     * @summary Gets Manifests as CSV
     * @param {ManifestsApiManifestsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsCsv = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.station, requestParameters.manifestIds, requestParameters.owner, requestParameters.manifestType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Handler to receive an inbound manifest.  This API endpoint enables Users to create and address hold reasons associated with a Package. When a list of hold reasons is specified in the `hold_for` field, the CloudSort system checks for their existence. If they don\'t already exist, the system creates and assigns them to the specified Package. Consequently, the Package can only be sorted after resolving all the listed hold reasons.  Each time a new list of hold reasons is passed to the `hold_for` field, the system marks any previously unresolved hold reasons as resolved. If the `hold_for` field is left blank or not included in the request, the system assumes all existing hold reasons have been addressed and marks them as resolved.  In essence, this mechanism ensures that the Package\'s status reflects the most recent list of hold reasons provided via the `hold_for` field.
     * @summary Inbound manifest
     * @param {ManifestsApiManifestsInboundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsInbound = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsInbound(requestParameters.data, requestParameters.owner, requestParameters.defaultEntryStation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Handler to receive an inbound manifest.
     * @summary Inbound manifest with CSV File
     * @param {ManifestsApiManifestsInboundInboundUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsInboundInboundUpload = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsInboundInboundUpload(requestParameters.owner, requestParameters.file, requestParameters.defaultEntryStation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A manifest is a document listing the cargo of a vehicle. The manifest is used to ensure that cargo listed as having been placed on board the transport at the beginning of its passage continue to be on board when it arrives at its destination.  *This endpoint returns a list of Manifests*
     * @summary Get Manifests
     * @param {ManifestsApiManifestsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsList(requestParameters.page, requestParameters.pageSize, requestParameters.id, requestParameters.outboundLoad, requestParameters.station, requestParameters.owner, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.manifestType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Manifest by ID*
     * @summary Patch Manifest
     * @param {ManifestsApiManifestsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a single Manifest by ID*
     * @summary Retrieve Manifest
     * @param {ManifestsApiManifestsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestsApi
     */
    ManifestsApi.prototype.manifestsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ManifestsApiFp)(this.configuration).manifestsRead(requestParameters.id, requestParameters.version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ManifestsApi;
}(base_1.BaseAPI));
exports.ManifestsApi = ManifestsApi;
/**
 * @export
 */
exports.ManifestsCsvManifestTypeEnum = {
    INBOUND: 'inbound',
    OUTBOUND: 'outbound'
};
/**
 * @export
 */
exports.ManifestsListSortByEnum = {
    ID: 'id',
    CREATED_ON: 'created_on',
    ID2: '-id',
    CREATED_ON2: '-created_on'
};
/**
 * @export
 */
exports.ManifestsListManifestTypeEnum = {
    INBOUND: 'inbound',
    OUTBOUND: 'outbound'
};
/**
 * ModulesApi - axios parameter creator
 * @export
 */
var ModulesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Assign the module to zones.
         * @summary Assign a Module
         * @param {ZoneModuleAssign} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesAssign: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('modulesAssign', 'data', data);
                            localVarPath = "/modules/assign/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Module*
         * @summary Create Module
         * @param {Module} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('modulesCreate', 'data', data);
                            localVarPath = "/modules/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Module by ID*
         * @summary Delete Module
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('modulesDelete', 'id', id);
                            localVarPath = "/modules/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modules are Zone configurations that layout a set of Load Points and can be activated/deactivated for the owning Zone. There can be at most one active Module per Zone, which relates to the currently used physical layout on the shop-floor of a CloudSort Station.  *This endpoint returns a list of Modules*
         * @summary Get Modules
         * @param {number} [station] Station ID
         * @param {boolean} [isActive] Is Active
         * @param {number} [zone] Zone ID
         * @param {ModulesListAreaTypeEnum} [areaType] Area Type
         * @param {ModulesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesList: function (station, isActive, zone, areaType, sortBy, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/modules/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (areaType !== undefined) {
                                localVarQueryParameter['area_type'] = areaType;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Module by ID*
         * @summary Patch Module
         * @param {number} id
         * @param {ModuleDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('modulesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('modulesPartialUpdate', 'data', data);
                            localVarPath = "/modules/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Module by ID*
         * @summary Retrieve Module
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('modulesRead', 'id', id);
                            localVarPath = "/modules/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ModulesApiAxiosParamCreator = ModulesApiAxiosParamCreator;
/**
 * ModulesApi - functional programming interface
 * @export
 */
var ModulesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ModulesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Assign the module to zones.
         * @summary Assign a Module
         * @param {ZoneModuleAssign} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesAssign: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesAssign(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesAssign']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Module*
         * @summary Create Module
         * @param {Module} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Module by ID*
         * @summary Delete Module
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Modules are Zone configurations that layout a set of Load Points and can be activated/deactivated for the owning Zone. There can be at most one active Module per Zone, which relates to the currently used physical layout on the shop-floor of a CloudSort Station.  *This endpoint returns a list of Modules*
         * @summary Get Modules
         * @param {number} [station] Station ID
         * @param {boolean} [isActive] Is Active
         * @param {number} [zone] Zone ID
         * @param {ModulesListAreaTypeEnum} [areaType] Area Type
         * @param {ModulesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesList: function (station, isActive, zone, areaType, sortBy, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesList(station, isActive, zone, areaType, sortBy, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Module by ID*
         * @summary Patch Module
         * @param {number} id
         * @param {ModuleDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Module by ID*
         * @summary Retrieve Module
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.modulesRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ModulesApi.modulesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ModulesApiFp = ModulesApiFp;
/**
 * ModulesApi - factory interface
 * @export
 */
var ModulesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ModulesApiFp)(configuration);
    return {
        /**
         * Assign the module to zones.
         * @summary Assign a Module
         * @param {ModulesApiModulesAssignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesAssign: function (requestParameters, options) {
            return localVarFp.modulesAssign(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Module*
         * @summary Create Module
         * @param {ModulesApiModulesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesCreate: function (requestParameters, options) {
            return localVarFp.modulesCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Module by ID*
         * @summary Delete Module
         * @param {ModulesApiModulesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesDelete: function (requestParameters, options) {
            return localVarFp.modulesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modules are Zone configurations that layout a set of Load Points and can be activated/deactivated for the owning Zone. There can be at most one active Module per Zone, which relates to the currently used physical layout on the shop-floor of a CloudSort Station.  *This endpoint returns a list of Modules*
         * @summary Get Modules
         * @param {ModulesApiModulesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.modulesList(requestParameters.station, requestParameters.isActive, requestParameters.zone, requestParameters.areaType, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Module by ID*
         * @summary Patch Module
         * @param {ModulesApiModulesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesPartialUpdate: function (requestParameters, options) {
            return localVarFp.modulesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Module by ID*
         * @summary Retrieve Module
         * @param {ModulesApiModulesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modulesRead: function (requestParameters, options) {
            return localVarFp.modulesRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ModulesApiFactory = ModulesApiFactory;
/**
 * ModulesApi - object-oriented interface
 * @export
 * @class ModulesApi
 * @extends {BaseAPI}
 */
var ModulesApi = /** @class */ (function (_super) {
    __extends(ModulesApi, _super);
    function ModulesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Assign the module to zones.
     * @summary Assign a Module
     * @param {ModulesApiModulesAssignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesAssign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ModulesApiFp)(this.configuration).modulesAssign(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Module*
     * @summary Create Module
     * @param {ModulesApiModulesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ModulesApiFp)(this.configuration).modulesCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Module by ID*
     * @summary Delete Module
     * @param {ModulesApiModulesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ModulesApiFp)(this.configuration).modulesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modules are Zone configurations that layout a set of Load Points and can be activated/deactivated for the owning Zone. There can be at most one active Module per Zone, which relates to the currently used physical layout on the shop-floor of a CloudSort Station.  *This endpoint returns a list of Modules*
     * @summary Get Modules
     * @param {ModulesApiModulesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ModulesApiFp)(this.configuration).modulesList(requestParameters.station, requestParameters.isActive, requestParameters.zone, requestParameters.areaType, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Module by ID*
     * @summary Patch Module
     * @param {ModulesApiModulesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ModulesApiFp)(this.configuration).modulesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Module by ID*
     * @summary Retrieve Module
     * @param {ModulesApiModulesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    ModulesApi.prototype.modulesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ModulesApiFp)(this.configuration).modulesRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ModulesApi;
}(base_1.BaseAPI));
exports.ModulesApi = ModulesApi;
/**
 * @export
 */
exports.ModulesListAreaTypeEnum = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGING: 'STAGING'
};
/**
 * @export
 */
exports.ModulesListSortByEnum = {
    LOAD_POINT_COUNT: 'load_point_count',
    NAME: 'name',
    LOAD_POINT_COUNT2: '-load_point_count',
    NAME2: '-name'
};
/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
var OrganizationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Organization*
         * @summary Create an Organization
         * @param {Organization} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsCreate', 'data', data);
                            localVarPath = "/organizations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete Organization with the specified id*
         * @summary Delete Organization
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsDelete', 'id', id);
                            localVarPath = "/organizations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of all the Organizations*
         * @summary Get all the Organizations
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsList: function (search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/organizations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Organization by ID*
         * @summary Patch Organization
         * @param {number} id
         * @param {Organization} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsPartialUpdate', 'data', data);
                            localVarPath = "/organizations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint creates a new organization role with changed permissions.
         * @summary Creates/Updates a organization role with set of permissions
         * @param {number} id
         * @param {PatchOrganizationRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsPermissionsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsPermissionsPartialUpdate', 'data', data);
                            localVarPath = "/organizations/{id}/permissions/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsPermissionsRead', 'id', id);
                            localVarPath = "/organizations/{id}/permissions/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a Organization with specified id*
         * @summary Retrieve Organization by Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('organizationsRead', 'id', id);
                            localVarPath = "/organizations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationsApiAxiosParamCreator = OrganizationsApiAxiosParamCreator;
/**
 * OrganizationsApi - functional programming interface
 * @export
 */
var OrganizationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Organization*
         * @summary Create an Organization
         * @param {Organization} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete Organization with the specified id*
         * @summary Delete Organization
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of all the Organizations*
         * @summary Get all the Organizations
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsList: function (search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsList(search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Organization by ID*
         * @summary Patch Organization
         * @param {number} id
         * @param {Organization} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint creates a new organization role with changed permissions.
         * @summary Creates/Updates a organization role with set of permissions
         * @param {number} id
         * @param {PatchOrganizationRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsPermissionsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsPermissionsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsPermissionsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsPermissionsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a Organization with specified id*
         * @summary Retrieve Organization by Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OrganizationsApi.organizationsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OrganizationsApiFp = OrganizationsApiFp;
/**
 * OrganizationsApi - factory interface
 * @export
 */
var OrganizationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationsApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Organization*
         * @summary Create an Organization
         * @param {OrganizationsApiOrganizationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCreate: function (requestParameters, options) {
            return localVarFp.organizationsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete Organization with the specified id*
         * @summary Delete Organization
         * @param {OrganizationsApiOrganizationsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete: function (requestParameters, options) {
            return localVarFp.organizationsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a list of all the Organizations*
         * @summary Get all the Organizations
         * @param {OrganizationsApiOrganizationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.organizationsList(requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Organization by ID*
         * @summary Patch Organization
         * @param {OrganizationsApiOrganizationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPartialUpdate: function (requestParameters, options) {
            return localVarFp.organizationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint creates a new organization role with changed permissions.
         * @summary Creates/Updates a organization role with set of permissions
         * @param {OrganizationsApiOrganizationsPermissionsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsPartialUpdate: function (requestParameters, options) {
            return localVarFp.organizationsPermissionsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {OrganizationsApiOrganizationsPermissionsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsPermissionsRead: function (requestParameters, options) {
            return localVarFp.organizationsPermissionsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a Organization with specified id*
         * @summary Retrieve Organization by Id
         * @param {OrganizationsApiOrganizationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsRead: function (requestParameters, options) {
            return localVarFp.organizationsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationsApiFactory = OrganizationsApiFactory;
/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
var OrganizationsApi = /** @class */ (function (_super) {
    __extends(OrganizationsApi, _super);
    function OrganizationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Organization*
     * @summary Create an Organization
     * @param {OrganizationsApiOrganizationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete Organization with the specified id*
     * @summary Delete Organization
     * @param {OrganizationsApiOrganizationsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a list of all the Organizations*
     * @summary Get all the Organizations
     * @param {OrganizationsApiOrganizationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsList(requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Organization by ID*
     * @summary Patch Organization
     * @param {OrganizationsApiOrganizationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint creates a new organization role with changed permissions.
     * @summary Creates/Updates a organization role with set of permissions
     * @param {OrganizationsApiOrganizationsPermissionsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsPermissionsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsPermissionsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of permissions by role
     * @summary Returns a list of permissions by role
     * @param {OrganizationsApiOrganizationsPermissionsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsPermissionsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsPermissionsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a Organization with specified id*
     * @summary Retrieve Organization by Id
     * @param {OrganizationsApiOrganizationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    OrganizationsApi.prototype.organizationsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration).organizationsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationsApi;
}(base_1.BaseAPI));
exports.OrganizationsApi = OrganizationsApi;
/**
 * OutboundloadsApi - axios parameter creator
 * @export
 */
var OutboundloadsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Outbound Load*
         * @summary Create Outbound Load
         * @param {OutboundLoad} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsCreate', 'data', data);
                            localVarPath = "/outboundloads/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing packages outbound loads with all their data. Filtering by a single or multiple outbound loads can be done with query parameters.
         * @summary Export Outboundloads as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [station] Station ID
         * @param {Array<number>} [outboundLoadIds] Outbound load ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCsv: function (fromDate, toDate, page, pageSize, station, outboundLoadIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fromDate' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsCsv', 'fromDate', fromDate);
                            // verify required parameter 'toDate' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsCsv', 'toDate', toDate);
                            localVarPath = "/outboundloads/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (outboundLoadIds) {
                                localVarQueryParameter['outbound_load_ids'] = outboundLoadIds.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Outbound Load with specified id*
         * @summary Delete Outbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsDelete', 'id', id);
                            localVarPath = "/outboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of Outbound Loads*
         * @summary Get Outbound Loads
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {OutboundloadsListOutboundLoadStatusEnum} [outboundLoadStatus] Outbound Load Status
         * @param {number} [dockdoor] DockDoor ID
         * @param {number} [station] Station ID
         * @param {number} [scheme] Scheme ID
         * @param {Array<number>} [route] Route ID
         * @param {Array<number>} [stop] OLoads whose Route contains this Stop ID
         * @param {Array<number>} [carrier] OLoads with at least one package for the Carrier ID
         * @param {Array<number>} [shipper] OLoads with at least one package for the Shipper ID
         * @param {OutboundloadsListSortByEnum} [sortBy] Sort By
         * @param {Array<OutboundloadsListDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {boolean} [includeGhostResources] Show Ghost packages
         * @param {boolean} [hidePending] Include only loads with events in from/to range.
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsList: function (page, pageSize, outboundLoadStatus, dockdoor, station, scheme, route, stop, carrier, shipper, sortBy, defects, includeGhostResources, hidePending, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/outboundloads/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (outboundLoadStatus !== undefined) {
                                localVarQueryParameter['outbound_load_status'] = outboundLoadStatus;
                            }
                            if (dockdoor !== undefined) {
                                localVarQueryParameter['dockdoor'] = dockdoor;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (stop) {
                                localVarQueryParameter['stop'] = stop.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (shipper) {
                                localVarQueryParameter['shipper'] = shipper.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Outbound Load with specified id*
         * @summary Patch Outbound Load
         * @param {number} id
         * @param {OutboundLoad} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsPartialUpdate: function (id, data, force, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsPartialUpdate', 'data', data);
                            localVarPath = "/outboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Outbound Load with specified id*
         * @summary Retrieve Outbound Load
         * @param {number} id
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsRead: function (id, troubleshoot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsRead', 'id', id);
                            localVarPath = "/outboundloads/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (troubleshoot !== undefined) {
                                localVarQueryParameter['troubleshoot'] = troubleshoot;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a ZIP archive of report files, produced during dispatching of the load.
         * @summary Retrieve report files for the given outbound load.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsReports: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsReports', 'id', id);
                            localVarPath = "/outboundloads/{id}/reports/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the state of a specific Outbound Load
         * @summary Get the state for an Outbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsState: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('outboundloadsState', 'id', id);
                            localVarPath = "/outboundloads/{id}/state/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OutboundloadsApiAxiosParamCreator = OutboundloadsApiAxiosParamCreator;
/**
 * OutboundloadsApi - functional programming interface
 * @export
 */
var OutboundloadsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OutboundloadsApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Outbound Load*
         * @summary Create Outbound Load
         * @param {OutboundLoad} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing packages outbound loads with all their data. Filtering by a single or multiple outbound loads can be done with query parameters.
         * @summary Export Outboundloads as CSV
         * @param {string} fromDate Time-bound Filter: From
         * @param {string} toDate Time-bound Filter: To
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [station] Station ID
         * @param {Array<number>} [outboundLoadIds] Outbound load ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCsv: function (fromDate, toDate, page, pageSize, station, outboundLoadIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsCsv(fromDate, toDate, page, pageSize, station, outboundLoadIds, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Outbound Load with specified id*
         * @summary Delete Outbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of Outbound Loads*
         * @summary Get Outbound Loads
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {OutboundloadsListOutboundLoadStatusEnum} [outboundLoadStatus] Outbound Load Status
         * @param {number} [dockdoor] DockDoor ID
         * @param {number} [station] Station ID
         * @param {number} [scheme] Scheme ID
         * @param {Array<number>} [route] Route ID
         * @param {Array<number>} [stop] OLoads whose Route contains this Stop ID
         * @param {Array<number>} [carrier] OLoads with at least one package for the Carrier ID
         * @param {Array<number>} [shipper] OLoads with at least one package for the Shipper ID
         * @param {OutboundloadsListSortByEnum} [sortBy] Sort By
         * @param {Array<OutboundloadsListDefectsEnum>} [defects] Defects (in station &amp; before to_date)
         * @param {boolean} [includeGhostResources] Show Ghost packages
         * @param {boolean} [hidePending] Include only loads with events in from/to range.
         * @param {string} [fromDate] Time-bound Filter: From
         * @param {string} [toDate] Time-bound Filter: To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsList: function (page, pageSize, outboundLoadStatus, dockdoor, station, scheme, route, stop, carrier, shipper, sortBy, defects, includeGhostResources, hidePending, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsList(page, pageSize, outboundLoadStatus, dockdoor, station, scheme, route, stop, carrier, shipper, sortBy, defects, includeGhostResources, hidePending, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Outbound Load with specified id*
         * @summary Patch Outbound Load
         * @param {number} id
         * @param {OutboundLoad} data
         * @param {boolean} [force] Force action
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsPartialUpdate: function (id, data, force, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsPartialUpdate(id, data, force, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Outbound Load with specified id*
         * @summary Retrieve Outbound Load
         * @param {number} id
         * @param {boolean} [troubleshoot] Troubleshoot mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsRead: function (id, troubleshoot, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsRead(id, troubleshoot, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a ZIP archive of report files, produced during dispatching of the load.
         * @summary Retrieve report files for the given outbound load.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsReports: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsReports(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsReports']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the state of a specific Outbound Load
         * @summary Get the state for an Outbound Load
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsState: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.outboundloadsState(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OutboundloadsApi.outboundloadsState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OutboundloadsApiFp = OutboundloadsApiFp;
/**
 * OutboundloadsApi - factory interface
 * @export
 */
var OutboundloadsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OutboundloadsApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Outbound Load*
         * @summary Create Outbound Load
         * @param {OutboundloadsApiOutboundloadsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCreate: function (requestParameters, options) {
            return localVarFp.outboundloadsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single csv file with rows representing packages outbound loads with all their data. Filtering by a single or multiple outbound loads can be done with query parameters.
         * @summary Export Outboundloads as CSV
         * @param {OutboundloadsApiOutboundloadsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsCsv: function (requestParameters, options) {
            return localVarFp.outboundloadsCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.station, requestParameters.outboundLoadIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Outbound Load with specified id*
         * @summary Delete Outbound Load
         * @param {OutboundloadsApiOutboundloadsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsDelete: function (requestParameters, options) {
            return localVarFp.outboundloadsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a list of Outbound Loads*
         * @summary Get Outbound Loads
         * @param {OutboundloadsApiOutboundloadsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.outboundloadsList(requestParameters.page, requestParameters.pageSize, requestParameters.outboundLoadStatus, requestParameters.dockdoor, requestParameters.station, requestParameters.scheme, requestParameters.route, requestParameters.stop, requestParameters.carrier, requestParameters.shipper, requestParameters.sortBy, requestParameters.defects, requestParameters.includeGhostResources, requestParameters.hidePending, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Outbound Load with specified id*
         * @summary Patch Outbound Load
         * @param {OutboundloadsApiOutboundloadsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsPartialUpdate: function (requestParameters, options) {
            return localVarFp.outboundloadsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Outbound Load with specified id*
         * @summary Retrieve Outbound Load
         * @param {OutboundloadsApiOutboundloadsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsRead: function (requestParameters, options) {
            return localVarFp.outboundloadsRead(requestParameters.id, requestParameters.troubleshoot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a ZIP archive of report files, produced during dispatching of the load.
         * @summary Retrieve report files for the given outbound load.
         * @param {OutboundloadsApiOutboundloadsReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsReports: function (requestParameters, options) {
            return localVarFp.outboundloadsReports(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the state of a specific Outbound Load
         * @summary Get the state for an Outbound Load
         * @param {OutboundloadsApiOutboundloadsStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outboundloadsState: function (requestParameters, options) {
            return localVarFp.outboundloadsState(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OutboundloadsApiFactory = OutboundloadsApiFactory;
/**
 * OutboundloadsApi - object-oriented interface
 * @export
 * @class OutboundloadsApi
 * @extends {BaseAPI}
 */
var OutboundloadsApi = /** @class */ (function (_super) {
    __extends(OutboundloadsApi, _super);
    function OutboundloadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Outbound Load*
     * @summary Create Outbound Load
     * @param {OutboundloadsApiOutboundloadsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single csv file with rows representing packages outbound loads with all their data. Filtering by a single or multiple outbound loads can be done with query parameters.
     * @summary Export Outboundloads as CSV
     * @param {OutboundloadsApiOutboundloadsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsCsv = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.station, requestParameters.outboundLoadIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Outbound Load with specified id*
     * @summary Delete Outbound Load
     * @param {OutboundloadsApiOutboundloadsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a list of Outbound Loads*
     * @summary Get Outbound Loads
     * @param {OutboundloadsApiOutboundloadsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsList(requestParameters.page, requestParameters.pageSize, requestParameters.outboundLoadStatus, requestParameters.dockdoor, requestParameters.station, requestParameters.scheme, requestParameters.route, requestParameters.stop, requestParameters.carrier, requestParameters.shipper, requestParameters.sortBy, requestParameters.defects, requestParameters.includeGhostResources, requestParameters.hidePending, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Outbound Load with specified id*
     * @summary Patch Outbound Load
     * @param {OutboundloadsApiOutboundloadsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Outbound Load with specified id*
     * @summary Retrieve Outbound Load
     * @param {OutboundloadsApiOutboundloadsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsRead(requestParameters.id, requestParameters.troubleshoot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a ZIP archive of report files, produced during dispatching of the load.
     * @summary Retrieve report files for the given outbound load.
     * @param {OutboundloadsApiOutboundloadsReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsReports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsReports(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the state of a specific Outbound Load
     * @summary Get the state for an Outbound Load
     * @param {OutboundloadsApiOutboundloadsStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutboundloadsApi
     */
    OutboundloadsApi.prototype.outboundloadsState = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OutboundloadsApiFp)(this.configuration).outboundloadsState(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OutboundloadsApi;
}(base_1.BaseAPI));
exports.OutboundloadsApi = OutboundloadsApi;
/**
 * @export
 */
exports.OutboundloadsListOutboundLoadStatusEnum = {
    OPEN: 'OPEN',
    LOADING: 'LOADING',
    DISPATCHED: 'DISPATCHED'
};
/**
 * @export
 */
exports.OutboundloadsListSortByEnum = {
    ID: 'id',
    LOAD_TIME: 'load_time',
    ROUTE_NAME: 'route_name',
    LOAD_STATUS: 'load_status',
    ID2: '-id',
    LOAD_TIME2: '-load_time',
    ROUTE_NAME2: '-route_name',
    LOAD_STATUS2: '-load_status'
};
/**
 * @export
 */
exports.OutboundloadsListDefectsEnum = {
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED'
};
/**
 * PackagesApi - axios parameter creator
 * @export
 */
var PackagesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This returns aggregate data from the list of packages that match the specified parameters. The datapoints returned are the number of packages \'count\' and the total volume of the packages \'volume\'. This endpoint uses the same parameters as the `list` endpoint.
         * @summary Get aggregate data from the list of Packages.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesAggregatedataSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesAggregatedataDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesAggregatedataProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesAggregatedataExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {string} [fromDate] Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} [toDate] Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesAggregatedata: function (page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages/aggregatedata/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (externalTrackingNumber !== undefined) {
                                localVarQueryParameter['external_tracking_number'] = externalTrackingNumber;
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (manifest) {
                                localVarQueryParameter['manifest'] = manifest.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (container) {
                                localVarQueryParameter['container'] = container.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (isManifested !== undefined) {
                                localVarQueryParameter['is_manifested'] = isManifested;
                            }
                            if (isScanned !== undefined) {
                                localVarQueryParameter['is_scanned'] = isScanned;
                            }
                            if (isLoaded !== undefined) {
                                localVarQueryParameter['is_loaded'] = isLoaded;
                            }
                            if (isArrived !== undefined) {
                                localVarQueryParameter['is_arrived'] = isArrived;
                            }
                            if (isDispatched !== undefined) {
                                localVarQueryParameter['is_dispatched'] = isDispatched;
                            }
                            if (isUnprocessable !== undefined) {
                                localVarQueryParameter['is_unprocessable'] = isUnprocessable;
                            }
                            if (inSystem !== undefined) {
                                localVarQueryParameter['in_system'] = inSystem;
                            }
                            if (isMissorted !== undefined) {
                                localVarQueryParameter['is_missorted'] = isMissorted;
                            }
                            if (isMisloaded !== undefined) {
                                localVarQueryParameter['is_misloaded'] = isMisloaded;
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (processStep) {
                                localVarQueryParameter['process_step'] = processStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeProcessStep) {
                                localVarQueryParameter['exclude_process_step'] = excludeProcessStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoad) {
                                localVarQueryParameter['inbound_load'] = inboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoadDirect !== undefined) {
                                localVarQueryParameter['inbound_load_direct'] = inboundLoadDirect;
                            }
                            if (outboundLoad) {
                                localVarQueryParameter['outbound_load'] = outboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (outboundLoadDirect !== undefined) {
                                localVarQueryParameter['outbound_load_direct'] = outboundLoadDirect;
                            }
                            if (firstScannedInWindow !== undefined) {
                                localVarQueryParameter['first_scanned_in_window'] = firstScannedInWindow;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (inHold !== undefined) {
                                localVarQueryParameter['in_hold'] = inHold;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PDF of the Commercial Invoice for a Package by ID if the corresponding providers configured via the Customer Centric Configurations provides it.
         * @summary Get the PDF Commercial Invoice for a Package via Providers.
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCommercialinvoicePdf: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesCommercialinvoicePdf', 'id', id);
                            localVarPath = "/packages/{id}/commercialinvoice/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows a User to create a package in the CloudSort system, registering it and its properties, as well as generating tracking and vendor related data. Once a package is created, it can be shipped (and optionally manifested) to a CloudSort Facility using a custom label or the label data provided by the CloudSort system.  The packages are identified by their tracking number while being processed in CloudSort Facilities. Tracking numbers must appear on custom labels.  To allow richer integration scenarios, it is possible to send an \"external tracking number\" alongside the package properties while creating the package.
         * @summary Create Package
         * @param {PackageCreation} data
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCreate: function (data, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesCreate', 'data', data);
                            localVarPath = "/packages/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing packages with all their data.
         * @summary Get package list as CSV
         * @param {string} fromDate Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} toDate Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesCsvSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesCsvDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesCsvProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesCsvExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {Array<string>} [includeLabels] The extra data labels to include in the response. The format is expected to be a comma-separated list of strings, with optional alias definition. Example: &#x60;include_labels&#x3D;some.label.key-no-alias,label.key|alias&#x60;. As seen, the alias can be provided separated via a | character.
         * @param {boolean} [eventTimes] Extends CSV file columns to include Scan, Load and Dispatch time stamps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCsv: function (fromDate, toDate, page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, includeLabels, eventTimes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fromDate' is not null or undefined
                            (0, common_1.assertParamExists)('packagesCsv', 'fromDate', fromDate);
                            // verify required parameter 'toDate' is not null or undefined
                            (0, common_1.assertParamExists)('packagesCsv', 'toDate', toDate);
                            localVarPath = "/packages/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (externalTrackingNumber !== undefined) {
                                localVarQueryParameter['external_tracking_number'] = externalTrackingNumber;
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (manifest) {
                                localVarQueryParameter['manifest'] = manifest.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (container) {
                                localVarQueryParameter['container'] = container.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (isManifested !== undefined) {
                                localVarQueryParameter['is_manifested'] = isManifested;
                            }
                            if (isScanned !== undefined) {
                                localVarQueryParameter['is_scanned'] = isScanned;
                            }
                            if (isLoaded !== undefined) {
                                localVarQueryParameter['is_loaded'] = isLoaded;
                            }
                            if (isArrived !== undefined) {
                                localVarQueryParameter['is_arrived'] = isArrived;
                            }
                            if (isDispatched !== undefined) {
                                localVarQueryParameter['is_dispatched'] = isDispatched;
                            }
                            if (isUnprocessable !== undefined) {
                                localVarQueryParameter['is_unprocessable'] = isUnprocessable;
                            }
                            if (inSystem !== undefined) {
                                localVarQueryParameter['in_system'] = inSystem;
                            }
                            if (isMissorted !== undefined) {
                                localVarQueryParameter['is_missorted'] = isMissorted;
                            }
                            if (isMisloaded !== undefined) {
                                localVarQueryParameter['is_misloaded'] = isMisloaded;
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (processStep) {
                                localVarQueryParameter['process_step'] = processStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeProcessStep) {
                                localVarQueryParameter['exclude_process_step'] = excludeProcessStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoad) {
                                localVarQueryParameter['inbound_load'] = inboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoadDirect !== undefined) {
                                localVarQueryParameter['inbound_load_direct'] = inboundLoadDirect;
                            }
                            if (outboundLoad) {
                                localVarQueryParameter['outbound_load'] = outboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (outboundLoadDirect !== undefined) {
                                localVarQueryParameter['outbound_load_direct'] = outboundLoadDirect;
                            }
                            if (firstScannedInWindow !== undefined) {
                                localVarQueryParameter['first_scanned_in_window'] = firstScannedInWindow;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (inHold !== undefined) {
                                localVarQueryParameter['in_hold'] = inHold;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (includeLabels) {
                                localVarQueryParameter['include_labels'] = includeLabels.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (eventTimes !== undefined) {
                                localVarQueryParameter['event_times'] = eventTimes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Package by ID*
         * @summary Delete Package
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesDelete', 'id', id);
                            localVarPath = "/packages/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint parses an incoming 2D bar code. Returns a package if a package exists with given barcode, otherwise will create a new package at ARRIVED.
         * @summary Parse external bar code.
         * @param {PackageExternalBarCode} data
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesFromexternalbarcode: function (data, scan, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesFromexternalbarcode', 'data', data);
                            localVarPath = "/packages/fromexternalbarcode/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (scan !== undefined) {
                                localVarQueryParameter['scan'] = scan;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Allow to perform package actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {PackageGeneric} data
         * @param {boolean} [force] Force action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesGeneric: function (data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesGeneric', 'data', data);
                            localVarPath = "/packages/generic/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a csv file where each row represents a holding reason with the information of the package that has it. If a package has multiple holding reasons, there will be multiple rows for that package.
         * @summary Get packages with holding reasons in CSV format.
         * @param {PackagesHoldReasonsCsvSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsCsvScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsCsvSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsCsvStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsCsv: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages/hold_reasons/csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (source !== undefined) {
                                localVarQueryParameter['source'] = source;
                            }
                            if (inboundLoad !== undefined) {
                                localVarQueryParameter['inbound_load'] = inboundLoad;
                            }
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (carrier !== undefined) {
                                localVarQueryParameter['carrier'] = carrier;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (reason !== undefined) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (scope !== undefined) {
                                localVarQueryParameter['scope'] = scope;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = toDate;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List all packages with holding reasons.
         * @param {PackagesHoldReasonsListSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsListScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsListSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsListStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsList: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages/hold_reasons/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (source !== undefined) {
                                localVarQueryParameter['source'] = source;
                            }
                            if (inboundLoad !== undefined) {
                                localVarQueryParameter['inbound_load'] = inboundLoad;
                            }
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (carrier !== undefined) {
                                localVarQueryParameter['carrier'] = carrier;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (reason !== undefined) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (scope !== undefined) {
                                localVarQueryParameter['scope'] = scope;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = toDate;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get stats about packages with holding reasons.
         * @param {PackagesHoldReasonsStatsSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsStatsScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsStatsSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsStatsStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsStats: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages/hold_reasons/stats/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (source !== undefined) {
                                localVarQueryParameter['source'] = source;
                            }
                            if (inboundLoad !== undefined) {
                                localVarQueryParameter['inbound_load'] = inboundLoad;
                            }
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (carrier !== undefined) {
                                localVarQueryParameter['carrier'] = carrier;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (reason !== undefined) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (scope !== undefined) {
                                localVarQueryParameter['scope'] = scope;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = toDate;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Package by ID.
         * @summary Get the PNG label for a Package
         * @param {number} id A unique integer value identifying this package.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesLabelLabelPng', 'id', id);
                            localVarPath = "/packages/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Package by ID.
         * @summary Get the ZPL label for a Package
         * @param {number} id A unique integer value identifying this package.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesLabelLabelZpl', 'id', id);
                            localVarPath = "/packages/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This API provides access to a list of packages, the shipping products of the CloudSort System. The endpoint provides detailed information about the package\'s current location, its destination and other relevant information. The endpoint also permits time-based slicing of the returned data to ensure easy access to a set of packages. The time-based filters `from_date` and `to_date` behave as follows:  * Providing a `from_date` prompts the API to filter the packages to contain only packages that had an interaction within the last 7 days counting back from the provided `from_date`. If a package has been dispatched from the CloudSort Facility before `from_date` it is also excluded. Therefore, `from_date` contains __all__ packages that are currently being processed by a CloudSort Facility on that date. This behavior is modified by providing `hide_pending=true`, which sets the lookback period to zero, and the resulting list only contains packages that had an interaction after the `from_date`.  * Providing a `to_date` has a different side-effect, in which the packages state is wound backwards to the given date, so the returned data provides a snapshot of the past (please note that setting a `to_date` can slow down the response time of the endpoint).  For tracking purposes, the API provides the following parameters to identify packages: * `tracking_number` - the Carrier\'s tracking number * `external_tracking_number` - the Customers/Shippers internal id
         * @summary List Packages
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesListSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesListDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesListProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesListExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {string} [fromDate] Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} [toDate] Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesList: function (page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/packages/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (trackingNumber !== undefined) {
                                localVarQueryParameter['tracking_number'] = trackingNumber;
                            }
                            if (externalTrackingNumber !== undefined) {
                                localVarQueryParameter['external_tracking_number'] = externalTrackingNumber;
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (manifest) {
                                localVarQueryParameter['manifest'] = manifest.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (container) {
                                localVarQueryParameter['container'] = container.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (hidePending !== undefined) {
                                localVarQueryParameter['hide_pending'] = hidePending;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (isManifested !== undefined) {
                                localVarQueryParameter['is_manifested'] = isManifested;
                            }
                            if (isScanned !== undefined) {
                                localVarQueryParameter['is_scanned'] = isScanned;
                            }
                            if (isLoaded !== undefined) {
                                localVarQueryParameter['is_loaded'] = isLoaded;
                            }
                            if (isArrived !== undefined) {
                                localVarQueryParameter['is_arrived'] = isArrived;
                            }
                            if (isDispatched !== undefined) {
                                localVarQueryParameter['is_dispatched'] = isDispatched;
                            }
                            if (isUnprocessable !== undefined) {
                                localVarQueryParameter['is_unprocessable'] = isUnprocessable;
                            }
                            if (inSystem !== undefined) {
                                localVarQueryParameter['in_system'] = inSystem;
                            }
                            if (isMissorted !== undefined) {
                                localVarQueryParameter['is_missorted'] = isMissorted;
                            }
                            if (isMisloaded !== undefined) {
                                localVarQueryParameter['is_misloaded'] = isMisloaded;
                            }
                            if (defects) {
                                localVarQueryParameter['defects'] = defects.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (processStep) {
                                localVarQueryParameter['process_step'] = processStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (excludeProcessStep) {
                                localVarQueryParameter['exclude_process_step'] = excludeProcessStep.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoad) {
                                localVarQueryParameter['inbound_load'] = inboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (inboundLoadDirect !== undefined) {
                                localVarQueryParameter['inbound_load_direct'] = inboundLoadDirect;
                            }
                            if (outboundLoad) {
                                localVarQueryParameter['outbound_load'] = outboundLoad.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (outboundLoadDirect !== undefined) {
                                localVarQueryParameter['outbound_load_direct'] = outboundLoadDirect;
                            }
                            if (firstScannedInWindow !== undefined) {
                                localVarQueryParameter['first_scanned_in_window'] = firstScannedInWindow;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (includeGhostResources !== undefined) {
                                localVarQueryParameter['include_ghost_resources'] = includeGhostResources;
                            }
                            if (inHold !== undefined) {
                                localVarQueryParameter['in_hold'] = inHold;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint triggers the start of a measuring task for a given package in a specific machine, the user needs to have one of the following permissions:  * `OPERATORTOOL_MEASURING`;
         * @summary Measure package endpoint.
         * @param {PackageMeasurement} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesMeasure: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesMeasure', 'data', data);
                            localVarPath = "/packages/measure/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Package by ID*
         * @summary Patch Package
         * @param {number} id A unique integer value identifying this package.
         * @param {PackageDetails} data
         * @param {boolean} [force] Force action
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesPartialUpdate: function (id, data, force, scan, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesPartialUpdate', 'data', data);
                            localVarPath = "/packages/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            if (scan !== undefined) {
                                localVarQueryParameter['scan'] = scan;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows a User to get a single Package in the CloudSort System.  As for its parameters: * It requires a unique ID to identify an individual Package; * A \'scan=true\' flag can be passed by to mark the Package as scanned. This is used to distinguish when the User is physically scanning the Package\'s barcode (registered event) from when the User is only consulting the Package\'s data through any other form.
         * @summary Retrieve Package
         * @param {number} id A unique integer value identifying this package.
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRead: function (id, scan, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesRead', 'id', id);
                            localVarPath = "/packages/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (scan !== undefined) {
                                localVarQueryParameter['scan'] = scan;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint changes the carrier and produces a new tracking number for a Package by ID. It also retrieves an updated label.
         * @summary Change carrier and retrieve new label
         * @param {number} id A unique integer value identifying this package.
         * @param {PackageRelabel} data
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabel: function (id, data, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesRelabel', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('packagesRelabel', 'data', data);
                            localVarPath = "/packages/{id}/relabel/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the providers that can be used with the relabel request.
         * @summary Retrieve authorized relabel providers.
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabelRelabelProviders: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('packagesRelabelRelabelProviders', 'id', id);
                            localVarPath = "/packages/{id}/relabel/providers/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PackagesApiAxiosParamCreator = PackagesApiAxiosParamCreator;
/**
 * PackagesApi - functional programming interface
 * @export
 */
var PackagesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PackagesApiAxiosParamCreator)(configuration);
    return {
        /**
         * This returns aggregate data from the list of packages that match the specified parameters. The datapoints returned are the number of packages \'count\' and the total volume of the packages \'volume\'. This endpoint uses the same parameters as the `list` endpoint.
         * @summary Get aggregate data from the list of Packages.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesAggregatedataSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesAggregatedataDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesAggregatedataProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesAggregatedataExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {string} [fromDate] Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} [toDate] Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesAggregatedata: function (page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesAggregatedata(page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesAggregatedata']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PDF of the Commercial Invoice for a Package by ID if the corresponding providers configured via the Customer Centric Configurations provides it.
         * @summary Get the PDF Commercial Invoice for a Package via Providers.
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCommercialinvoicePdf: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesCommercialinvoicePdf(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesCommercialinvoicePdf']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows a User to create a package in the CloudSort system, registering it and its properties, as well as generating tracking and vendor related data. Once a package is created, it can be shipped (and optionally manifested) to a CloudSort Facility using a custom label or the label data provided by the CloudSort system.  The packages are identified by their tracking number while being processed in CloudSort Facilities. Tracking numbers must appear on custom labels.  To allow richer integration scenarios, it is possible to send an \"external tracking number\" alongside the package properties while creating the package.
         * @summary Create Package
         * @param {PackageCreation} data
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCreate: function (data, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesCreate(data, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a single csv file with rows representing packages with all their data.
         * @summary Get package list as CSV
         * @param {string} fromDate Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} toDate Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesCsvSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesCsvDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesCsvProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesCsvExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {Array<string>} [includeLabels] The extra data labels to include in the response. The format is expected to be a comma-separated list of strings, with optional alias definition. Example: &#x60;include_labels&#x3D;some.label.key-no-alias,label.key|alias&#x60;. As seen, the alias can be provided separated via a | character.
         * @param {boolean} [eventTimes] Extends CSV file columns to include Scan, Load and Dispatch time stamps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCsv: function (fromDate, toDate, page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, includeLabels, eventTimes, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesCsv(fromDate, toDate, page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, includeLabels, eventTimes, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Package by ID*
         * @summary Delete Package
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint parses an incoming 2D bar code. Returns a package if a package exists with given barcode, otherwise will create a new package at ARRIVED.
         * @summary Parse external bar code.
         * @param {PackageExternalBarCode} data
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesFromexternalbarcode: function (data, scan, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesFromexternalbarcode(data, scan, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesFromexternalbarcode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Allow to perform package actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {PackageGeneric} data
         * @param {boolean} [force] Force action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesGeneric: function (data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesGeneric(data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesGeneric']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a csv file where each row represents a holding reason with the information of the package that has it. If a package has multiple holding reasons, there will be multiple rows for that package.
         * @summary Get packages with holding reasons in CSV format.
         * @param {PackagesHoldReasonsCsvSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsCsvScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsCsvSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsCsvStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsCsv: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesHoldReasonsCsv(source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesHoldReasonsCsv']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * List all packages with holding reasons.
         * @param {PackagesHoldReasonsListSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsListScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsListSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsListStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsList: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesHoldReasonsList(source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesHoldReasonsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get stats about packages with holding reasons.
         * @param {PackagesHoldReasonsStatsSourceEnum} [source] Filter the hold reasons by the source of the hold.
         * @param {number} [inboundLoad] Filter to the packages that are part of the inbound load.
         * @param {number} [owner] Filter the packages with the given owner.
         * @param {number} [carrier] Filter the packages with the given final mile carrier.
         * @param {number} [station] Filter the packages with the given station.
         * @param {string} [reason] Filter the hold reasons by the code.
         * @param {string} [trackingNumber] Filter the packages by the tracking number.
         * @param {PackagesHoldReasonsStatsScopeEnum} [scope] Filter the hold reasons by the scope of the hold.
         * @param {string} [fromDate] Only get the packages with holds modified on or after the given date.
         * @param {string} [toDate] Only get the packages with holds modified on or before the given date.
         * @param {PackagesHoldReasonsStatsSortByEnum} [sortBy]
         * @param {PackagesHoldReasonsStatsStatusEnum} [status] Filter the packages by the status of the holds. If the value is &#x60;RESOLVED&#x60;, only get the packages with all holds resolved. If the value is &#x60;RESOLVED_DISPATCHED&#x60;, only get the packages with all holds resolved and that already have been dispatched. Otherwise, get all the packages with hold reasons.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsStats: function (source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesHoldReasonsStats(source, inboundLoad, owner, carrier, station, reason, trackingNumber, scope, fromDate, toDate, sortBy, status, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesHoldReasonsStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Package by ID.
         * @summary Get the PNG label for a Package
         * @param {number} id A unique integer value identifying this package.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Package by ID.
         * @summary Get the ZPL label for a Package
         * @param {number} id A unique integer value identifying this package.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This API provides access to a list of packages, the shipping products of the CloudSort System. The endpoint provides detailed information about the package\'s current location, its destination and other relevant information. The endpoint also permits time-based slicing of the returned data to ensure easy access to a set of packages. The time-based filters `from_date` and `to_date` behave as follows:  * Providing a `from_date` prompts the API to filter the packages to contain only packages that had an interaction within the last 7 days counting back from the provided `from_date`. If a package has been dispatched from the CloudSort Facility before `from_date` it is also excluded. Therefore, `from_date` contains __all__ packages that are currently being processed by a CloudSort Facility on that date. This behavior is modified by providing `hide_pending=true`, which sets the lookback period to zero, and the resulting list only contains packages that had an interaction after the `from_date`.  * Providing a `to_date` has a different side-effect, in which the packages state is wound backwards to the given date, so the returned data provides a snapshot of the past (please note that setting a `to_date` can slow down the response time of the endpoint).  For tracking purposes, the API provides the following parameters to identify packages: * `tracking_number` - the Carrier\'s tracking number * `external_tracking_number` - the Customers/Shippers internal id
         * @summary List Packages
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [trackingNumber] Filter the result to the given Tracking Number.
         * @param {string} [externalTrackingNumber] Filter the result to the given Shipper Tracking Number.
         * @param {Array<number>} [carrier] Filter the result to the given [Carrier ID](#operation/fmcs_list).
         * @param {Array<number>} [owner] Filter the result to the given [Customer ID](#operation/customers_list).
         * @param {Array<number>} [manifest] Filter the result to the given [Manifest ID](#operation/manifests_inbound).
         * @param {Array<number>} [container] Filter the result to the given Container ID.The specified ids will be used to filter by both &#x60;container&#x60; and &#x60;inbound_container&#x60; fields.
         * @param {boolean} [hidePending] Limit the result to only contain packages with interactions after the &#x60;from_date&#x60;. This parameter only takes effect if &#x60;from_date&#x60; is also provided.
         * @param {PackagesListSortByEnum} [sortBy] Property by which to order the result set, default to &#x60;process_step_time&#x60; which relates to the last interaction with the package. Use the &#x60;-&#x60; prefix to change the sort direction from ascending to descending.
         * @param {boolean} [isManifested] Limit the result to only packages that have been manifested to CloudSort.
         * @param {boolean} [isScanned] Limit the result to only packages that have been scanned in a CloudSort Facility.
         * @param {boolean} [isLoaded] Limit the result to only packages that have been loaded in a CloudSort Facility.
         * @param {boolean} [isArrived] Limit the result to only packages that have been physically arrived at a CloudSort Facility.
         * @param {boolean} [isDispatched] Limit the result to only packages that have been dispatched from a CloudSort Facility.
         * @param {boolean} [isUnprocessable] Limit the result to only packages that have been marked as unprocessable. Unprocessable  means the package is missing information required for processing, such as ZIP Code or carrier data
         * @param {boolean} [inSystem] Limit the result to only packages that are currently being processed in a CloudSort Facility (post arrived, pre dispatched).
         * @param {boolean} [isMissorted] Internal: Limit the result to only packages that have been containerized into a container different from theactual planned container.
         * @param {boolean} [isMisloaded] Internal: Limit the result to only packages that have been loaded to a load different from the actually planned destination.
         * @param {Array<PackagesListDefectsEnum>} [defects] Internal: Limit the result to only packages that have been marked with the given defects. This provides a combination of the &#x60;is_missorted&#x60;, &#x60;is_misloaded&#x60; and &#x60;is_unprocessable&#x60; filters.
         * @param {Array<PackagesListProcessStepEnum>} [processStep] Internal: Limit the result to only packages that are currently in the given process step. A process step is a tracking information of progress through a CloudSort Facility.
         * @param {Array<PackagesListExcludeProcessStepEnum>} [excludeProcessStep] Internal: Exclude packages with the given process step, see &#x60;process_step&#x60; filter for more details.
         * @param {Array<number>} [destination] Internal: Target stop ID
         * @param {Array<number>} [route] Internal: Target route ID
         * @param {Array<number>} [inboundLoad] Internal: List of Inbound Load IDs
         * @param {boolean} [inboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {Array<number>} [outboundLoad] Internal: Outbound Load ID
         * @param {boolean} [outboundLoadDirect] Internal: Display individually loaded packages if true
         * @param {boolean} [firstScannedInWindow] Display packages scanned for the first time in window if true
         * @param {number} [station] Internal: Station ID
         * @param {number} [area] Internal: Area ID
         * @param {boolean} [includeGhostResources] Internal: Show Ghost packages
         * @param {boolean} [inHold] Exposes only Packages that are currently in hold.
         * @param {string} [fromDate] Limit the result to only contain packages with interactions within X days of the given date. Note that X depends on the given stations configuration, the default is typically 7 days
         * @param {string} [toDate] Limit the result to only contain packages available before the given date. Note that the package\&#39;s properties are wound back in time, providing a past state of the package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesList: function (page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesList(page, pageSize, trackingNumber, externalTrackingNumber, carrier, owner, manifest, container, hidePending, sortBy, isManifested, isScanned, isLoaded, isArrived, isDispatched, isUnprocessable, inSystem, isMissorted, isMisloaded, defects, processStep, excludeProcessStep, destination, route, inboundLoad, inboundLoadDirect, outboundLoad, outboundLoadDirect, firstScannedInWindow, station, area, includeGhostResources, inHold, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint triggers the start of a measuring task for a given package in a specific machine, the user needs to have one of the following permissions:  * `OPERATORTOOL_MEASURING`;
         * @summary Measure package endpoint.
         * @param {PackageMeasurement} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesMeasure: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesMeasure(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesMeasure']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Package by ID*
         * @summary Patch Package
         * @param {number} id A unique integer value identifying this package.
         * @param {PackageDetails} data
         * @param {boolean} [force] Force action
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesPartialUpdate: function (id, data, force, scan, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesPartialUpdate(id, data, force, scan, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows a User to get a single Package in the CloudSort System.  As for its parameters: * It requires a unique ID to identify an individual Package; * A \'scan=true\' flag can be passed by to mark the Package as scanned. This is used to distinguish when the User is physically scanning the Package\'s barcode (registered event) from when the User is only consulting the Package\'s data through any other form.
         * @summary Retrieve Package
         * @param {number} id A unique integer value identifying this package.
         * @param {boolean} [scan] Scan Action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRead: function (id, scan, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesRead(id, scan, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint changes the carrier and produces a new tracking number for a Package by ID. It also retrieves an updated label.
         * @summary Change carrier and retrieve new label
         * @param {number} id A unique integer value identifying this package.
         * @param {PackageRelabel} data
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabel: function (id, data, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesRelabel(id, data, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesRelabel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the providers that can be used with the relabel request.
         * @summary Retrieve authorized relabel providers.
         * @param {number} id A unique integer value identifying this package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabelRelabelProviders: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.packagesRelabelRelabelProviders(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PackagesApi.packagesRelabelRelabelProviders']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PackagesApiFp = PackagesApiFp;
/**
 * PackagesApi - factory interface
 * @export
 */
var PackagesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PackagesApiFp)(configuration);
    return {
        /**
         * This returns aggregate data from the list of packages that match the specified parameters. The datapoints returned are the number of packages \'count\' and the total volume of the packages \'volume\'. This endpoint uses the same parameters as the `list` endpoint.
         * @summary Get aggregate data from the list of Packages.
         * @param {PackagesApiPackagesAggregatedataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesAggregatedata: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.packagesAggregatedata(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PDF of the Commercial Invoice for a Package by ID if the corresponding providers configured via the Customer Centric Configurations provides it.
         * @summary Get the PDF Commercial Invoice for a Package via Providers.
         * @param {PackagesApiPackagesCommercialinvoicePdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCommercialinvoicePdf: function (requestParameters, options) {
            return localVarFp.packagesCommercialinvoicePdf(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a User to create a package in the CloudSort system, registering it and its properties, as well as generating tracking and vendor related data. Once a package is created, it can be shipped (and optionally manifested) to a CloudSort Facility using a custom label or the label data provided by the CloudSort system.  The packages are identified by their tracking number while being processed in CloudSort Facilities. Tracking numbers must appear on custom labels.  To allow richer integration scenarios, it is possible to send an \"external tracking number\" alongside the package properties while creating the package.
         * @summary Create Package
         * @param {PackagesApiPackagesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCreate: function (requestParameters, options) {
            return localVarFp.packagesCreate(requestParameters.data, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single csv file with rows representing packages with all their data.
         * @summary Get package list as CSV
         * @param {PackagesApiPackagesCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesCsv: function (requestParameters, options) {
            return localVarFp.packagesCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.includeLabels, requestParameters.eventTimes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Package by ID*
         * @summary Delete Package
         * @param {PackagesApiPackagesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesDelete: function (requestParameters, options) {
            return localVarFp.packagesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint parses an incoming 2D bar code. Returns a package if a package exists with given barcode, otherwise will create a new package at ARRIVED.
         * @summary Parse external bar code.
         * @param {PackagesApiPackagesFromexternalbarcodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesFromexternalbarcode: function (requestParameters, options) {
            return localVarFp.packagesFromexternalbarcode(requestParameters.data, requestParameters.scan, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Allow to perform package actions, independent from their nature with a single PATCH.
         * @summary Generic patch endpoint.
         * @param {PackagesApiPackagesGenericRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesGeneric: function (requestParameters, options) {
            return localVarFp.packagesGeneric(requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a csv file where each row represents a holding reason with the information of the package that has it. If a package has multiple holding reasons, there will be multiple rows for that package.
         * @summary Get packages with holding reasons in CSV format.
         * @param {PackagesApiPackagesHoldReasonsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsCsv: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.packagesHoldReasonsCsv(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List all packages with holding reasons.
         * @param {PackagesApiPackagesHoldReasonsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.packagesHoldReasonsList(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get stats about packages with holding reasons.
         * @param {PackagesApiPackagesHoldReasonsStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesHoldReasonsStats: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.packagesHoldReasonsStats(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Package by ID.
         * @summary Get the PNG label for a Package
         * @param {PackagesApiPackagesLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelPng: function (requestParameters, options) {
            return localVarFp.packagesLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Package by ID.
         * @summary Get the ZPL label for a Package
         * @param {PackagesApiPackagesLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.packagesLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This API provides access to a list of packages, the shipping products of the CloudSort System. The endpoint provides detailed information about the package\'s current location, its destination and other relevant information. The endpoint also permits time-based slicing of the returned data to ensure easy access to a set of packages. The time-based filters `from_date` and `to_date` behave as follows:  * Providing a `from_date` prompts the API to filter the packages to contain only packages that had an interaction within the last 7 days counting back from the provided `from_date`. If a package has been dispatched from the CloudSort Facility before `from_date` it is also excluded. Therefore, `from_date` contains __all__ packages that are currently being processed by a CloudSort Facility on that date. This behavior is modified by providing `hide_pending=true`, which sets the lookback period to zero, and the resulting list only contains packages that had an interaction after the `from_date`.  * Providing a `to_date` has a different side-effect, in which the packages state is wound backwards to the given date, so the returned data provides a snapshot of the past (please note that setting a `to_date` can slow down the response time of the endpoint).  For tracking purposes, the API provides the following parameters to identify packages: * `tracking_number` - the Carrier\'s tracking number * `external_tracking_number` - the Customers/Shippers internal id
         * @summary List Packages
         * @param {PackagesApiPackagesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.packagesList(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint triggers the start of a measuring task for a given package in a specific machine, the user needs to have one of the following permissions:  * `OPERATORTOOL_MEASURING`;
         * @summary Measure package endpoint.
         * @param {PackagesApiPackagesMeasureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesMeasure: function (requestParameters, options) {
            return localVarFp.packagesMeasure(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Package by ID*
         * @summary Patch Package
         * @param {PackagesApiPackagesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesPartialUpdate: function (requestParameters, options) {
            return localVarFp.packagesPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.scan, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows a User to get a single Package in the CloudSort System.  As for its parameters: * It requires a unique ID to identify an individual Package; * A \'scan=true\' flag can be passed by to mark the Package as scanned. This is used to distinguish when the User is physically scanning the Package\'s barcode (registered event) from when the User is only consulting the Package\'s data through any other form.
         * @summary Retrieve Package
         * @param {PackagesApiPackagesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRead: function (requestParameters, options) {
            return localVarFp.packagesRead(requestParameters.id, requestParameters.scan, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint changes the carrier and produces a new tracking number for a Package by ID. It also retrieves an updated label.
         * @summary Change carrier and retrieve new label
         * @param {PackagesApiPackagesRelabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabel: function (requestParameters, options) {
            return localVarFp.packagesRelabel(requestParameters.id, requestParameters.data, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the providers that can be used with the relabel request.
         * @summary Retrieve authorized relabel providers.
         * @param {PackagesApiPackagesRelabelRelabelProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packagesRelabelRelabelProviders: function (requestParameters, options) {
            return localVarFp.packagesRelabelRelabelProviders(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PackagesApiFactory = PackagesApiFactory;
/**
 * PackagesApi - object-oriented interface
 * @export
 * @class PackagesApi
 * @extends {BaseAPI}
 */
var PackagesApi = /** @class */ (function (_super) {
    __extends(PackagesApi, _super);
    function PackagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This returns aggregate data from the list of packages that match the specified parameters. The datapoints returned are the number of packages \'count\' and the total volume of the packages \'volume\'. This endpoint uses the same parameters as the `list` endpoint.
     * @summary Get aggregate data from the list of Packages.
     * @param {PackagesApiPackagesAggregatedataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesAggregatedata = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PackagesApiFp)(this.configuration).packagesAggregatedata(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PDF of the Commercial Invoice for a Package by ID if the corresponding providers configured via the Customer Centric Configurations provides it.
     * @summary Get the PDF Commercial Invoice for a Package via Providers.
     * @param {PackagesApiPackagesCommercialinvoicePdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesCommercialinvoicePdf = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesCommercialinvoicePdf(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a User to create a package in the CloudSort system, registering it and its properties, as well as generating tracking and vendor related data. Once a package is created, it can be shipped (and optionally manifested) to a CloudSort Facility using a custom label or the label data provided by the CloudSort system.  The packages are identified by their tracking number while being processed in CloudSort Facilities. Tracking numbers must appear on custom labels.  To allow richer integration scenarios, it is possible to send an \"external tracking number\" alongside the package properties while creating the package.
     * @summary Create Package
     * @param {PackagesApiPackagesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesCreate(requestParameters.data, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single csv file with rows representing packages with all their data.
     * @summary Get package list as CSV
     * @param {PackagesApiPackagesCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesCsv = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesCsv(requestParameters.fromDate, requestParameters.toDate, requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.includeLabels, requestParameters.eventTimes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Package by ID*
     * @summary Delete Package
     * @param {PackagesApiPackagesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint parses an incoming 2D bar code. Returns a package if a package exists with given barcode, otherwise will create a new package at ARRIVED.
     * @summary Parse external bar code.
     * @param {PackagesApiPackagesFromexternalbarcodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesFromexternalbarcode = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesFromexternalbarcode(requestParameters.data, requestParameters.scan, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Allow to perform package actions, independent from their nature with a single PATCH.
     * @summary Generic patch endpoint.
     * @param {PackagesApiPackagesGenericRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesGeneric = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesGeneric(requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a csv file where each row represents a holding reason with the information of the package that has it. If a package has multiple holding reasons, there will be multiple rows for that package.
     * @summary Get packages with holding reasons in CSV format.
     * @param {PackagesApiPackagesHoldReasonsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesHoldReasonsCsv = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PackagesApiFp)(this.configuration).packagesHoldReasonsCsv(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List all packages with holding reasons.
     * @param {PackagesApiPackagesHoldReasonsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesHoldReasonsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PackagesApiFp)(this.configuration).packagesHoldReasonsList(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get stats about packages with holding reasons.
     * @param {PackagesApiPackagesHoldReasonsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesHoldReasonsStats = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PackagesApiFp)(this.configuration).packagesHoldReasonsStats(requestParameters.source, requestParameters.inboundLoad, requestParameters.owner, requestParameters.carrier, requestParameters.station, requestParameters.reason, requestParameters.trackingNumber, requestParameters.scope, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.status, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Package by ID.
     * @summary Get the PNG label for a Package
     * @param {PackagesApiPackagesLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label as JSON for a Package by ID.
     * @summary Get the ZPL label for a Package
     * @param {PackagesApiPackagesLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This API provides access to a list of packages, the shipping products of the CloudSort System. The endpoint provides detailed information about the package\'s current location, its destination and other relevant information. The endpoint also permits time-based slicing of the returned data to ensure easy access to a set of packages. The time-based filters `from_date` and `to_date` behave as follows:  * Providing a `from_date` prompts the API to filter the packages to contain only packages that had an interaction within the last 7 days counting back from the provided `from_date`. If a package has been dispatched from the CloudSort Facility before `from_date` it is also excluded. Therefore, `from_date` contains __all__ packages that are currently being processed by a CloudSort Facility on that date. This behavior is modified by providing `hide_pending=true`, which sets the lookback period to zero, and the resulting list only contains packages that had an interaction after the `from_date`.  * Providing a `to_date` has a different side-effect, in which the packages state is wound backwards to the given date, so the returned data provides a snapshot of the past (please note that setting a `to_date` can slow down the response time of the endpoint).  For tracking purposes, the API provides the following parameters to identify packages: * `tracking_number` - the Carrier\'s tracking number * `external_tracking_number` - the Customers/Shippers internal id
     * @summary List Packages
     * @param {PackagesApiPackagesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PackagesApiFp)(this.configuration).packagesList(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumber, requestParameters.externalTrackingNumber, requestParameters.carrier, requestParameters.owner, requestParameters.manifest, requestParameters.container, requestParameters.hidePending, requestParameters.sortBy, requestParameters.isManifested, requestParameters.isScanned, requestParameters.isLoaded, requestParameters.isArrived, requestParameters.isDispatched, requestParameters.isUnprocessable, requestParameters.inSystem, requestParameters.isMissorted, requestParameters.isMisloaded, requestParameters.defects, requestParameters.processStep, requestParameters.excludeProcessStep, requestParameters.destination, requestParameters.route, requestParameters.inboundLoad, requestParameters.inboundLoadDirect, requestParameters.outboundLoad, requestParameters.outboundLoadDirect, requestParameters.firstScannedInWindow, requestParameters.station, requestParameters.area, requestParameters.includeGhostResources, requestParameters.inHold, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint triggers the start of a measuring task for a given package in a specific machine, the user needs to have one of the following permissions:  * `OPERATORTOOL_MEASURING`;
     * @summary Measure package endpoint.
     * @param {PackagesApiPackagesMeasureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesMeasure = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesMeasure(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Package by ID*
     * @summary Patch Package
     * @param {PackagesApiPackagesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.force, requestParameters.scan, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows a User to get a single Package in the CloudSort System.  As for its parameters: * It requires a unique ID to identify an individual Package; * A \'scan=true\' flag can be passed by to mark the Package as scanned. This is used to distinguish when the User is physically scanning the Package\'s barcode (registered event) from when the User is only consulting the Package\'s data through any other form.
     * @summary Retrieve Package
     * @param {PackagesApiPackagesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesRead(requestParameters.id, requestParameters.scan, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint changes the carrier and produces a new tracking number for a Package by ID. It also retrieves an updated label.
     * @summary Change carrier and retrieve new label
     * @param {PackagesApiPackagesRelabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesRelabel = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesRelabel(requestParameters.id, requestParameters.data, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the providers that can be used with the relabel request.
     * @summary Retrieve authorized relabel providers.
     * @param {PackagesApiPackagesRelabelRelabelProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackagesApi
     */
    PackagesApi.prototype.packagesRelabelRelabelProviders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PackagesApiFp)(this.configuration).packagesRelabelRelabelProviders(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PackagesApi;
}(base_1.BaseAPI));
exports.PackagesApi = PackagesApi;
/**
 * @export
 */
exports.PackagesAggregatedataSortByEnum = {
    ID: 'id',
    PROCESS_STEP_TIME: 'process_step_time',
    OUTBOUND_LOAD_ID: 'outbound_load_id',
    CONTAINER_ID: 'container_id',
    ID2: '-id',
    PROCESS_STEP_TIME2: '-process_step_time',
    OUTBOUND_LOAD_ID2: '-outbound_load_id',
    CONTAINER_ID2: '-container_id'
};
/**
 * @export
 */
exports.PackagesAggregatedataDefectsEnum = {
    MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    RETURNED: 'EXCEPTION_RETURNED',
    RELABELED: 'EXCEPTION_RELABELED',
    MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO'
};
/**
 * @export
 */
exports.PackagesAggregatedataProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.PackagesAggregatedataExcludeProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.PackagesCsvSortByEnum = {
    ID: 'id',
    PROCESS_STEP_TIME: 'process_step_time',
    OUTBOUND_LOAD_ID: 'outbound_load_id',
    CONTAINER_ID: 'container_id',
    ID2: '-id',
    PROCESS_STEP_TIME2: '-process_step_time',
    OUTBOUND_LOAD_ID2: '-outbound_load_id',
    CONTAINER_ID2: '-container_id'
};
/**
 * @export
 */
exports.PackagesCsvDefectsEnum = {
    MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    RETURNED: 'EXCEPTION_RETURNED',
    RELABELED: 'EXCEPTION_RELABELED',
    MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO'
};
/**
 * @export
 */
exports.PackagesCsvProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.PackagesCsvExcludeProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.PackagesHoldReasonsCsvSourceEnum = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
};
/**
 * @export
 */
exports.PackagesHoldReasonsCsvScopeEnum = {
    SYSTEM: 'SYSTEM',
    CUSTOMER: 'CUSTOMER'
};
/**
 * @export
 */
exports.PackagesHoldReasonsCsvSortByEnum = {
    CREATED_ON: 'created_on',
    CREATED_ON2: '-created_on',
    SCOPE: 'scope',
    SCOPE2: '-scope',
    OWNER: 'owner',
    OWNER2: '-owner',
    CARRIER: 'carrier',
    CARRIER2: '-carrier',
    STATION: 'station',
    STATION2: '-station'
};
/**
 * @export
 */
exports.PackagesHoldReasonsCsvStatusEnum = {
    UNRESOLVED: 'UNRESOLVED',
    RESOLVED: 'RESOLVED',
    RESOLVED_DISPATCHED: 'RESOLVED_DISPATCHED'
};
/**
 * @export
 */
exports.PackagesHoldReasonsListSourceEnum = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
};
/**
 * @export
 */
exports.PackagesHoldReasonsListScopeEnum = {
    SYSTEM: 'SYSTEM',
    CUSTOMER: 'CUSTOMER'
};
/**
 * @export
 */
exports.PackagesHoldReasonsListSortByEnum = {
    CREATED_ON: 'created_on',
    CREATED_ON2: '-created_on',
    SCOPE: 'scope',
    SCOPE2: '-scope',
    OWNER: 'owner',
    OWNER2: '-owner',
    CARRIER: 'carrier',
    CARRIER2: '-carrier',
    STATION: 'station',
    STATION2: '-station'
};
/**
 * @export
 */
exports.PackagesHoldReasonsListStatusEnum = {
    UNRESOLVED: 'UNRESOLVED',
    RESOLVED: 'RESOLVED',
    RESOLVED_DISPATCHED: 'RESOLVED_DISPATCHED'
};
/**
 * @export
 */
exports.PackagesHoldReasonsStatsSourceEnum = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
};
/**
 * @export
 */
exports.PackagesHoldReasonsStatsScopeEnum = {
    SYSTEM: 'SYSTEM',
    CUSTOMER: 'CUSTOMER'
};
/**
 * @export
 */
exports.PackagesHoldReasonsStatsSortByEnum = {
    CREATED_ON: 'created_on',
    CREATED_ON2: '-created_on',
    SCOPE: 'scope',
    SCOPE2: '-scope',
    OWNER: 'owner',
    OWNER2: '-owner',
    CARRIER: 'carrier',
    CARRIER2: '-carrier',
    STATION: 'station',
    STATION2: '-station'
};
/**
 * @export
 */
exports.PackagesHoldReasonsStatsStatusEnum = {
    UNRESOLVED: 'UNRESOLVED',
    RESOLVED: 'RESOLVED',
    RESOLVED_DISPATCHED: 'RESOLVED_DISPATCHED'
};
/**
 * @export
 */
exports.PackagesListSortByEnum = {
    ID: 'id',
    PROCESS_STEP_TIME: 'process_step_time',
    OUTBOUND_LOAD_ID: 'outbound_load_id',
    CONTAINER_ID: 'container_id',
    ID2: '-id',
    PROCESS_STEP_TIME2: '-process_step_time',
    OUTBOUND_LOAD_ID2: '-outbound_load_id',
    CONTAINER_ID2: '-container_id'
};
/**
 * @export
 */
exports.PackagesListDefectsEnum = {
    MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    RETURNED: 'EXCEPTION_RETURNED',
    RELABELED: 'EXCEPTION_RELABELED',
    MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO'
};
/**
 * @export
 */
exports.PackagesListProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * @export
 */
exports.PackagesListExcludeProcessStepEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * ProbesApi - axios parameter creator
 * @export
 */
var ProbesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Return 200 if system depdencies are live.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesLiveness: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/probes/liveness";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return empty 200.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesReadiness: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/probes/readiness";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Trigger a chaos flag
         * @param {TriggerChaosFlag} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerChaos: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('triggerChaos', 'data', data);
                            localVarPath = "/probes/triggers/chaosflag";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProbesApiAxiosParamCreator = ProbesApiAxiosParamCreator;
/**
 * ProbesApi - functional programming interface
 * @export
 */
var ProbesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProbesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Return 200 if system depdencies are live.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesLiveness: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.probesLiveness(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProbesApi.probesLiveness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return empty 200.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesReadiness: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.probesReadiness(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProbesApi.probesReadiness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Trigger a chaos flag
         * @param {TriggerChaosFlag} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerChaos: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerChaos(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProbesApi.triggerChaos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ProbesApiFp = ProbesApiFp;
/**
 * ProbesApi - factory interface
 * @export
 */
var ProbesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProbesApiFp)(configuration);
    return {
        /**
         * Return 200 if system depdencies are live.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesLiveness: function (options) {
            return localVarFp.probesLiveness(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return empty 200.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        probesReadiness: function (options) {
            return localVarFp.probesReadiness(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Trigger a chaos flag
         * @param {ProbesApiTriggerChaosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerChaos: function (requestParameters, options) {
            return localVarFp.triggerChaos(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProbesApiFactory = ProbesApiFactory;
/**
 * ProbesApi - object-oriented interface
 * @export
 * @class ProbesApi
 * @extends {BaseAPI}
 */
var ProbesApi = /** @class */ (function (_super) {
    __extends(ProbesApi, _super);
    function ProbesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return 200 if system depdencies are live.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProbesApi
     */
    ProbesApi.prototype.probesLiveness = function (options) {
        var _this = this;
        return (0, exports.ProbesApiFp)(this.configuration).probesLiveness(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return empty 200.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProbesApi
     */
    ProbesApi.prototype.probesReadiness = function (options) {
        var _this = this;
        return (0, exports.ProbesApiFp)(this.configuration).probesReadiness(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Trigger a chaos flag
     * @param {ProbesApiTriggerChaosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProbesApi
     */
    ProbesApi.prototype.triggerChaos = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProbesApiFp)(this.configuration).triggerChaos(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProbesApi;
}(base_1.BaseAPI));
exports.ProbesApi = ProbesApi;
/**
 * PublicApi - axios parameter creator
 * @export
 */
var PublicApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoints updates a container by id, if the user requesting it is the owner of the container and the container is in a state that allow updates: [\"CLOSED\", \"STAGED\", \"LOADED\"].
         * @summary Update Container
         * @param {string} id
         * @param {PublicContainerSerializer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('publicContainersPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('publicContainersPartialUpdate', 'data', data);
                            localVarPath = "/public/containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint retrieves a container by id, if the user requesting it is the owner of the container.
         * @summary Retrieve Container
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('publicContainersRead', 'id', id);
                            localVarPath = "/public/containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PublicApiAxiosParamCreator = PublicApiAxiosParamCreator;
/**
 * PublicApi - functional programming interface
 * @export
 */
var PublicApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PublicApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoints updates a container by id, if the user requesting it is the owner of the container and the container is in a state that allow updates: [\"CLOSED\", \"STAGED\", \"LOADED\"].
         * @summary Update Container
         * @param {string} id
         * @param {PublicContainerSerializer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publicContainersPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicApi.publicContainersPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint retrieves a container by id, if the user requesting it is the owner of the container.
         * @summary Retrieve Container
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publicContainersRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PublicApi.publicContainersRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PublicApiFp = PublicApiFp;
/**
 * PublicApi - factory interface
 * @export
 */
var PublicApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PublicApiFp)(configuration);
    return {
        /**
         * This endpoints updates a container by id, if the user requesting it is the owner of the container and the container is in a state that allow updates: [\"CLOSED\", \"STAGED\", \"LOADED\"].
         * @summary Update Container
         * @param {PublicApiPublicContainersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersPartialUpdate: function (requestParameters, options) {
            return localVarFp.publicContainersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint retrieves a container by id, if the user requesting it is the owner of the container.
         * @summary Retrieve Container
         * @param {PublicApiPublicContainersReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicContainersRead: function (requestParameters, options) {
            return localVarFp.publicContainersRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PublicApiFactory = PublicApiFactory;
/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
var PublicApi = /** @class */ (function (_super) {
    __extends(PublicApi, _super);
    function PublicApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoints updates a container by id, if the user requesting it is the owner of the container and the container is in a state that allow updates: [\"CLOSED\", \"STAGED\", \"LOADED\"].
     * @summary Update Container
     * @param {PublicApiPublicContainersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    PublicApi.prototype.publicContainersPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PublicApiFp)(this.configuration).publicContainersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint retrieves a container by id, if the user requesting it is the owner of the container.
     * @summary Retrieve Container
     * @param {PublicApiPublicContainersReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    PublicApi.prototype.publicContainersRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PublicApiFp)(this.configuration).publicContainersRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PublicApi;
}(base_1.BaseAPI));
exports.PublicApi = PublicApi;
/**
 * ReportsApi - axios parameter creator
 * @export
 */
var ReportsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns a Report on the Event Intervals of Cloudsort. The computed dataset contains the aggregated intervals between any two events specified as origin and target aligned on their respective owning resource, e.g. the times between arrived and dispatched would be calculated between containers and packages individually and then averaged out over the requested grouping. Further filtering can be applied to scope the returned dataset by station, area, zone, outbound load, container and package, as well as time-wise limit the result to a from/to range.
         * @summary Get a Report on the Event Intervals
         * @param {ReportsDatasetsEventintervalsListOriginEventEnum} originEvent Origin Event
         * @param {ReportsDatasetsEventintervalsListTargetEventEnum} targetEvent Target Event
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area
         * @param {number} [zone] Scope: Zone
         * @param {number} [outboundLoad] Scope: Outbound Load
         * @param {number} [container] Scope: Container
         * @param {number} [_package] Scope: Package
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsEventintervalsList: function (originEvent, targetEvent, station, area, zone, outboundLoad, container, _package, owner, carrier, destination, route, groupBy, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'originEvent' is not null or undefined
                            (0, common_1.assertParamExists)('reportsDatasetsEventintervalsList', 'originEvent', originEvent);
                            // verify required parameter 'targetEvent' is not null or undefined
                            (0, common_1.assertParamExists)('reportsDatasetsEventintervalsList', 'targetEvent', targetEvent);
                            localVarPath = "/reports/datasets/eventintervals/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (outboundLoad !== undefined) {
                                localVarQueryParameter['outbound_load'] = outboundLoad;
                            }
                            if (container !== undefined) {
                                localVarQueryParameter['container'] = container;
                            }
                            if (_package !== undefined) {
                                localVarQueryParameter['package'] = _package;
                            }
                            if (originEvent !== undefined) {
                                localVarQueryParameter['origin_event'] = originEvent;
                            }
                            if (targetEvent !== undefined) {
                                localVarQueryParameter['target_event'] = targetEvent;
                            }
                            if (owner) {
                                localVarQueryParameter['owner'] = owner.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (groupBy !== undefined) {
                                localVarQueryParameter['group_by'] = groupBy;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a Report on the Expected Influx of Cloudsort. The returned dataset aggregates the number of expected packages by weight/volume or count over the requested time period and station.
         * @summary Get a Report on the Expected Influx
         * @param {ReportsDatasetsExpectedinfluxListInfluxTypeEnum} influxType Influx Type
         * @param {number} [station] Scope: Station
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsExpectedinfluxList: function (influxType, station, groupBy, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'influxType' is not null or undefined
                            (0, common_1.assertParamExists)('reportsDatasetsExpectedinfluxList', 'influxType', influxType);
                            localVarPath = "/reports/datasets/expectedinflux/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (influxType !== undefined) {
                                localVarQueryParameter['influx_type'] = influxType;
                            }
                            if (groupBy !== undefined) {
                                localVarQueryParameter['group_by'] = groupBy;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This returns a Report on the performance of Cloudsort. Performance is measured by the amount of time required to get a package or amount of volume through the system. The performance metric is inverse throughput, such that for a station that processes X packages in a minute, its performance would be 1/X minutes per package.
         * @summary Get a Report on the performance of Cloudsort.
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area (only SECONDARY)
         * @param {Array<number>} [shipper] Shipper ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {ReportsDatasetsPerformanceListMetricEnum} [metric] Metric
         * @param {ReportsDatasetsPerformanceListTimeEnum} [time] Time unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsPerformanceList: function (station, area, shipper, carrier, destination, route, groupBy, fromDate, toDate, metric, time, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/reports/datasets/performance/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (shipper) {
                                localVarQueryParameter['shipper'] = shipper.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (groupBy !== undefined) {
                                localVarQueryParameter['group_by'] = groupBy;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (metric !== undefined) {
                                localVarQueryParameter['metric'] = metric;
                            }
                            if (time !== undefined) {
                                localVarQueryParameter['time'] = time;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a Report on the Process Steps of Cloudsort. The returned dataset contains an aggregation of the number of entities in each of the provided process steps at the given grouping. It will return counts/volume or weight depending on the requested metric for each bucket within the from/to range that suits the group by specification, summing the process step state of the entities.
         * @summary Get a Report on the Process Steps
         * @param {ReportsDatasetsProcessstepsListResourceEnum} resource Resource
         * @param {ReportsDatasetsProcessstepsListMetricEnum} metric Metric
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area
         * @param {Array<ReportsDatasetsProcessstepsListProcessStepsEnum>} [processSteps] Process Steps
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {Array<number>} [shipper] Shipper ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsProcessstepsList: function (resource, metric, station, area, processSteps, groupBy, shipper, carrier, destination, route, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'resource' is not null or undefined
                            (0, common_1.assertParamExists)('reportsDatasetsProcessstepsList', 'resource', resource);
                            // verify required parameter 'metric' is not null or undefined
                            (0, common_1.assertParamExists)('reportsDatasetsProcessstepsList', 'metric', metric);
                            localVarPath = "/reports/datasets/processsteps/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (processSteps) {
                                localVarQueryParameter['process_steps'] = processSteps.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (resource !== undefined) {
                                localVarQueryParameter['resource'] = resource;
                            }
                            if (metric !== undefined) {
                                localVarQueryParameter['metric'] = metric;
                            }
                            if (groupBy !== undefined) {
                                localVarQueryParameter['group_by'] = groupBy;
                            }
                            if (shipper) {
                                localVarQueryParameter['shipper'] = shipper.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (carrier) {
                                localVarQueryParameter['carrier'] = carrier.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (destination) {
                                localVarQueryParameter['destination'] = destination.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (route) {
                                localVarQueryParameter['route'] = route.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ReportsApiAxiosParamCreator = ReportsApiAxiosParamCreator;
/**
 * ReportsApi - functional programming interface
 * @export
 */
var ReportsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReportsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns a Report on the Event Intervals of Cloudsort. The computed dataset contains the aggregated intervals between any two events specified as origin and target aligned on their respective owning resource, e.g. the times between arrived and dispatched would be calculated between containers and packages individually and then averaged out over the requested grouping. Further filtering can be applied to scope the returned dataset by station, area, zone, outbound load, container and package, as well as time-wise limit the result to a from/to range.
         * @summary Get a Report on the Event Intervals
         * @param {ReportsDatasetsEventintervalsListOriginEventEnum} originEvent Origin Event
         * @param {ReportsDatasetsEventintervalsListTargetEventEnum} targetEvent Target Event
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area
         * @param {number} [zone] Scope: Zone
         * @param {number} [outboundLoad] Scope: Outbound Load
         * @param {number} [container] Scope: Container
         * @param {number} [_package] Scope: Package
         * @param {Array<number>} [owner] Owner ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsEventintervalsList: function (originEvent, targetEvent, station, area, zone, outboundLoad, container, _package, owner, carrier, destination, route, groupBy, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportsDatasetsEventintervalsList(originEvent, targetEvent, station, area, zone, outboundLoad, container, _package, owner, carrier, destination, route, groupBy, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportsApi.reportsDatasetsEventintervalsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a Report on the Expected Influx of Cloudsort. The returned dataset aggregates the number of expected packages by weight/volume or count over the requested time period and station.
         * @summary Get a Report on the Expected Influx
         * @param {ReportsDatasetsExpectedinfluxListInfluxTypeEnum} influxType Influx Type
         * @param {number} [station] Scope: Station
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsExpectedinfluxList: function (influxType, station, groupBy, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportsDatasetsExpectedinfluxList(influxType, station, groupBy, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportsApi.reportsDatasetsExpectedinfluxList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This returns a Report on the performance of Cloudsort. Performance is measured by the amount of time required to get a package or amount of volume through the system. The performance metric is inverse throughput, such that for a station that processes X packages in a minute, its performance would be 1/X minutes per package.
         * @summary Get a Report on the performance of Cloudsort.
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area (only SECONDARY)
         * @param {Array<number>} [shipper] Shipper ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {ReportsDatasetsPerformanceListMetricEnum} [metric] Metric
         * @param {ReportsDatasetsPerformanceListTimeEnum} [time] Time unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsPerformanceList: function (station, area, shipper, carrier, destination, route, groupBy, fromDate, toDate, metric, time, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportsDatasetsPerformanceList(station, area, shipper, carrier, destination, route, groupBy, fromDate, toDate, metric, time, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportsApi.reportsDatasetsPerformanceList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a Report on the Process Steps of Cloudsort. The returned dataset contains an aggregation of the number of entities in each of the provided process steps at the given grouping. It will return counts/volume or weight depending on the requested metric for each bucket within the from/to range that suits the group by specification, summing the process step state of the entities.
         * @summary Get a Report on the Process Steps
         * @param {ReportsDatasetsProcessstepsListResourceEnum} resource Resource
         * @param {ReportsDatasetsProcessstepsListMetricEnum} metric Metric
         * @param {number} [station] Scope: Station
         * @param {number} [area] Scope: Area
         * @param {Array<ReportsDatasetsProcessstepsListProcessStepsEnum>} [processSteps] Process Steps
         * @param {string} [groupBy] Group By (e.g. 1d+1h)
         * @param {Array<number>} [shipper] Shipper ID
         * @param {Array<number>} [carrier] Carrier ID
         * @param {Array<number>} [destination] Target stop ID
         * @param {Array<number>} [route] Target route ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsProcessstepsList: function (resource, metric, station, area, processSteps, groupBy, shipper, carrier, destination, route, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportsDatasetsProcessstepsList(resource, metric, station, area, processSteps, groupBy, shipper, carrier, destination, route, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportsApi.reportsDatasetsProcessstepsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ReportsApiFp = ReportsApiFp;
/**
 * ReportsApi - factory interface
 * @export
 */
var ReportsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReportsApiFp)(configuration);
    return {
        /**
         * This endpoint returns a Report on the Event Intervals of Cloudsort. The computed dataset contains the aggregated intervals between any two events specified as origin and target aligned on their respective owning resource, e.g. the times between arrived and dispatched would be calculated between containers and packages individually and then averaged out over the requested grouping. Further filtering can be applied to scope the returned dataset by station, area, zone, outbound load, container and package, as well as time-wise limit the result to a from/to range.
         * @summary Get a Report on the Event Intervals
         * @param {ReportsApiReportsDatasetsEventintervalsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsEventintervalsList: function (requestParameters, options) {
            return localVarFp.reportsDatasetsEventintervalsList(requestParameters.originEvent, requestParameters.targetEvent, requestParameters.station, requestParameters.area, requestParameters.zone, requestParameters.outboundLoad, requestParameters.container, requestParameters._package, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a Report on the Expected Influx of Cloudsort. The returned dataset aggregates the number of expected packages by weight/volume or count over the requested time period and station.
         * @summary Get a Report on the Expected Influx
         * @param {ReportsApiReportsDatasetsExpectedinfluxListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsExpectedinfluxList: function (requestParameters, options) {
            return localVarFp.reportsDatasetsExpectedinfluxList(requestParameters.influxType, requestParameters.station, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This returns a Report on the performance of Cloudsort. Performance is measured by the amount of time required to get a package or amount of volume through the system. The performance metric is inverse throughput, such that for a station that processes X packages in a minute, its performance would be 1/X minutes per package.
         * @summary Get a Report on the performance of Cloudsort.
         * @param {ReportsApiReportsDatasetsPerformanceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsPerformanceList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.reportsDatasetsPerformanceList(requestParameters.station, requestParameters.area, requestParameters.shipper, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, requestParameters.metric, requestParameters.time, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a Report on the Process Steps of Cloudsort. The returned dataset contains an aggregation of the number of entities in each of the provided process steps at the given grouping. It will return counts/volume or weight depending on the requested metric for each bucket within the from/to range that suits the group by specification, summing the process step state of the entities.
         * @summary Get a Report on the Process Steps
         * @param {ReportsApiReportsDatasetsProcessstepsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDatasetsProcessstepsList: function (requestParameters, options) {
            return localVarFp.reportsDatasetsProcessstepsList(requestParameters.resource, requestParameters.metric, requestParameters.station, requestParameters.area, requestParameters.processSteps, requestParameters.groupBy, requestParameters.shipper, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReportsApiFactory = ReportsApiFactory;
/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
var ReportsApi = /** @class */ (function (_super) {
    __extends(ReportsApi, _super);
    function ReportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns a Report on the Event Intervals of Cloudsort. The computed dataset contains the aggregated intervals between any two events specified as origin and target aligned on their respective owning resource, e.g. the times between arrived and dispatched would be calculated between containers and packages individually and then averaged out over the requested grouping. Further filtering can be applied to scope the returned dataset by station, area, zone, outbound load, container and package, as well as time-wise limit the result to a from/to range.
     * @summary Get a Report on the Event Intervals
     * @param {ReportsApiReportsDatasetsEventintervalsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    ReportsApi.prototype.reportsDatasetsEventintervalsList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ReportsApiFp)(this.configuration).reportsDatasetsEventintervalsList(requestParameters.originEvent, requestParameters.targetEvent, requestParameters.station, requestParameters.area, requestParameters.zone, requestParameters.outboundLoad, requestParameters.container, requestParameters._package, requestParameters.owner, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a Report on the Expected Influx of Cloudsort. The returned dataset aggregates the number of expected packages by weight/volume or count over the requested time period and station.
     * @summary Get a Report on the Expected Influx
     * @param {ReportsApiReportsDatasetsExpectedinfluxListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    ReportsApi.prototype.reportsDatasetsExpectedinfluxList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ReportsApiFp)(this.configuration).reportsDatasetsExpectedinfluxList(requestParameters.influxType, requestParameters.station, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This returns a Report on the performance of Cloudsort. Performance is measured by the amount of time required to get a package or amount of volume through the system. The performance metric is inverse throughput, such that for a station that processes X packages in a minute, its performance would be 1/X minutes per package.
     * @summary Get a Report on the performance of Cloudsort.
     * @param {ReportsApiReportsDatasetsPerformanceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    ReportsApi.prototype.reportsDatasetsPerformanceList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ReportsApiFp)(this.configuration).reportsDatasetsPerformanceList(requestParameters.station, requestParameters.area, requestParameters.shipper, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.groupBy, requestParameters.fromDate, requestParameters.toDate, requestParameters.metric, requestParameters.time, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a Report on the Process Steps of Cloudsort. The returned dataset contains an aggregation of the number of entities in each of the provided process steps at the given grouping. It will return counts/volume or weight depending on the requested metric for each bucket within the from/to range that suits the group by specification, summing the process step state of the entities.
     * @summary Get a Report on the Process Steps
     * @param {ReportsApiReportsDatasetsProcessstepsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    ReportsApi.prototype.reportsDatasetsProcessstepsList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ReportsApiFp)(this.configuration).reportsDatasetsProcessstepsList(requestParameters.resource, requestParameters.metric, requestParameters.station, requestParameters.area, requestParameters.processSteps, requestParameters.groupBy, requestParameters.shipper, requestParameters.carrier, requestParameters.destination, requestParameters.route, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportsApi;
}(base_1.BaseAPI));
exports.ReportsApi = ReportsApi;
/**
 * @export
 */
exports.ReportsDatasetsEventintervalsListOriginEventEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * @export
 */
exports.ReportsDatasetsEventintervalsListTargetEventEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    SCANNED: 'SCANNED',
    ZONE: 'ZONE',
    CONTAINERIZATION_ELIGIBLE: 'CONTAINERIZATION_ELIGIBLE',
    CONTAINERIZED: 'CONTAINERIZED',
    TMP_CONTAINERIZED: 'TMP_CONTAINERIZED',
    MOVED: 'MOVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND',
    EXCEPTION_MISSORT: 'EXCEPTION_MISSORT',
    EXCEPTION_MISSORT_FORCED: 'EXCEPTION_MISSORT_FORCED',
    EXCEPTION_MISLOAD: 'EXCEPTION_MISLOAD',
    EXCEPTION_MISLOAD_FORCED: 'EXCEPTION_MISLOAD_FORCED',
    EXCEPTION_MISMOVE: 'EXCEPTION_MISMOVE',
    EXCEPTION_MISMOVE_FORCED: 'EXCEPTION_MISMOVE_FORCED',
    EXCEPTION_PRINT_FORCED: 'EXCEPTION_PRINT_FORCED',
    EXCEPTION_DISPATCH_FORCED: 'EXCEPTION_DISPATCH_FORCED',
    EXCEPTION_UNIDENTIFIED: 'EXCEPTION_UNIDENTIFIED',
    EXCEPTION_UNPROCESSABLE: 'EXCEPTION_UNPROCESSABLE',
    EXCEPTION_TROUBLESHOOT: 'EXCEPTION_TROUBLESHOOT',
    EXCEPTION_RELABELED: 'EXCEPTION_RELABELED',
    EXCEPTION_RETURNED: 'EXCEPTION_RETURNED',
    EXCEPTION_MISSING_DISPATCH_INFO: 'EXCEPTION_MISSING_DISPATCH_INFO',
    EXCEPTION_REQUIRES_MEASUREMENT: 'EXCEPTION_REQUIRES_MEASUREMENT',
    EXCEPTION_CLEANUP: 'EXCEPTION_CLEANUP',
    EXCEPTION_HAS_ACTIVE_HOLD: 'EXCEPTION_HAS_ACTIVE_HOLD',
    EXCEPTION_HOLD_RESOLVED: 'EXCEPTION_HOLD_RESOLVED',
    EXCEPTION_HOLD_UPDATED: 'EXCEPTION_HOLD_UPDATED',
    EXCEPTION_HOLD_CREATED: 'EXCEPTION_HOLD_CREATED',
    CARRIER_ARRIVED_AT_FACILITY: 'CARRIER_ARRIVED_AT_FACILITY',
    CARRIER_OUT_FOR_DELIVERY: 'CARRIER_OUT_FOR_DELIVERY',
    CARRIER_DELIVERED: 'CARRIER_DELIVERED',
    CARRIER_DELIVERY_FAILED: 'CARRIER_DELIVERY_FAILED',
    CARRIER_IN_TRANSIT: 'CARRIER_IN_TRANSIT',
    GROUPED: 'GROUPED',
    UNGROUPED: 'UNGROUPED',
    PLANNED: 'PLANNED',
    CHECKED_IN: 'CHECKED_IN',
    UPDATE_PACKAGE_FROM_BARCODE: 'UPDATE_PACKAGE_FROM_BARCODE',
    MEASURED: 'MEASURED'
};
/**
 * @export
 */
exports.ReportsDatasetsExpectedinfluxListInfluxTypeEnum = {
    COUNT: 'COUNT',
    WEIGHT: 'WEIGHT',
    VOLUME: 'VOLUME'
};
/**
 * @export
 */
exports.ReportsDatasetsPerformanceListMetricEnum = {
    PACKAGES: 'PACKAGES',
    VOLUME: 'VOLUME'
};
/**
 * @export
 */
exports.ReportsDatasetsPerformanceListTimeEnum = {
    SECONDS: 'SECONDS',
    MINUTES: 'MINUTES',
    HOURS: 'HOURS'
};
/**
 * @export
 */
exports.ReportsDatasetsProcessstepsListResourceEnum = {
    PACKAGES: 'PACKAGES'
};
/**
 * @export
 */
exports.ReportsDatasetsProcessstepsListMetricEnum = {
    COUNT: 'COUNT',
    WEIGHT: 'WEIGHT',
    VOLUME: 'VOLUME'
};
/**
 * @export
 */
exports.ReportsDatasetsProcessstepsListProcessStepsEnum = {
    MANIFESTED_INBOUND: 'MANIFESTED_INBOUND',
    ARRIVED: 'ARRIVED',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ZONE: 'ZONE',
    CONTAINERIZED: 'CONTAINERIZED',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    STAGED: 'STAGED',
    LOADED: 'LOADED',
    DISPATCHED: 'DISPATCHED',
    MANIFESTED_OUTBOUND: 'MANIFESTED_OUTBOUND'
};
/**
 * Route2stationsApi - axios parameter creator
 * @export
 */
var Route2stationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint will create a new route to station assignment, effectively adding the given station to the given route. Note that a stops are inserted at the beginning of a route.
         * @summary Create Route to Station Assignment
         * @param {Route2Station} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('route2stationsCreate', 'data', data);
                            localVarPath = "/route2stations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint is used to delete a stop from a route.
         * @summary Delete Route to Station Assignment
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('route2stationsDelete', 'id', id);
                            localVarPath = "/route2stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A route to stop assignment describes the mapping of a stop (station) to a route of a `CLOUDSORT` station. There may be one or more stops on a single route. See the routes API for details on how to manage the order of a routes stops.
         * @summary Get Route to Station Assignments
         * @param {number} [station] Filter the returned list of route to stop assignments to contain only entries for the given station (stop) ID.
         * @param {number} [route] Filter the returned list of route to stop assignments to the given route.
         * @param {number} [originStation] Filter the returned list of route to stop assignments to contain only entries whose route is of the given station.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsList: function (station, route, originStation, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/route2stations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (route !== undefined) {
                                localVarQueryParameter['route'] = route;
                            }
                            if (originStation !== undefined) {
                                localVarQueryParameter['origin_station'] = originStation;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *Update the route to station assignment.*
         * @summary Update Route to Station Assignment
         * @param {number} id
         * @param {Route2StationDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('route2stationsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('route2stationsPartialUpdate', 'data', data);
                            localVarPath = "/route2stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the individual details of a given route to stop assignment and can be subsequently used to delete/recreate it if necessary.
         * @summary Retrieve Route to Station Assignment
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('route2stationsRead', 'id', id);
                            localVarPath = "/route2stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.Route2stationsApiAxiosParamCreator = Route2stationsApiAxiosParamCreator;
/**
 * Route2stationsApi - functional programming interface
 * @export
 */
var Route2stationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.Route2stationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint will create a new route to station assignment, effectively adding the given station to the given route. Note that a stops are inserted at the beginning of a route.
         * @summary Create Route to Station Assignment
         * @param {Route2Station} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.route2stationsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Route2stationsApi.route2stationsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint is used to delete a stop from a route.
         * @summary Delete Route to Station Assignment
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.route2stationsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Route2stationsApi.route2stationsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A route to stop assignment describes the mapping of a stop (station) to a route of a `CLOUDSORT` station. There may be one or more stops on a single route. See the routes API for details on how to manage the order of a routes stops.
         * @summary Get Route to Station Assignments
         * @param {number} [station] Filter the returned list of route to stop assignments to contain only entries for the given station (stop) ID.
         * @param {number} [route] Filter the returned list of route to stop assignments to the given route.
         * @param {number} [originStation] Filter the returned list of route to stop assignments to contain only entries whose route is of the given station.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsList: function (station, route, originStation, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.route2stationsList(station, route, originStation, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Route2stationsApi.route2stationsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *Update the route to station assignment.*
         * @summary Update Route to Station Assignment
         * @param {number} id
         * @param {Route2StationDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.route2stationsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Route2stationsApi.route2stationsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the individual details of a given route to stop assignment and can be subsequently used to delete/recreate it if necessary.
         * @summary Retrieve Route to Station Assignment
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.route2stationsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Route2stationsApi.route2stationsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.Route2stationsApiFp = Route2stationsApiFp;
/**
 * Route2stationsApi - factory interface
 * @export
 */
var Route2stationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.Route2stationsApiFp)(configuration);
    return {
        /**
         * This endpoint will create a new route to station assignment, effectively adding the given station to the given route. Note that a stops are inserted at the beginning of a route.
         * @summary Create Route to Station Assignment
         * @param {Route2stationsApiRoute2stationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsCreate: function (requestParameters, options) {
            return localVarFp.route2stationsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint is used to delete a stop from a route.
         * @summary Delete Route to Station Assignment
         * @param {Route2stationsApiRoute2stationsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsDelete: function (requestParameters, options) {
            return localVarFp.route2stationsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A route to stop assignment describes the mapping of a stop (station) to a route of a `CLOUDSORT` station. There may be one or more stops on a single route. See the routes API for details on how to manage the order of a routes stops.
         * @summary Get Route to Station Assignments
         * @param {Route2stationsApiRoute2stationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.route2stationsList(requestParameters.station, requestParameters.route, requestParameters.originStation, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *Update the route to station assignment.*
         * @summary Update Route to Station Assignment
         * @param {Route2stationsApiRoute2stationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsPartialUpdate: function (requestParameters, options) {
            return localVarFp.route2stationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the individual details of a given route to stop assignment and can be subsequently used to delete/recreate it if necessary.
         * @summary Retrieve Route to Station Assignment
         * @param {Route2stationsApiRoute2stationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route2stationsRead: function (requestParameters, options) {
            return localVarFp.route2stationsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.Route2stationsApiFactory = Route2stationsApiFactory;
/**
 * Route2stationsApi - object-oriented interface
 * @export
 * @class Route2stationsApi
 * @extends {BaseAPI}
 */
var Route2stationsApi = /** @class */ (function (_super) {
    __extends(Route2stationsApi, _super);
    function Route2stationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint will create a new route to station assignment, effectively adding the given station to the given route. Note that a stops are inserted at the beginning of a route.
     * @summary Create Route to Station Assignment
     * @param {Route2stationsApiRoute2stationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Route2stationsApi
     */
    Route2stationsApi.prototype.route2stationsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Route2stationsApiFp)(this.configuration).route2stationsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint is used to delete a stop from a route.
     * @summary Delete Route to Station Assignment
     * @param {Route2stationsApiRoute2stationsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Route2stationsApi
     */
    Route2stationsApi.prototype.route2stationsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Route2stationsApiFp)(this.configuration).route2stationsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A route to stop assignment describes the mapping of a stop (station) to a route of a `CLOUDSORT` station. There may be one or more stops on a single route. See the routes API for details on how to manage the order of a routes stops.
     * @summary Get Route to Station Assignments
     * @param {Route2stationsApiRoute2stationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Route2stationsApi
     */
    Route2stationsApi.prototype.route2stationsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.Route2stationsApiFp)(this.configuration).route2stationsList(requestParameters.station, requestParameters.route, requestParameters.originStation, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *Update the route to station assignment.*
     * @summary Update Route to Station Assignment
     * @param {Route2stationsApiRoute2stationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Route2stationsApi
     */
    Route2stationsApi.prototype.route2stationsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Route2stationsApiFp)(this.configuration).route2stationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the individual details of a given route to stop assignment and can be subsequently used to delete/recreate it if necessary.
     * @summary Retrieve Route to Station Assignment
     * @param {Route2stationsApiRoute2stationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Route2stationsApi
     */
    Route2stationsApi.prototype.route2stationsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Route2stationsApiFp)(this.configuration).route2stationsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Route2stationsApi;
}(base_1.BaseAPI));
exports.Route2stationsApi = Route2stationsApi;
/**
 * RoutesApi - axios parameter creator
 * @export
 */
var RoutesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint is used to create a new route for a given station. Note again that it cannot be used to assign stops. To change the stops of a route, use the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Create Route
         * @param {Route} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('routesCreate', 'data', data);
                            localVarPath = "/routes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint will delete the given route and all stop assignments.
         * @summary Delete Route
         * @param {number} id A unique integer value identifying this route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('routesDelete', 'id', id);
                            localVarPath = "/routes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This API is used to return all routes in the system. A route describes an ordered collection of stops to which packages and containers are targetted. As such, the routes stop list is defining the desired contents of an Outbound Load. An Outbound Load will be linked to a route and receive all containers and packages matching any of the routes stops. During load operations, the Outbound Load will be loaded according to the order of stops on the route, such that the first stop on the route is the last one to be loaded, picturing e.g. a trailer.
         * @summary Get Routes
         * @param {number} [station] Filter the routes to the ones that are part of the given station (ie. whose &#x60;station&#x60; property matches the ID).
         * @param {number} [scheme] Filter the routes to the ones that are assigned to the given Scheme
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesList: function (station, scheme, search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/routes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to modify a given route with the new data, such as `name` or the `station`. Note that this endpoint *cannot* be used to assign new, or remove stops from the route. It *is* though to be used to modify the **order** of stops. The order in which the `route2stations` list is provided will be persisted to the database.  Assuming for example the following `GET /routes/<id>` request response:  ``` {     \"id\": <id>,     \"station\": <station id>,     \"name\": \"foo\",     \"route2stations\": [         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},     ] } ```  It is possible to update the order of the stops on the route by sending the following payload to the `PATCH /routes/<id>` API:  ``` {     \"route2stations\": [         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},     ] } ```  As a result, the stops are now changed in order to 2, 3, 1.
         * @summary Update Route
         * @param {number} id A unique integer value identifying this route.
         * @param {Route} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('routesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('routesPartialUpdate', 'data', data);
                            localVarPath = "/routes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This API provides a details endpoint for a given route, returning it\'s stop configuration.
         * @summary Retrieve Route
         * @param {number} id A unique integer value identifying this route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('routesRead', 'id', id);
                            localVarPath = "/routes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RoutesApiAxiosParamCreator = RoutesApiAxiosParamCreator;
/**
 * RoutesApi - functional programming interface
 * @export
 */
var RoutesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RoutesApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint is used to create a new route for a given station. Note again that it cannot be used to assign stops. To change the stops of a route, use the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Create Route
         * @param {Route} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routesCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoutesApi.routesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint will delete the given route and all stop assignments.
         * @summary Delete Route
         * @param {number} id A unique integer value identifying this route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoutesApi.routesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This API is used to return all routes in the system. A route describes an ordered collection of stops to which packages and containers are targetted. As such, the routes stop list is defining the desired contents of an Outbound Load. An Outbound Load will be linked to a route and receive all containers and packages matching any of the routes stops. During load operations, the Outbound Load will be loaded according to the order of stops on the route, such that the first stop on the route is the last one to be loaded, picturing e.g. a trailer.
         * @summary Get Routes
         * @param {number} [station] Filter the routes to the ones that are part of the given station (ie. whose &#x60;station&#x60; property matches the ID).
         * @param {number} [scheme] Filter the routes to the ones that are assigned to the given Scheme
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesList: function (station, scheme, search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routesList(station, scheme, search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoutesApi.routesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to modify a given route with the new data, such as `name` or the `station`. Note that this endpoint *cannot* be used to assign new, or remove stops from the route. It *is* though to be used to modify the **order** of stops. The order in which the `route2stations` list is provided will be persisted to the database.  Assuming for example the following `GET /routes/<id>` request response:  ``` {     \"id\": <id>,     \"station\": <station id>,     \"name\": \"foo\",     \"route2stations\": [         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},     ] } ```  It is possible to update the order of the stops on the route by sending the following payload to the `PATCH /routes/<id>` API:  ``` {     \"route2stations\": [         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},     ] } ```  As a result, the stops are now changed in order to 2, 3, 1.
         * @summary Update Route
         * @param {number} id A unique integer value identifying this route.
         * @param {Route} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routesPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoutesApi.routesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This API provides a details endpoint for a given route, returning it\'s stop configuration.
         * @summary Retrieve Route
         * @param {number} id A unique integer value identifying this route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routesRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RoutesApi.routesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RoutesApiFp = RoutesApiFp;
/**
 * RoutesApi - factory interface
 * @export
 */
var RoutesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RoutesApiFp)(configuration);
    return {
        /**
         * This endpoint is used to create a new route for a given station. Note again that it cannot be used to assign stops. To change the stops of a route, use the [Routes to Stops API](#tag/Routes-to-Stops-API).
         * @summary Create Route
         * @param {RoutesApiRoutesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesCreate: function (requestParameters, options) {
            return localVarFp.routesCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint will delete the given route and all stop assignments.
         * @summary Delete Route
         * @param {RoutesApiRoutesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesDelete: function (requestParameters, options) {
            return localVarFp.routesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This API is used to return all routes in the system. A route describes an ordered collection of stops to which packages and containers are targetted. As such, the routes stop list is defining the desired contents of an Outbound Load. An Outbound Load will be linked to a route and receive all containers and packages matching any of the routes stops. During load operations, the Outbound Load will be loaded according to the order of stops on the route, such that the first stop on the route is the last one to be loaded, picturing e.g. a trailer.
         * @summary Get Routes
         * @param {RoutesApiRoutesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.routesList(requestParameters.station, requestParameters.scheme, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows to modify a given route with the new data, such as `name` or the `station`. Note that this endpoint *cannot* be used to assign new, or remove stops from the route. It *is* though to be used to modify the **order** of stops. The order in which the `route2stations` list is provided will be persisted to the database.  Assuming for example the following `GET /routes/<id>` request response:  ``` {     \"id\": <id>,     \"station\": <station id>,     \"name\": \"foo\",     \"route2stations\": [         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},     ] } ```  It is possible to update the order of the stops on the route by sending the following payload to the `PATCH /routes/<id>` API:  ``` {     \"route2stations\": [         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},     ] } ```  As a result, the stops are now changed in order to 2, 3, 1.
         * @summary Update Route
         * @param {RoutesApiRoutesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesPartialUpdate: function (requestParameters, options) {
            return localVarFp.routesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This API provides a details endpoint for a given route, returning it\'s stop configuration.
         * @summary Retrieve Route
         * @param {RoutesApiRoutesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routesRead: function (requestParameters, options) {
            return localVarFp.routesRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RoutesApiFactory = RoutesApiFactory;
/**
 * RoutesApi - object-oriented interface
 * @export
 * @class RoutesApi
 * @extends {BaseAPI}
 */
var RoutesApi = /** @class */ (function (_super) {
    __extends(RoutesApi, _super);
    function RoutesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint is used to create a new route for a given station. Note again that it cannot be used to assign stops. To change the stops of a route, use the [Routes to Stops API](#tag/Routes-to-Stops-API).
     * @summary Create Route
     * @param {RoutesApiRoutesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    RoutesApi.prototype.routesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoutesApiFp)(this.configuration).routesCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint will delete the given route and all stop assignments.
     * @summary Delete Route
     * @param {RoutesApiRoutesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    RoutesApi.prototype.routesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoutesApiFp)(this.configuration).routesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This API is used to return all routes in the system. A route describes an ordered collection of stops to which packages and containers are targetted. As such, the routes stop list is defining the desired contents of an Outbound Load. An Outbound Load will be linked to a route and receive all containers and packages matching any of the routes stops. During load operations, the Outbound Load will be loaded according to the order of stops on the route, such that the first stop on the route is the last one to be loaded, picturing e.g. a trailer.
     * @summary Get Routes
     * @param {RoutesApiRoutesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    RoutesApi.prototype.routesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RoutesApiFp)(this.configuration).routesList(requestParameters.station, requestParameters.scheme, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows to modify a given route with the new data, such as `name` or the `station`. Note that this endpoint *cannot* be used to assign new, or remove stops from the route. It *is* though to be used to modify the **order** of stops. The order in which the `route2stations` list is provided will be persisted to the database.  Assuming for example the following `GET /routes/<id>` request response:  ``` {     \"id\": <id>,     \"station\": <station id>,     \"name\": \"foo\",     \"route2stations\": [         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},     ] } ```  It is possible to update the order of the stops on the route by sending the following payload to the `PATCH /routes/<id>` API:  ``` {     \"route2stations\": [         {\"id\": <stop id 2>, \"name\": \"Stop 2\", ...},         {\"id\": <stop id 3>, \"name\": \"Stop 3\", ...},         {\"id\": <stop id 1>, \"name\": \"Stop 1\", ...},     ] } ```  As a result, the stops are now changed in order to 2, 3, 1.
     * @summary Update Route
     * @param {RoutesApiRoutesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    RoutesApi.prototype.routesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoutesApiFp)(this.configuration).routesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This API provides a details endpoint for a given route, returning it\'s stop configuration.
     * @summary Retrieve Route
     * @param {RoutesApiRoutesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutesApi
     */
    RoutesApi.prototype.routesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RoutesApiFp)(this.configuration).routesRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RoutesApi;
}(base_1.BaseAPI));
exports.RoutesApi = RoutesApi;
/**
 * SchemesApi - axios parameter creator
 * @export
 */
var SchemesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint creates a new scheme*
         * @summary Create Scheme
         * @param {SchemeDetails} data
         * @param {boolean} [conflictResolve] Move ZIP Code conflicts
         * @param {number} [loadplanStation] Filter by Loadplan Station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesCreate: function (data, conflictResolve, loadplanStation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('schemesCreate', 'data', data);
                            localVarPath = "/schemes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (conflictResolve !== undefined) {
                                localVarQueryParameter['conflict_resolve'] = conflictResolve;
                            }
                            if (loadplanStation !== undefined) {
                                localVarQueryParameter['loadplan_station'] = loadplanStation;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint deletes a scheme*
         * @summary Delete Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('schemesDelete', 'id', id);
                            localVarPath = "/schemes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A scheme relates with a station (e.g. usps) with a list of zipcodes that this station should receive  *This endpoint returns a list of Schemes*
         * @summary Get Schemes
         * @param {string} [search]
         * @param {number} [station] Station ID
         * @param {number} [loadplan] Load Plan ID
         * @param {number} [stationOwner]
         * @param {number} [loadplanStation] Load Plan Station ID
         * @param {boolean} [isActive] Load Plan Active
         * @param {SchemesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesList: function (search, station, loadplan, stationOwner, loadplanStation, isActive, sortBy, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/schemes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (loadplan !== undefined) {
                                localVarQueryParameter['loadplan'] = loadplan;
                            }
                            if (stationOwner !== undefined) {
                                localVarQueryParameter['station_owner'] = stationOwner;
                            }
                            if (loadplanStation !== undefined) {
                                localVarQueryParameter['loadplan_station'] = loadplanStation;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoints updates a scheme*
         * @summary Update Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {SchemeDetails} data
         * @param {boolean} [conflictResolve] Move ZIP Code conflicts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesPartialUpdate: function (id, data, conflictResolve, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('schemesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('schemesPartialUpdate', 'data', data);
                            localVarPath = "/schemes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (conflictResolve !== undefined) {
                                localVarQueryParameter['conflict_resolve'] = conflictResolve;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Scheme by ID*
         * @summary Retrieve Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('schemesRead', 'id', id);
                            localVarPath = "/schemes/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SchemesApiAxiosParamCreator = SchemesApiAxiosParamCreator;
/**
 * SchemesApi - functional programming interface
 * @export
 */
var SchemesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SchemesApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint creates a new scheme*
         * @summary Create Scheme
         * @param {SchemeDetails} data
         * @param {boolean} [conflictResolve] Move ZIP Code conflicts
         * @param {number} [loadplanStation] Filter by Loadplan Station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesCreate: function (data, conflictResolve, loadplanStation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.schemesCreate(data, conflictResolve, loadplanStation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemesApi.schemesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint deletes a scheme*
         * @summary Delete Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.schemesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemesApi.schemesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A scheme relates with a station (e.g. usps) with a list of zipcodes that this station should receive  *This endpoint returns a list of Schemes*
         * @summary Get Schemes
         * @param {string} [search]
         * @param {number} [station] Station ID
         * @param {number} [loadplan] Load Plan ID
         * @param {number} [stationOwner]
         * @param {number} [loadplanStation] Load Plan Station ID
         * @param {boolean} [isActive] Load Plan Active
         * @param {SchemesListSortByEnum} [sortBy] Sort By
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesList: function (search, station, loadplan, stationOwner, loadplanStation, isActive, sortBy, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.schemesList(search, station, loadplan, stationOwner, loadplanStation, isActive, sortBy, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemesApi.schemesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoints updates a scheme*
         * @summary Update Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {SchemeDetails} data
         * @param {boolean} [conflictResolve] Move ZIP Code conflicts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesPartialUpdate: function (id, data, conflictResolve, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.schemesPartialUpdate(id, data, conflictResolve, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemesApi.schemesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Scheme by ID*
         * @summary Retrieve Scheme
         * @param {number} id A unique integer value identifying this scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.schemesRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemesApi.schemesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SchemesApiFp = SchemesApiFp;
/**
 * SchemesApi - factory interface
 * @export
 */
var SchemesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SchemesApiFp)(configuration);
    return {
        /**
         * *This endpoint creates a new scheme*
         * @summary Create Scheme
         * @param {SchemesApiSchemesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesCreate: function (requestParameters, options) {
            return localVarFp.schemesCreate(requestParameters.data, requestParameters.conflictResolve, requestParameters.loadplanStation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint deletes a scheme*
         * @summary Delete Scheme
         * @param {SchemesApiSchemesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesDelete: function (requestParameters, options) {
            return localVarFp.schemesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A scheme relates with a station (e.g. usps) with a list of zipcodes that this station should receive  *This endpoint returns a list of Schemes*
         * @summary Get Schemes
         * @param {SchemesApiSchemesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.schemesList(requestParameters.search, requestParameters.station, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.loadplanStation, requestParameters.isActive, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoints updates a scheme*
         * @summary Update Scheme
         * @param {SchemesApiSchemesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesPartialUpdate: function (requestParameters, options) {
            return localVarFp.schemesPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.conflictResolve, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Scheme by ID*
         * @summary Retrieve Scheme
         * @param {SchemesApiSchemesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesRead: function (requestParameters, options) {
            return localVarFp.schemesRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SchemesApiFactory = SchemesApiFactory;
/**
 * SchemesApi - object-oriented interface
 * @export
 * @class SchemesApi
 * @extends {BaseAPI}
 */
var SchemesApi = /** @class */ (function (_super) {
    __extends(SchemesApi, _super);
    function SchemesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint creates a new scheme*
     * @summary Create Scheme
     * @param {SchemesApiSchemesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemesApi
     */
    SchemesApi.prototype.schemesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SchemesApiFp)(this.configuration).schemesCreate(requestParameters.data, requestParameters.conflictResolve, requestParameters.loadplanStation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint deletes a scheme*
     * @summary Delete Scheme
     * @param {SchemesApiSchemesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemesApi
     */
    SchemesApi.prototype.schemesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SchemesApiFp)(this.configuration).schemesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A scheme relates with a station (e.g. usps) with a list of zipcodes that this station should receive  *This endpoint returns a list of Schemes*
     * @summary Get Schemes
     * @param {SchemesApiSchemesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemesApi
     */
    SchemesApi.prototype.schemesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SchemesApiFp)(this.configuration).schemesList(requestParameters.search, requestParameters.station, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.loadplanStation, requestParameters.isActive, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoints updates a scheme*
     * @summary Update Scheme
     * @param {SchemesApiSchemesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemesApi
     */
    SchemesApi.prototype.schemesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SchemesApiFp)(this.configuration).schemesPartialUpdate(requestParameters.id, requestParameters.data, requestParameters.conflictResolve, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Scheme by ID*
     * @summary Retrieve Scheme
     * @param {SchemesApiSchemesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemesApi
     */
    SchemesApi.prototype.schemesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SchemesApiFp)(this.configuration).schemesRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SchemesApi;
}(base_1.BaseAPI));
exports.SchemesApi = SchemesApi;
/**
 * @export
 */
exports.SchemesListSortByEnum = {
    LOAD_PLAN__ACTIVE: 'load_plan__active',
    LOAD_PLAN__ACTIVE2: '-load_plan__active'
};
/**
 * ShiftPlanPresetsApi - axios parameter creator
 * @export
 */
var ShiftPlanPresetsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint creates a new Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan Preset
         * @param {ShiftPlanPreset} data
         * @param {boolean} [force] Force Shift Plan overwrite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsCreate: function (data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlanPresetsCreate', 'data', data);
                            localVarPath = "/shift_plan_presets/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlanPresetsDelete', 'id', id);
                            localVarPath = "/shift_plan_presets/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Shift Plan Presets. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plan Presets
         * @param {number} [station] Station ID
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsList: function (station, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shift_plan_presets/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Shift Plan Preset by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan Preset
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlanPresetsRead', 'id', id);
                            localVarPath = "/shift_plan_presets/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan Preset
         * @param {number} id
         * @param {ShiftPlanPreset} data
         * @param {boolean} [force] Force Shift Plan overwrite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsUpdate: function (id, data, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlanPresetsUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlanPresetsUpdate', 'data', data);
                            localVarPath = "/shift_plan_presets/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShiftPlanPresetsApiAxiosParamCreator = ShiftPlanPresetsApiAxiosParamCreator;
/**
 * ShiftPlanPresetsApi - functional programming interface
 * @export
 */
var ShiftPlanPresetsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShiftPlanPresetsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint creates a new Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan Preset
         * @param {ShiftPlanPreset} data
         * @param {boolean} [force] Force Shift Plan overwrite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsCreate: function (data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlanPresetsCreate(data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlanPresetsApi.shiftPlanPresetsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlanPresetsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlanPresetsApi.shiftPlanPresetsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Shift Plan Presets. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plan Presets
         * @param {number} [station] Station ID
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsList: function (station, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlanPresetsList(station, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlanPresetsApi.shiftPlanPresetsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Shift Plan Preset by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan Preset
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlanPresetsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlanPresetsApi.shiftPlanPresetsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan Preset
         * @param {number} id
         * @param {ShiftPlanPreset} data
         * @param {boolean} [force] Force Shift Plan overwrite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsUpdate: function (id, data, force, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlanPresetsUpdate(id, data, force, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlanPresetsApi.shiftPlanPresetsUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ShiftPlanPresetsApiFp = ShiftPlanPresetsApiFp;
/**
 * ShiftPlanPresetsApi - factory interface
 * @export
 */
var ShiftPlanPresetsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShiftPlanPresetsApiFp)(configuration);
    return {
        /**
         * This endpoint creates a new Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan Preset
         * @param {ShiftPlanPresetsApiShiftPlanPresetsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsCreate: function (requestParameters, options) {
            return localVarFp.shiftPlanPresetsCreate(requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ShiftPlanPresetsApiShiftPlanPresetsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsDelete: function (requestParameters, options) {
            return localVarFp.shiftPlanPresetsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of Shift Plan Presets. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plan Presets
         * @param {ShiftPlanPresetsApiShiftPlanPresetsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.shiftPlanPresetsList(requestParameters.station, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Shift Plan Preset by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan Preset
         * @param {ShiftPlanPresetsApiShiftPlanPresetsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsRead: function (requestParameters, options) {
            return localVarFp.shiftPlanPresetsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates an existing Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan Preset
         * @param {ShiftPlanPresetsApiShiftPlanPresetsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlanPresetsUpdate: function (requestParameters, options) {
            return localVarFp.shiftPlanPresetsUpdate(requestParameters.id, requestParameters.data, requestParameters.force, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShiftPlanPresetsApiFactory = ShiftPlanPresetsApiFactory;
/**
 * ShiftPlanPresetsApi - object-oriented interface
 * @export
 * @class ShiftPlanPresetsApi
 * @extends {BaseAPI}
 */
var ShiftPlanPresetsApi = /** @class */ (function (_super) {
    __extends(ShiftPlanPresetsApi, _super);
    function ShiftPlanPresetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint creates a new Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
     * @summary Create Shift Plan Preset
     * @param {ShiftPlanPresetsApiShiftPlanPresetsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlanPresetsApi
     */
    ShiftPlanPresetsApi.prototype.shiftPlanPresetsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlanPresetsApiFp)(this.configuration).shiftPlanPresetsCreate(requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ShiftPlanPresetsApiShiftPlanPresetsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlanPresetsApi
     */
    ShiftPlanPresetsApi.prototype.shiftPlanPresetsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlanPresetsApiFp)(this.configuration).shiftPlanPresetsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of Shift Plan Presets. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
     * @summary Get Shift Plan Presets
     * @param {ShiftPlanPresetsApiShiftPlanPresetsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlanPresetsApi
     */
    ShiftPlanPresetsApi.prototype.shiftPlanPresetsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ShiftPlanPresetsApiFp)(this.configuration).shiftPlanPresetsList(requestParameters.station, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Shift Plan Preset by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
     * @summary Retrieve Shift Plan Preset
     * @param {ShiftPlanPresetsApiShiftPlanPresetsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlanPresetsApi
     */
    ShiftPlanPresetsApi.prototype.shiftPlanPresetsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlanPresetsApiFp)(this.configuration).shiftPlanPresetsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates an existing Shift Plan Preset. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
     * @summary Update Shift Plan Preset
     * @param {ShiftPlanPresetsApiShiftPlanPresetsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlanPresetsApi
     */
    ShiftPlanPresetsApi.prototype.shiftPlanPresetsUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlanPresetsApiFp)(this.configuration).shiftPlanPresetsUpdate(requestParameters.id, requestParameters.data, requestParameters.force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShiftPlanPresetsApi;
}(base_1.BaseAPI));
exports.ShiftPlanPresetsApi = ShiftPlanPresetsApi;
/**
 * ShiftPlansApi - axios parameter creator
 * @export
 */
var ShiftPlansApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint creates a new Shift Plan. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan
         * @param {ShiftPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansCreate', 'data', data);
                            localVarPath = "/shift_plans/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansDelete', 'id', id);
                            localVarPath = "/shift_plans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Shift Plans. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plans
         * @param {number} [station] Station ID
         * @param {string} [planDate] Date assigned to the plan
         * @param {Array<ShiftPlansListShiftPlanTypeEnum>} [shiftPlanType] Date assigned to the plan
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansList: function (station, planDate, shiftPlanType, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shift_plans/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (planDate !== undefined) {
                                localVarQueryParameter['plan_date'] = (planDate instanceof Date) ?
                                    planDate.toISOString().substring(0, 10) :
                                    planDate;
                            }
                            if (shiftPlanType) {
                                localVarQueryParameter['shift_plan_type'] = shiftPlanType.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Shift Plan by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansRead', 'id', id);
                            localVarPath = "/shift_plans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint will return the capacity and inbound packages per each group of hour within the given interval.
         * @param {number} station Station ID
         * @param {string} fromDate From Date
         * @param {string} [planDate]
         * @param {ShiftPlansTimelineShiftPlanTypeEnum} [shiftPlanType]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansTimeline: function (station, fromDate, planDate, shiftPlanType, page, pageSize, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'station' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansTimeline', 'station', station);
                            // verify required parameter 'fromDate' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansTimeline', 'fromDate', fromDate);
                            localVarPath = "/shift_plans/timeline/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (planDate !== undefined) {
                                localVarQueryParameter['plan_date'] = planDate;
                            }
                            if (shiftPlanType !== undefined) {
                                localVarQueryParameter['shift_plan_type'] = shiftPlanType;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Shift Plan . In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan
         * @param {number} id
         * @param {ShiftPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('shiftPlansUpdate', 'data', data);
                            localVarPath = "/shift_plans/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShiftPlansApiAxiosParamCreator = ShiftPlansApiAxiosParamCreator;
/**
 * ShiftPlansApi - functional programming interface
 * @export
 */
var ShiftPlansApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShiftPlansApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint creates a new Shift Plan. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan
         * @param {ShiftPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of Shift Plans. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plans
         * @param {number} [station] Station ID
         * @param {string} [planDate] Date assigned to the plan
         * @param {Array<ShiftPlansListShiftPlanTypeEnum>} [shiftPlanType] Date assigned to the plan
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansList: function (station, planDate, shiftPlanType, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansList(station, planDate, shiftPlanType, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Shift Plan by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint will return the capacity and inbound packages per each group of hour within the given interval.
         * @param {number} station Station ID
         * @param {string} fromDate From Date
         * @param {string} [planDate]
         * @param {ShiftPlansTimelineShiftPlanTypeEnum} [shiftPlanType]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansTimeline: function (station, fromDate, planDate, shiftPlanType, page, pageSize, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansTimeline(station, fromDate, planDate, shiftPlanType, page, pageSize, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansTimeline']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing Shift Plan . In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan
         * @param {number} id
         * @param {ShiftPlan} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shiftPlansUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShiftPlansApi.shiftPlansUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ShiftPlansApiFp = ShiftPlansApiFp;
/**
 * ShiftPlansApi - factory interface
 * @export
 */
var ShiftPlansApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShiftPlansApiFp)(configuration);
    return {
        /**
         * This endpoint creates a new Shift Plan. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Create Shift Plan
         * @param {ShiftPlansApiShiftPlansCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansCreate: function (requestParameters, options) {
            return localVarFp.shiftPlansCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ShiftPlansApiShiftPlansDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansDelete: function (requestParameters, options) {
            return localVarFp.shiftPlansDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of Shift Plans. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Get Shift Plans
         * @param {ShiftPlansApiShiftPlansListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.shiftPlansList(requestParameters.station, requestParameters.planDate, requestParameters.shiftPlanType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Shift Plan by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
         * @summary Retrieve Shift Plan
         * @param {ShiftPlansApiShiftPlansReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansRead: function (requestParameters, options) {
            return localVarFp.shiftPlansRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint will return the capacity and inbound packages per each group of hour within the given interval.
         * @param {ShiftPlansApiShiftPlansTimelineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansTimeline: function (requestParameters, options) {
            return localVarFp.shiftPlansTimeline(requestParameters.station, requestParameters.fromDate, requestParameters.planDate, requestParameters.shiftPlanType, requestParameters.page, requestParameters.pageSize, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates an existing Shift Plan . In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
         * @summary Update Shift Plan
         * @param {ShiftPlansApiShiftPlansUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shiftPlansUpdate: function (requestParameters, options) {
            return localVarFp.shiftPlansUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShiftPlansApiFactory = ShiftPlansApiFactory;
/**
 * ShiftPlansApi - object-oriented interface
 * @export
 * @class ShiftPlansApi
 * @extends {BaseAPI}
 */
var ShiftPlansApi = /** @class */ (function (_super) {
    __extends(ShiftPlansApi, _super);
    function ShiftPlansApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint creates a new Shift Plan. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
     * @summary Create Shift Plan
     * @param {ShiftPlansApiShiftPlansCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ShiftPlansApiShiftPlansDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of Shift Plans. In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
     * @summary Get Shift Plans
     * @param {ShiftPlansApiShiftPlansListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansList(requestParameters.station, requestParameters.planDate, requestParameters.shiftPlanType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Shift Plan by ID.  In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`.
     * @summary Retrieve Shift Plan
     * @param {ShiftPlansApiShiftPlansReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint will return the capacity and inbound packages per each group of hour within the given interval.
     * @param {ShiftPlansApiShiftPlansTimelineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansTimeline = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansTimeline(requestParameters.station, requestParameters.fromDate, requestParameters.planDate, requestParameters.shiftPlanType, requestParameters.page, requestParameters.pageSize, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates an existing Shift Plan . In order to make the request, the user needs to have the following permissions:  * `STATION_READ`; * `STATION_PLANNER_READ`; * `STATION_PLANNER_WRITE`.
     * @summary Update Shift Plan
     * @param {ShiftPlansApiShiftPlansUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftPlansApi
     */
    ShiftPlansApi.prototype.shiftPlansUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShiftPlansApiFp)(this.configuration).shiftPlansUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShiftPlansApi;
}(base_1.BaseAPI));
exports.ShiftPlansApi = ShiftPlansApi;
/**
 * @export
 */
exports.ShiftPlansListShiftPlanTypeEnum = {
    DEFAULT: 'DEFAULT',
    PRESET: 'PRESET'
};
/**
 * @export
 */
exports.ShiftPlansTimelineShiftPlanTypeEnum = {
    DEFAULT: 'DEFAULT',
    PRESET: 'PRESET'
};
/**
 * ShippersApi - axios parameter creator
 * @export
 */
var ShippersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Provides a list of the registered & used shippers a customer is managing via the CloudSort System.
         * @summary List Shippers
         * @param {string} [search] Filter the returned shippers by name given the search value.
         * @param {number} [customer] Filter the returned shippers to the given Customer ID.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippersList: function (search, customer, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shippers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShippersApiAxiosParamCreator = ShippersApiAxiosParamCreator;
/**
 * ShippersApi - functional programming interface
 * @export
 */
var ShippersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShippersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Provides a list of the registered & used shippers a customer is managing via the CloudSort System.
         * @summary List Shippers
         * @param {string} [search] Filter the returned shippers by name given the search value.
         * @param {number} [customer] Filter the returned shippers to the given Customer ID.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippersList: function (search, customer, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shippersList(search, customer, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ShippersApi.shippersList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ShippersApiFp = ShippersApiFp;
/**
 * ShippersApi - factory interface
 * @export
 */
var ShippersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShippersApiFp)(configuration);
    return {
        /**
         * Provides a list of the registered & used shippers a customer is managing via the CloudSort System.
         * @summary List Shippers
         * @param {ShippersApiShippersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippersList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.shippersList(requestParameters.search, requestParameters.customer, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShippersApiFactory = ShippersApiFactory;
/**
 * ShippersApi - object-oriented interface
 * @export
 * @class ShippersApi
 * @extends {BaseAPI}
 */
var ShippersApi = /** @class */ (function (_super) {
    __extends(ShippersApi, _super);
    function ShippersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Provides a list of the registered & used shippers a customer is managing via the CloudSort System.
     * @summary List Shippers
     * @param {ShippersApiShippersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippersApi
     */
    ShippersApi.prototype.shippersList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ShippersApiFp)(this.configuration).shippersList(requestParameters.search, requestParameters.customer, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShippersApi;
}(base_1.BaseAPI));
exports.ShippersApi = ShippersApi;
/**
 * StaffApi - axios parameter creator
 * @export
 */
var StaffApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint allows to create a new Staff in the system and associate it with the given permission data. It is expected that the staff is created in a station, or organization context.
         * @summary Create Staff
         * @param {Staff} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('staffCreate', 'data', data);
                            localVarPath = "/staff/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint removes the staff from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the staff will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDelete: function (id, stationId, organizationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffDelete', 'id', id);
                            localVarPath = "/staff/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint resets the user\'s badge token to invalidate current QR code
         * @summary Resets user badge token
         * @param {number} id A unique integer value identifying this user.
         * @param {object} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeviceTokenReset: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffDeviceTokenReset', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('staffDeviceTokenReset', 'data', data);
                            localVarPath = "/staff/{id}/devicetokenreset/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for the Staff.
         * @summary Get the PNG label for the Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffLabelLabelPng', 'id', id);
                            localVarPath = "/staff/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for the Staff of a Station by ID.
         * @summary Get the ZPL label for the Staff of a Station
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffLabelLabelZpl', 'id', id);
                            localVarPath = "/staff/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Provides a list of the registered & integrated staff that work in CloudSort Organizations and Stations.
         * @summary List Staff
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {boolean} [isVirtual] Is virtual
         * @param {StaffListSortByEnum} [sortBy] Sort By
         * @param {StaffListRoleTypeEnum} [roleType] Role Type
         * @param {boolean} [isActive] Is active (user not deactivated)
         * @param {boolean} [active] Active (user operationally active)
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60; &amp; &#x60;seconds_per_package&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffList: function (page, pageSize, fromDate, toDate, stationId, organizationId, isVirtual, sortBy, roleType, isActive, active, extendData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/staff/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            if (isVirtual !== undefined) {
                                localVarQueryParameter['is_virtual'] = isVirtual;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (roleType !== undefined) {
                                localVarQueryParameter['role_type'] = roleType;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (active !== undefined) {
                                localVarQueryParameter['active'] = active;
                            }
                            if (extendData !== undefined) {
                                localVarQueryParameter['extend_data'] = extendData;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns user ID if email exists.
         * @summary Lookup user by email
         * @param {StaffLookup} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLookup: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('staffLookup', 'data', data);
                            localVarPath = "/staff/lookup/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to update the staff with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {Staff} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('staffPartialUpdate', 'data', data);
                            localVarPath = "/staff/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Staff by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the staff for the respective entity.
         * @summary Retrieve Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60; &amp; &#x60;seconds_per_package&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffRead: function (id, fromDate, toDate, stationId, organizationId, extendData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffRead', 'id', id);
                            localVarPath = "/staff/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            if (extendData !== undefined) {
                                localVarQueryParameter['extend_data'] = extendData;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns performance statistics for a specific station Staff
         * @summary Get statistics for this station staff
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffStats: function (id, stationId, organizationId, fromDate, toDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('staffStats', 'id', id);
                            localVarPath = "/staff/{id}/stats/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (stationId !== undefined) {
                                localVarQueryParameter['station_id'] = stationId;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['organization_id'] = organizationId;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            if (toDate !== undefined) {
                                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                                    toDate.toISOString() :
                                    toDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StaffApiAxiosParamCreator = StaffApiAxiosParamCreator;
/**
 * StaffApi - functional programming interface
 * @export
 */
var StaffApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StaffApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint allows to create a new Staff in the system and associate it with the given permission data. It is expected that the staff is created in a station, or organization context.
         * @summary Create Staff
         * @param {Staff} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint removes the staff from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the staff will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDelete: function (id, stationId, organizationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffDelete(id, stationId, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint resets the user\'s badge token to invalidate current QR code
         * @summary Resets user badge token
         * @param {number} id A unique integer value identifying this user.
         * @param {object} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeviceTokenReset: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffDeviceTokenReset(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffDeviceTokenReset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for the Staff.
         * @summary Get the PNG label for the Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for the Staff of a Station by ID.
         * @summary Get the ZPL label for the Staff of a Station
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Provides a list of the registered & integrated staff that work in CloudSort Organizations and Stations.
         * @summary List Staff
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {boolean} [isVirtual] Is virtual
         * @param {StaffListSortByEnum} [sortBy] Sort By
         * @param {StaffListRoleTypeEnum} [roleType] Role Type
         * @param {boolean} [isActive] Is active (user not deactivated)
         * @param {boolean} [active] Active (user operationally active)
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60; &amp; &#x60;seconds_per_package&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffList: function (page, pageSize, fromDate, toDate, stationId, organizationId, isVirtual, sortBy, roleType, isActive, active, extendData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffList(page, pageSize, fromDate, toDate, stationId, organizationId, isVirtual, sortBy, roleType, isActive, active, extendData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns user ID if email exists.
         * @summary Lookup user by email
         * @param {StaffLookup} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLookup: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffLookup(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffLookup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint allows to update the staff with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {Staff} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Staff by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the staff for the respective entity.
         * @summary Retrieve Staff
         * @param {number} id A unique integer value identifying this user.
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {boolean} [extendData] Include additional data: &#x60;active&#x60; &amp; &#x60;seconds_per_package&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffRead: function (id, fromDate, toDate, stationId, organizationId, extendData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffRead(id, fromDate, toDate, stationId, organizationId, extendData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns performance statistics for a specific station Staff
         * @summary Get statistics for this station staff
         * @param {number} id A unique integer value identifying this user.
         * @param {number} [stationId] Station ID
         * @param {number} [organizationId] Organization ID
         * @param {string} [fromDate] From Date
         * @param {string} [toDate] To Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffStats: function (id, stationId, organizationId, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.staffStats(id, stationId, organizationId, fromDate, toDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaffApi.staffStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StaffApiFp = StaffApiFp;
/**
 * StaffApi - factory interface
 * @export
 */
var StaffApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StaffApiFp)(configuration);
    return {
        /**
         * This endpoint allows to create a new Staff in the system and associate it with the given permission data. It is expected that the staff is created in a station, or organization context.
         * @summary Create Staff
         * @param {StaffApiStaffCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffCreate: function (requestParameters, options) {
            return localVarFp.staffCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint removes the staff from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the staff will be dissassociated from all organizations and stations that the requesting user has access to.
         * @summary Remove Staff
         * @param {StaffApiStaffDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDelete: function (requestParameters, options) {
            return localVarFp.staffDelete(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint resets the user\'s badge token to invalidate current QR code
         * @summary Resets user badge token
         * @param {StaffApiStaffDeviceTokenResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffDeviceTokenReset: function (requestParameters, options) {
            return localVarFp.staffDeviceTokenReset(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for the Staff.
         * @summary Get the PNG label for the Staff
         * @param {StaffApiStaffLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelPng: function (requestParameters, options) {
            return localVarFp.staffLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label as JSON for the Staff of a Station by ID.
         * @summary Get the ZPL label for the Staff of a Station
         * @param {StaffApiStaffLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.staffLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Provides a list of the registered & integrated staff that work in CloudSort Organizations and Stations.
         * @summary List Staff
         * @param {StaffApiStaffListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.staffList(requestParameters.page, requestParameters.pageSize, requestParameters.fromDate, requestParameters.toDate, requestParameters.stationId, requestParameters.organizationId, requestParameters.isVirtual, requestParameters.sortBy, requestParameters.roleType, requestParameters.isActive, requestParameters.active, requestParameters.extendData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns user ID if email exists.
         * @summary Lookup user by email
         * @param {StaffApiStaffLookupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffLookup: function (requestParameters, options) {
            return localVarFp.staffLookup(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint allows to update the staff with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
         * @summary Update Staff
         * @param {StaffApiStaffPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffPartialUpdate: function (requestParameters, options) {
            return localVarFp.staffPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Staff by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the staff for the respective entity.
         * @summary Retrieve Staff
         * @param {StaffApiStaffReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffRead: function (requestParameters, options) {
            return localVarFp.staffRead(requestParameters.id, requestParameters.fromDate, requestParameters.toDate, requestParameters.stationId, requestParameters.organizationId, requestParameters.extendData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns performance statistics for a specific station Staff
         * @summary Get statistics for this station staff
         * @param {StaffApiStaffStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staffStats: function (requestParameters, options) {
            return localVarFp.staffStats(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StaffApiFactory = StaffApiFactory;
/**
 * StaffApi - object-oriented interface
 * @export
 * @class StaffApi
 * @extends {BaseAPI}
 */
var StaffApi = /** @class */ (function (_super) {
    __extends(StaffApi, _super);
    function StaffApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint allows to create a new Staff in the system and associate it with the given permission data. It is expected that the staff is created in a station, or organization context.
     * @summary Create Staff
     * @param {StaffApiStaffCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint removes the staff from the system, or removes the association with the given `station_id` or `organization_id` (query parameters). If not query parameters are given, the staff will be dissassociated from all organizations and stations that the requesting user has access to.
     * @summary Remove Staff
     * @param {StaffApiStaffDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffDelete(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint resets the user\'s badge token to invalidate current QR code
     * @summary Resets user badge token
     * @param {StaffApiStaffDeviceTokenResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffDeviceTokenReset = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffDeviceTokenReset(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for the Staff.
     * @summary Get the PNG label for the Staff
     * @param {StaffApiStaffLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label as JSON for the Staff of a Station by ID.
     * @summary Get the ZPL label for the Staff of a Station
     * @param {StaffApiStaffLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Provides a list of the registered & integrated staff that work in CloudSort Organizations and Stations.
     * @summary List Staff
     * @param {StaffApiStaffListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StaffApiFp)(this.configuration).staffList(requestParameters.page, requestParameters.pageSize, requestParameters.fromDate, requestParameters.toDate, requestParameters.stationId, requestParameters.organizationId, requestParameters.isVirtual, requestParameters.sortBy, requestParameters.roleType, requestParameters.isActive, requestParameters.active, requestParameters.extendData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns user ID if email exists.
     * @summary Lookup user by email
     * @param {StaffApiStaffLookupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffLookup = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffLookup(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint allows to update the staff with the provided data. The permission information can only be modified by authorised staff of the respective organization, or station.
     * @summary Update Staff
     * @param {StaffApiStaffPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Staff by ID. If the request specifies either the `station_id` or the `organization_id` parameter, the `permission_data` field will be populated with the permissions of the staff for the respective entity.
     * @summary Retrieve Staff
     * @param {StaffApiStaffReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffRead(requestParameters.id, requestParameters.fromDate, requestParameters.toDate, requestParameters.stationId, requestParameters.organizationId, requestParameters.extendData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns performance statistics for a specific station Staff
     * @summary Get statistics for this station staff
     * @param {StaffApiStaffStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffApi
     */
    StaffApi.prototype.staffStats = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaffApiFp)(this.configuration).staffStats(requestParameters.id, requestParameters.stationId, requestParameters.organizationId, requestParameters.fromDate, requestParameters.toDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StaffApi;
}(base_1.BaseAPI));
exports.StaffApi = StaffApi;
/**
 * @export
 */
exports.StaffListSortByEnum = {
    ID: 'id',
    ACTIVE: 'active',
    SECONDS_PER_PACKAGE: 'seconds_per_package',
    ID2: '-id',
    ACTIVE2: '-active',
    SECONDS_PER_PACKAGE2: '-seconds_per_package'
};
/**
 * @export
 */
exports.StaffListRoleTypeEnum = {
    BLANK: 'BLANK',
    OPERATOR_I: 'OPERATOR_I',
    OPERATOR_II: 'OPERATOR_II',
    OPERATOR_III: 'OPERATOR_III',
    STATION_ADMIN: 'STATION_ADMIN',
    ORG_ADMIN: 'ORG_ADMIN',
    SUPER_USER: 'SUPER_USER'
};
/**
 * Station2schemeApi - axios parameter creator
 * @export
 */
var Station2schemeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint will create a new Station Scheme*
         * @summary Create Station Scheme
         * @param {Station2Scheme} data
         * @param {boolean} [conflictResolve] Move station/scheme conflicts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeCreate: function (data, conflictResolve, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('station2schemeCreate', 'data', data);
                            localVarPath = "/station2scheme/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (conflictResolve !== undefined) {
                                localVarQueryParameter['conflict_resolve'] = conflictResolve;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Station Scheme by ID*
         * @summary Delete Station Scheme
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('station2schemeDelete', 'id', id);
                            localVarPath = "/station2scheme/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of Station Schemes*
         * @summary Get Station Schemes
         * @param {number} [station] Filter by station ID
         * @param {number} [scheme] Filter by scheme ID
         * @param {number} [loadplan] Filter by Loadplan ID
         * @param {number} [stationOwner]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [loadplanStation] Filter by Loadplan station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeList: function (station, scheme, loadplan, stationOwner, page, pageSize, loadplanStation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/station2scheme/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (scheme !== undefined) {
                                localVarQueryParameter['scheme'] = scheme;
                            }
                            if (loadplan !== undefined) {
                                localVarQueryParameter['loadplan'] = loadplan;
                            }
                            if (stationOwner !== undefined) {
                                localVarQueryParameter['station_owner'] = stationOwner;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (loadplanStation !== undefined) {
                                localVarQueryParameter['loadplan_station'] = loadplanStation;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.Station2schemeApiAxiosParamCreator = Station2schemeApiAxiosParamCreator;
/**
 * Station2schemeApi - functional programming interface
 * @export
 */
var Station2schemeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.Station2schemeApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint will create a new Station Scheme*
         * @summary Create Station Scheme
         * @param {Station2Scheme} data
         * @param {boolean} [conflictResolve] Move station/scheme conflicts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeCreate: function (data, conflictResolve, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.station2schemeCreate(data, conflictResolve, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Station2schemeApi.station2schemeCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Station Scheme by ID*
         * @summary Delete Station Scheme
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.station2schemeDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Station2schemeApi.station2schemeDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns a list of Station Schemes*
         * @summary Get Station Schemes
         * @param {number} [station] Filter by station ID
         * @param {number} [scheme] Filter by scheme ID
         * @param {number} [loadplan] Filter by Loadplan ID
         * @param {number} [stationOwner]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [loadplanStation] Filter by Loadplan station ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeList: function (station, scheme, loadplan, stationOwner, page, pageSize, loadplanStation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.station2schemeList(station, scheme, loadplan, stationOwner, page, pageSize, loadplanStation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Station2schemeApi.station2schemeList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.Station2schemeApiFp = Station2schemeApiFp;
/**
 * Station2schemeApi - factory interface
 * @export
 */
var Station2schemeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.Station2schemeApiFp)(configuration);
    return {
        /**
         * *This endpoint will create a new Station Scheme*
         * @summary Create Station Scheme
         * @param {Station2schemeApiStation2schemeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeCreate: function (requestParameters, options) {
            return localVarFp.station2schemeCreate(requestParameters.data, requestParameters.conflictResolve, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Station Scheme by ID*
         * @summary Delete Station Scheme
         * @param {Station2schemeApiStation2schemeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeDelete: function (requestParameters, options) {
            return localVarFp.station2schemeDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns a list of Station Schemes*
         * @summary Get Station Schemes
         * @param {Station2schemeApiStation2schemeListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        station2schemeList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.station2schemeList(requestParameters.station, requestParameters.scheme, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.page, requestParameters.pageSize, requestParameters.loadplanStation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.Station2schemeApiFactory = Station2schemeApiFactory;
/**
 * Station2schemeApi - object-oriented interface
 * @export
 * @class Station2schemeApi
 * @extends {BaseAPI}
 */
var Station2schemeApi = /** @class */ (function (_super) {
    __extends(Station2schemeApi, _super);
    function Station2schemeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint will create a new Station Scheme*
     * @summary Create Station Scheme
     * @param {Station2schemeApiStation2schemeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Station2schemeApi
     */
    Station2schemeApi.prototype.station2schemeCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Station2schemeApiFp)(this.configuration).station2schemeCreate(requestParameters.data, requestParameters.conflictResolve, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Station Scheme by ID*
     * @summary Delete Station Scheme
     * @param {Station2schemeApiStation2schemeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Station2schemeApi
     */
    Station2schemeApi.prototype.station2schemeDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.Station2schemeApiFp)(this.configuration).station2schemeDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns a list of Station Schemes*
     * @summary Get Station Schemes
     * @param {Station2schemeApiStation2schemeListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Station2schemeApi
     */
    Station2schemeApi.prototype.station2schemeList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.Station2schemeApiFp)(this.configuration).station2schemeList(requestParameters.station, requestParameters.scheme, requestParameters.loadplan, requestParameters.stationOwner, requestParameters.page, requestParameters.pageSize, requestParameters.loadplanStation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Station2schemeApi;
}(base_1.BaseAPI));
exports.Station2schemeApi = Station2schemeApi;
/**
 * StationsApi - axios parameter creator
 * @export
 */
var StationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This API will resync all policies with ADM for all stations in the system.
         * @summary Re-sync all polices in the system with ADM.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsAdmsync: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/stations/admsync/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Station*
         * @summary Create Station
         * @param {Station} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('stationsCreate', 'data', data);
                            localVarPath = "/stations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Station with specified id*
         * @summary Delete Station
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsDelete', 'id', id);
                            localVarPath = "/stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint responds with a ZIP-Archive of the labels for all locations & staff in the station. The filters are to reduce the amount of labels returned, e.g. by only considering one area, or zone.
         * @summary Produce all labels for the station
         * @param {number} id
         * @param {number} [area] Filter to Area
         * @param {boolean} [areas] Return Area Labels
         * @param {number} [zone] Filter to Zone
         * @param {boolean} [zones] Return Zone Labels
         * @param {boolean} [activeLoadpoints] Return active Loadpoint Labels
         * @param {boolean} [inactiveLoadpoints] Return inactive Loadpoint Labels
         * @param {boolean} [dockdoors] Return Dock Door Labels
         * @param {boolean} [staff] Return Staff Labels
         * @param {StationsLabelsDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabels: function (id, area, areas, zone, zones, activeLoadpoints, inactiveLoadpoints, dockdoors, staff, dataFormat, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsLabels', 'id', id);
                            localVarPath = "/stations/{id}/labels/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (areas !== undefined) {
                                localVarQueryParameter['areas'] = areas;
                            }
                            if (zone !== undefined) {
                                localVarQueryParameter['zone'] = zone;
                            }
                            if (zones !== undefined) {
                                localVarQueryParameter['zones'] = zones;
                            }
                            if (activeLoadpoints !== undefined) {
                                localVarQueryParameter['active_loadpoints'] = activeLoadpoints;
                            }
                            if (inactiveLoadpoints !== undefined) {
                                localVarQueryParameter['inactive_loadpoints'] = inactiveLoadpoints;
                            }
                            if (dockdoors !== undefined) {
                                localVarQueryParameter['dockdoors'] = dockdoors;
                            }
                            if (staff !== undefined) {
                                localVarQueryParameter['staff'] = staff;
                            }
                            if (dataFormat !== undefined) {
                                localVarQueryParameter['data_format'] = dataFormat;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint precaches all labels for the given station using the given format/size and dpi settings.
         * @summary Precache all labels for the station
         * @param {number} id
         * @param {StationsLabelsPrecacheDataFormatEnum} dataFormat Format
         * @param {string} size Size (wxh)
         * @param {number} dpi DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabelsPrecache: function (id, dataFormat, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsLabelsPrecache', 'id', id);
                            // verify required parameter 'dataFormat' is not null or undefined
                            (0, common_1.assertParamExists)('stationsLabelsPrecache', 'dataFormat', dataFormat);
                            // verify required parameter 'size' is not null or undefined
                            (0, common_1.assertParamExists)('stationsLabelsPrecache', 'size', size);
                            // verify required parameter 'dpi' is not null or undefined
                            (0, common_1.assertParamExists)('stationsLabelsPrecache', 'dpi', dpi);
                            localVarPath = "/stations/{id}/labels_precache/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dataFormat !== undefined) {
                                localVarQueryParameter['data_format'] = dataFormat;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A generalized term that refers to the location where the sortation operation is being performed.  *This endpoint returns a list of Stations*
         * @summary Get Stations
         * @param {string} [search]
         * @param {number} [organization] Filter by Organization
         * @param {StationsListStationTypeEnum} [stationType] Station Type
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsList: function (search, organization, stationType, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/stations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (organization !== undefined) {
                                localVarQueryParameter['organization'] = organization;
                            }
                            if (stationType !== undefined) {
                                localVarQueryParameter['station_type'] = stationType;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Station with specified id*
         * @summary Patch Station
         * @param {number} id
         * @param {StationDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('stationsPartialUpdate', 'data', data);
                            localVarPath = "/stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint creates a new station role with changed permissions.
         * @summary Creates/Updates a station role with set of permissions
         * @param {number} id
         * @param {PatchStationRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsPermissionsPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('stationsPermissionsPartialUpdate', 'data', data);
                            localVarPath = "/stations/{id}/permissions/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsPermissionsRead', 'id', id);
                            localVarPath = "/stations/{id}/permissions/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Station with specified id*
         * @summary Retrieve Station
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsRead', 'id', id);
                            localVarPath = "/stations/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint imports the given stop data and extends or creates the existing stops of the given station with it. This API can be used to provide additional data to otherwise anonymous stops created via the loadplan API.  The data expected in the upload (format: CSV), requires the following layout (note that all but the `external_id` column are optional fields)  ```csv external_id,name,zipcode,station_type,... STOP_1,Stop A,129127263,USPS_DDU, ```
         * @summary Import stops data to the given Station.
         * @param {number} id
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {boolean} [geocode] If false, the new addresses will not be geocoded. By default, the addresses will be geocoded.
         * @param {File} [file] The Stops File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsStopsImport: function (id, dryRun, geocode, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('stationsStopsImport', 'id', id);
                            // verify required parameter 'dryRun' is not null or undefined
                            (0, common_1.assertParamExists)('stationsStopsImport', 'dryRun', dryRun);
                            localVarPath = "/stations/{id}/stops_import/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dryRun !== undefined) {
                                localVarQueryParameter['dry_run'] = dryRun;
                            }
                            if (geocode !== undefined) {
                                localVarQueryParameter['geocode'] = geocode;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StationsApiAxiosParamCreator = StationsApiAxiosParamCreator;
/**
 * StationsApi - functional programming interface
 * @export
 */
var StationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This API will resync all policies with ADM for all stations in the system.
         * @summary Re-sync all polices in the system with ADM.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsAdmsync: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsAdmsync(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsAdmsync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Station*
         * @summary Create Station
         * @param {Station} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Station with specified id*
         * @summary Delete Station
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint responds with a ZIP-Archive of the labels for all locations & staff in the station. The filters are to reduce the amount of labels returned, e.g. by only considering one area, or zone.
         * @summary Produce all labels for the station
         * @param {number} id
         * @param {number} [area] Filter to Area
         * @param {boolean} [areas] Return Area Labels
         * @param {number} [zone] Filter to Zone
         * @param {boolean} [zones] Return Zone Labels
         * @param {boolean} [activeLoadpoints] Return active Loadpoint Labels
         * @param {boolean} [inactiveLoadpoints] Return inactive Loadpoint Labels
         * @param {boolean} [dockdoors] Return Dock Door Labels
         * @param {boolean} [staff] Return Staff Labels
         * @param {StationsLabelsDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabels: function (id, area, areas, zone, zones, activeLoadpoints, inactiveLoadpoints, dockdoors, staff, dataFormat, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsLabels(id, area, areas, zone, zones, activeLoadpoints, inactiveLoadpoints, dockdoors, staff, dataFormat, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsLabels']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint precaches all labels for the given station using the given format/size and dpi settings.
         * @summary Precache all labels for the station
         * @param {number} id
         * @param {StationsLabelsPrecacheDataFormatEnum} dataFormat Format
         * @param {string} size Size (wxh)
         * @param {number} dpi DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabelsPrecache: function (id, dataFormat, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsLabelsPrecache(id, dataFormat, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsLabelsPrecache']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A generalized term that refers to the location where the sortation operation is being performed.  *This endpoint returns a list of Stations*
         * @summary Get Stations
         * @param {string} [search]
         * @param {number} [organization] Filter by Organization
         * @param {StationsListStationTypeEnum} [stationType] Station Type
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsList: function (search, organization, stationType, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsList(search, organization, stationType, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Station with specified id*
         * @summary Patch Station
         * @param {number} id
         * @param {StationDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint creates a new station role with changed permissions.
         * @summary Creates/Updates a station role with set of permissions
         * @param {number} id
         * @param {PatchStationRoles} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsPermissionsPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsPermissionsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsPermissionsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsPermissionsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Station with specified id*
         * @summary Retrieve Station
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint imports the given stop data and extends or creates the existing stops of the given station with it. This API can be used to provide additional data to otherwise anonymous stops created via the loadplan API.  The data expected in the upload (format: CSV), requires the following layout (note that all but the `external_id` column are optional fields)  ```csv external_id,name,zipcode,station_type,... STOP_1,Stop A,129127263,USPS_DDU, ```
         * @summary Import stops data to the given Station.
         * @param {number} id
         * @param {boolean} dryRun If true, makes no changes, used for getting confirmation data and testing an integration.
         * @param {boolean} [geocode] If false, the new addresses will not be geocoded. By default, the addresses will be geocoded.
         * @param {File} [file] The Stops File to upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsStopsImport: function (id, dryRun, geocode, file, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stationsStopsImport(id, dryRun, geocode, file, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StationsApi.stationsStopsImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StationsApiFp = StationsApiFp;
/**
 * StationsApi - factory interface
 * @export
 */
var StationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StationsApiFp)(configuration);
    return {
        /**
         * This API will resync all policies with ADM for all stations in the system.
         * @summary Re-sync all polices in the system with ADM.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsAdmsync: function (options) {
            return localVarFp.stationsAdmsync(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Station*
         * @summary Create Station
         * @param {StationsApiStationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsCreate: function (requestParameters, options) {
            return localVarFp.stationsCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Station with specified id*
         * @summary Delete Station
         * @param {StationsApiStationsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsDelete: function (requestParameters, options) {
            return localVarFp.stationsDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint responds with a ZIP-Archive of the labels for all locations & staff in the station. The filters are to reduce the amount of labels returned, e.g. by only considering one area, or zone.
         * @summary Produce all labels for the station
         * @param {StationsApiStationsLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabels: function (requestParameters, options) {
            return localVarFp.stationsLabels(requestParameters.id, requestParameters.area, requestParameters.areas, requestParameters.zone, requestParameters.zones, requestParameters.activeLoadpoints, requestParameters.inactiveLoadpoints, requestParameters.dockdoors, requestParameters.staff, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint precaches all labels for the given station using the given format/size and dpi settings.
         * @summary Precache all labels for the station
         * @param {StationsApiStationsLabelsPrecacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsLabelsPrecache: function (requestParameters, options) {
            return localVarFp.stationsLabelsPrecache(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A generalized term that refers to the location where the sortation operation is being performed.  *This endpoint returns a list of Stations*
         * @summary Get Stations
         * @param {StationsApiStationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.stationsList(requestParameters.search, requestParameters.organization, requestParameters.stationType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Station with specified id*
         * @summary Patch Station
         * @param {StationsApiStationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPartialUpdate: function (requestParameters, options) {
            return localVarFp.stationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint creates a new station role with changed permissions.
         * @summary Creates/Updates a station role with set of permissions
         * @param {StationsApiStationsPermissionsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsPartialUpdate: function (requestParameters, options) {
            return localVarFp.stationsPermissionsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of permissions by role
         * @summary Returns a list of permissions by role
         * @param {StationsApiStationsPermissionsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsPermissionsRead: function (requestParameters, options) {
            return localVarFp.stationsPermissionsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Station with specified id*
         * @summary Retrieve Station
         * @param {StationsApiStationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsRead: function (requestParameters, options) {
            return localVarFp.stationsRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint imports the given stop data and extends or creates the existing stops of the given station with it. This API can be used to provide additional data to otherwise anonymous stops created via the loadplan API.  The data expected in the upload (format: CSV), requires the following layout (note that all but the `external_id` column are optional fields)  ```csv external_id,name,zipcode,station_type,... STOP_1,Stop A,129127263,USPS_DDU, ```
         * @summary Import stops data to the given Station.
         * @param {StationsApiStationsStopsImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsStopsImport: function (requestParameters, options) {
            return localVarFp.stationsStopsImport(requestParameters.id, requestParameters.dryRun, requestParameters.geocode, requestParameters.file, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StationsApiFactory = StationsApiFactory;
/**
 * StationsApi - object-oriented interface
 * @export
 * @class StationsApi
 * @extends {BaseAPI}
 */
var StationsApi = /** @class */ (function (_super) {
    __extends(StationsApi, _super);
    function StationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This API will resync all policies with ADM for all stations in the system.
     * @summary Re-sync all polices in the system with ADM.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsAdmsync = function (options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsAdmsync(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Station*
     * @summary Create Station
     * @param {StationsApiStationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Station with specified id*
     * @summary Delete Station
     * @param {StationsApiStationsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint responds with a ZIP-Archive of the labels for all locations & staff in the station. The filters are to reduce the amount of labels returned, e.g. by only considering one area, or zone.
     * @summary Produce all labels for the station
     * @param {StationsApiStationsLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsLabels = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsLabels(requestParameters.id, requestParameters.area, requestParameters.areas, requestParameters.zone, requestParameters.zones, requestParameters.activeLoadpoints, requestParameters.inactiveLoadpoints, requestParameters.dockdoors, requestParameters.staff, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint precaches all labels for the given station using the given format/size and dpi settings.
     * @summary Precache all labels for the station
     * @param {StationsApiStationsLabelsPrecacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsLabelsPrecache = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsLabelsPrecache(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A generalized term that refers to the location where the sortation operation is being performed.  *This endpoint returns a list of Stations*
     * @summary Get Stations
     * @param {StationsApiStationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StationsApiFp)(this.configuration).stationsList(requestParameters.search, requestParameters.organization, requestParameters.stationType, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Station with specified id*
     * @summary Patch Station
     * @param {StationsApiStationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint creates a new station role with changed permissions.
     * @summary Creates/Updates a station role with set of permissions
     * @param {StationsApiStationsPermissionsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsPermissionsPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsPermissionsPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of permissions by role
     * @summary Returns a list of permissions by role
     * @param {StationsApiStationsPermissionsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsPermissionsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsPermissionsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Station with specified id*
     * @summary Retrieve Station
     * @param {StationsApiStationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint imports the given stop data and extends or creates the existing stops of the given station with it. This API can be used to provide additional data to otherwise anonymous stops created via the loadplan API.  The data expected in the upload (format: CSV), requires the following layout (note that all but the `external_id` column are optional fields)  ```csv external_id,name,zipcode,station_type,... STOP_1,Stop A,129127263,USPS_DDU, ```
     * @summary Import stops data to the given Station.
     * @param {StationsApiStationsStopsImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.stationsStopsImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).stationsStopsImport(requestParameters.id, requestParameters.dryRun, requestParameters.geocode, requestParameters.file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StationsApi;
}(base_1.BaseAPI));
exports.StationsApi = StationsApi;
/**
 * @export
 */
exports.StationsLabelsDataFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
/**
 * @export
 */
exports.StationsLabelsPrecacheDataFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
/**
 * @export
 */
exports.StationsListStationTypeEnum = {
    CLOUDSORT: 'CLOUDSORT',
    CLOUDSORT_TEMPLATE: 'CLOUDSORT_TEMPLATE',
    STOP: 'STOP',
    USPS_DNDC: 'USPS_DNDC',
    USPS_DSCF: 'USPS_DSCF',
    USPS_ADC: 'USPS_ADC',
    USPS_ASF: 'USPS_ASF',
    USPS_DDU: 'USPS_DDU',
    USPS_ISC: 'USPS_ISC',
    FEDEX_HUB: 'FEDEX_HUB'
};
/**
 * SystemApi - axios parameter creator
 * @export
 */
var SystemApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Calling this endpoint will restore full system.
         * @summary Restore current system database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemResetCreate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/system/reset";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SystemApiAxiosParamCreator = SystemApiAxiosParamCreator;
/**
 * SystemApi - functional programming interface
 * @export
 */
var SystemApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SystemApiAxiosParamCreator)(configuration);
    return {
        /**
         * Calling this endpoint will restore full system.
         * @summary Restore current system database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemResetCreate: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.systemResetCreate(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SystemApi.systemResetCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SystemApiFp = SystemApiFp;
/**
 * SystemApi - factory interface
 * @export
 */
var SystemApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SystemApiFp)(configuration);
    return {
        /**
         * Calling this endpoint will restore full system.
         * @summary Restore current system database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemResetCreate: function (options) {
            return localVarFp.systemResetCreate(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SystemApiFactory = SystemApiFactory;
/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
var SystemApi = /** @class */ (function (_super) {
    __extends(SystemApi, _super);
    function SystemApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Calling this endpoint will restore full system.
     * @summary Restore current system database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    SystemApi.prototype.systemResetCreate = function (options) {
        var _this = this;
        return (0, exports.SystemApiFp)(this.configuration).systemResetCreate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SystemApi;
}(base_1.BaseAPI));
exports.SystemApi = SystemApi;
/**
 * TaskApi - axios parameter creator
 * @export
 */
var TaskApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieve output file for the given task ID.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskOutput: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('taskOutput', 'id', id);
                            localVarPath = "/task/{id}/output/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Task by ID.
         * @summary Retrieve Task
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('taskRead', 'id', id);
                            localVarPath = "/task/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ### Summary  This API allows to resubmit a given set of tasks via various options. Each group of fields can be used distinctly, only one group of fields can be used at a time.  Use the `dry_run` query parameter to simulate what would happen and retrieve a Resubmission Response before actually submitting the list of tasks.  Use the `all` field to re-submit all tasks, independent of their execution state. If `all` is not `true`, then the resubmission will only target tasks that have either failed, or not been executed at all.  #### Group 1 - Resubmission via Time-boundary and Object Reference  The fields labeled `Group 1` are all required to be set when attempting to resubmit a list of tasks based on a time range. The object ID and object type ID references will be provided by the respective resource API (e.g. WebHooks API).  #### Group 2 - Resubmission via Task IDs  The fields labeled `Group 2` are all required to be set when attempting to resubmit a list of tasks based on their IDs.
         * @summary Resubmit Tasks
         * @param {TaskResubmission} data
         * @param {boolean} [dryRun] Simulate the resubmission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskResubmit: function (data, dryRun, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('taskResubmit', 'data', data);
                            localVarPath = "/task/resubmit/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dryRun !== undefined) {
                                localVarQueryParameter['dry_run'] = dryRun;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TaskApiAxiosParamCreator = TaskApiAxiosParamCreator;
/**
 * TaskApi - functional programming interface
 * @export
 */
var TaskApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TaskApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieve output file for the given task ID.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskOutput: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.taskOutput(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TaskApi.taskOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the Task by ID.
         * @summary Retrieve Task
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.taskRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TaskApi.taskRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * ### Summary  This API allows to resubmit a given set of tasks via various options. Each group of fields can be used distinctly, only one group of fields can be used at a time.  Use the `dry_run` query parameter to simulate what would happen and retrieve a Resubmission Response before actually submitting the list of tasks.  Use the `all` field to re-submit all tasks, independent of their execution state. If `all` is not `true`, then the resubmission will only target tasks that have either failed, or not been executed at all.  #### Group 1 - Resubmission via Time-boundary and Object Reference  The fields labeled `Group 1` are all required to be set when attempting to resubmit a list of tasks based on a time range. The object ID and object type ID references will be provided by the respective resource API (e.g. WebHooks API).  #### Group 2 - Resubmission via Task IDs  The fields labeled `Group 2` are all required to be set when attempting to resubmit a list of tasks based on their IDs.
         * @summary Resubmit Tasks
         * @param {TaskResubmission} data
         * @param {boolean} [dryRun] Simulate the resubmission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskResubmit: function (data, dryRun, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.taskResubmit(data, dryRun, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TaskApi.taskResubmit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TaskApiFp = TaskApiFp;
/**
 * TaskApi - factory interface
 * @export
 */
var TaskApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TaskApiFp)(configuration);
    return {
        /**
         * Retrieve output file for the given task ID.
         * @param {TaskApiTaskOutputRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskOutput: function (requestParameters, options) {
            return localVarFp.taskOutput(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the Task by ID.
         * @summary Retrieve Task
         * @param {TaskApiTaskReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRead: function (requestParameters, options) {
            return localVarFp.taskRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ### Summary  This API allows to resubmit a given set of tasks via various options. Each group of fields can be used distinctly, only one group of fields can be used at a time.  Use the `dry_run` query parameter to simulate what would happen and retrieve a Resubmission Response before actually submitting the list of tasks.  Use the `all` field to re-submit all tasks, independent of their execution state. If `all` is not `true`, then the resubmission will only target tasks that have either failed, or not been executed at all.  #### Group 1 - Resubmission via Time-boundary and Object Reference  The fields labeled `Group 1` are all required to be set when attempting to resubmit a list of tasks based on a time range. The object ID and object type ID references will be provided by the respective resource API (e.g. WebHooks API).  #### Group 2 - Resubmission via Task IDs  The fields labeled `Group 2` are all required to be set when attempting to resubmit a list of tasks based on their IDs.
         * @summary Resubmit Tasks
         * @param {TaskApiTaskResubmitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskResubmit: function (requestParameters, options) {
            return localVarFp.taskResubmit(requestParameters.data, requestParameters.dryRun, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TaskApiFactory = TaskApiFactory;
/**
 * TaskApi - object-oriented interface
 * @export
 * @class TaskApi
 * @extends {BaseAPI}
 */
var TaskApi = /** @class */ (function (_super) {
    __extends(TaskApi, _super);
    function TaskApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve output file for the given task ID.
     * @param {TaskApiTaskOutputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    TaskApi.prototype.taskOutput = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaskApiFp)(this.configuration).taskOutput(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the Task by ID.
     * @summary Retrieve Task
     * @param {TaskApiTaskReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    TaskApi.prototype.taskRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaskApiFp)(this.configuration).taskRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ### Summary  This API allows to resubmit a given set of tasks via various options. Each group of fields can be used distinctly, only one group of fields can be used at a time.  Use the `dry_run` query parameter to simulate what would happen and retrieve a Resubmission Response before actually submitting the list of tasks.  Use the `all` field to re-submit all tasks, independent of their execution state. If `all` is not `true`, then the resubmission will only target tasks that have either failed, or not been executed at all.  #### Group 1 - Resubmission via Time-boundary and Object Reference  The fields labeled `Group 1` are all required to be set when attempting to resubmit a list of tasks based on a time range. The object ID and object type ID references will be provided by the respective resource API (e.g. WebHooks API).  #### Group 2 - Resubmission via Task IDs  The fields labeled `Group 2` are all required to be set when attempting to resubmit a list of tasks based on their IDs.
     * @summary Resubmit Tasks
     * @param {TaskApiTaskResubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    TaskApi.prototype.taskResubmit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaskApiFp)(this.configuration).taskResubmit(requestParameters.data, requestParameters.dryRun, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TaskApi;
}(base_1.BaseAPI));
exports.TaskApi = TaskApi;
/**
 * TrackableContainersApi - axios parameter creator
 * @export
 */
var TrackableContainersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Import Trackable Containers
         * @param {Array<TrackableContainerBulkImport>} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersBulkImport: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersBulkImport', 'data', data);
                            localVarPath = "/trackable_containers/import/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {TrackableContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersCreate', 'data', data);
                            localVarPath = "/trackable_containers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersDelete', 'id', id);
                            localVarPath = "/trackable_containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This view returns the historical journey data for a Trackable Container , including geographical checkpoints (latitude, longitude, and timestamp) recorded during its journey. The data is obtained from the associated Tracker Device\'s journey logs.  Example Response: {     \"id\": 1,     \"trackable_container_history\": [         {             \"lat\": 40.7128,             \"lng\": -74.0060,             \"timestamp\": \"2023-11-02T10:00:00Z\"         },         {             \"lat\": 42.6526,             \"lng\": -73.7562,             \"timestamp\": \"2023-11-02T12:00:00Z\"         },         ...     ] }
         * @summary Retrieve the historical journey data for a Trackable Container.
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersHistory: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersHistory', 'id', id);
                            localVarPath = "/trackable_containers/{id}/history/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [assetId] The asset ID of the Trackable Container.
         * @param {number} [ownerId] The owner ID of the Trackable Container.
         * @param {string} [trackerDeviceIdentifier] The tracker device identifier of the Trackable Container.
         * @param {string} [cornerLl] Left lower coordinate of the map bounds.
         * @param {string} [cornerRu] Right upper coordinate of the map bounds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersList: function (page, pageSize, assetId, ownerId, trackerDeviceIdentifier, cornerLl, cornerRu, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/trackable_containers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (assetId !== undefined) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (ownerId !== undefined) {
                                localVarQueryParameter['owner_id'] = ownerId;
                            }
                            if (trackerDeviceIdentifier !== undefined) {
                                localVarQueryParameter['tracker_device_identifier'] = trackerDeviceIdentifier;
                            }
                            if (cornerLl !== undefined) {
                                localVarQueryParameter['corner_ll'] = cornerLl;
                            }
                            if (cornerRu !== undefined) {
                                localVarQueryParameter['corner_ru'] = cornerRu;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the trackable containers that will fill the map.
         * @summary Retrieve Trackable Containers
         * @param {string} cornerLl Left lower coordinate of the map bounds.
         * @param {string} cornerRu Right upper coordinate of the map bounds.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [assetId] The asset ID of the Trackable Container.
         * @param {number} [ownerId] The owner ID of the Trackable Container.
         * @param {string} [trackerDeviceIdentifier] The tracker device identifier of the Trackable Container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersMap: function (cornerLl, cornerRu, page, pageSize, assetId, ownerId, trackerDeviceIdentifier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cornerLl' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersMap', 'cornerLl', cornerLl);
                            // verify required parameter 'cornerRu' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersMap', 'cornerRu', cornerRu);
                            localVarPath = "/trackable_containers/map/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (assetId !== undefined) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (ownerId !== undefined) {
                                localVarQueryParameter['owner_id'] = ownerId;
                            }
                            if (trackerDeviceIdentifier !== undefined) {
                                localVarQueryParameter['tracker_device_identifier'] = trackerDeviceIdentifier;
                            }
                            if (cornerLl !== undefined) {
                                localVarQueryParameter['corner_ll'] = cornerLl;
                            }
                            if (cornerRu !== undefined) {
                                localVarQueryParameter['corner_ru'] = cornerRu;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {TrackableContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersPartialUpdate', 'data', data);
                            localVarPath = "/trackable_containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('trackableContainersRead', 'id', id);
                            localVarPath = "/trackable_containers/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrackableContainersApiAxiosParamCreator = TrackableContainersApiAxiosParamCreator;
/**
 * TrackableContainersApi - functional programming interface
 * @export
 */
var TrackableContainersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrackableContainersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Import Trackable Containers
         * @param {Array<TrackableContainerBulkImport>} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersBulkImport: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersBulkImport(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersBulkImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {TrackableContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This view returns the historical journey data for a Trackable Container , including geographical checkpoints (latitude, longitude, and timestamp) recorded during its journey. The data is obtained from the associated Tracker Device\'s journey logs.  Example Response: {     \"id\": 1,     \"trackable_container_history\": [         {             \"lat\": 40.7128,             \"lng\": -74.0060,             \"timestamp\": \"2023-11-02T10:00:00Z\"         },         {             \"lat\": 42.6526,             \"lng\": -73.7562,             \"timestamp\": \"2023-11-02T12:00:00Z\"         },         ...     ] }
         * @summary Retrieve the historical journey data for a Trackable Container.
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersHistory: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersHistory(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [assetId] The asset ID of the Trackable Container.
         * @param {number} [ownerId] The owner ID of the Trackable Container.
         * @param {string} [trackerDeviceIdentifier] The tracker device identifier of the Trackable Container.
         * @param {string} [cornerLl] Left lower coordinate of the map bounds.
         * @param {string} [cornerRu] Right upper coordinate of the map bounds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersList: function (page, pageSize, assetId, ownerId, trackerDeviceIdentifier, cornerLl, cornerRu, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersList(page, pageSize, assetId, ownerId, trackerDeviceIdentifier, cornerLl, cornerRu, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the trackable containers that will fill the map.
         * @summary Retrieve Trackable Containers
         * @param {string} cornerLl Left lower coordinate of the map bounds.
         * @param {string} cornerRu Right upper coordinate of the map bounds.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {string} [assetId] The asset ID of the Trackable Container.
         * @param {number} [ownerId] The owner ID of the Trackable Container.
         * @param {string} [trackerDeviceIdentifier] The tracker device identifier of the Trackable Container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersMap: function (cornerLl, cornerRu, page, pageSize, assetId, ownerId, trackerDeviceIdentifier, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersMap(cornerLl, cornerRu, page, pageSize, assetId, ownerId, trackerDeviceIdentifier, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersMap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {TrackableContainer} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this trackable container.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackableContainersRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackableContainersApi.trackableContainersRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TrackableContainersApiFp = TrackableContainersApiFp;
/**
 * TrackableContainersApi - factory interface
 * @export
 */
var TrackableContainersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrackableContainersApiFp)(configuration);
    return {
        /**
         * Import Trackable Containers
         * @param {TrackableContainersApiTrackableContainersBulkImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersBulkImport: function (requestParameters, options) {
            return localVarFp.trackableContainersBulkImport(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TrackableContainersApiTrackableContainersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersCreate: function (requestParameters, options) {
            return localVarFp.trackableContainersCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TrackableContainersApiTrackableContainersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersDelete: function (requestParameters, options) {
            return localVarFp.trackableContainersDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This view returns the historical journey data for a Trackable Container , including geographical checkpoints (latitude, longitude, and timestamp) recorded during its journey. The data is obtained from the associated Tracker Device\'s journey logs.  Example Response: {     \"id\": 1,     \"trackable_container_history\": [         {             \"lat\": 40.7128,             \"lng\": -74.0060,             \"timestamp\": \"2023-11-02T10:00:00Z\"         },         {             \"lat\": 42.6526,             \"lng\": -73.7562,             \"timestamp\": \"2023-11-02T12:00:00Z\"         },         ...     ] }
         * @summary Retrieve the historical journey data for a Trackable Container.
         * @param {TrackableContainersApiTrackableContainersHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersHistory: function (requestParameters, options) {
            return localVarFp.trackableContainersHistory(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TrackableContainersApiTrackableContainersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.trackableContainersList(requestParameters.page, requestParameters.pageSize, requestParameters.assetId, requestParameters.ownerId, requestParameters.trackerDeviceIdentifier, requestParameters.cornerLl, requestParameters.cornerRu, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the trackable containers that will fill the map.
         * @summary Retrieve Trackable Containers
         * @param {TrackableContainersApiTrackableContainersMapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersMap: function (requestParameters, options) {
            return localVarFp.trackableContainersMap(requestParameters.cornerLl, requestParameters.cornerRu, requestParameters.page, requestParameters.pageSize, requestParameters.assetId, requestParameters.ownerId, requestParameters.trackerDeviceIdentifier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TrackableContainersApiTrackableContainersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersPartialUpdate: function (requestParameters, options) {
            return localVarFp.trackableContainersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {TrackableContainersApiTrackableContainersReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackableContainersRead: function (requestParameters, options) {
            return localVarFp.trackableContainersRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrackableContainersApiFactory = TrackableContainersApiFactory;
/**
 * TrackableContainersApi - object-oriented interface
 * @export
 * @class TrackableContainersApi
 * @extends {BaseAPI}
 */
var TrackableContainersApi = /** @class */ (function (_super) {
    __extends(TrackableContainersApi, _super);
    function TrackableContainersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Import Trackable Containers
     * @param {TrackableContainersApiTrackableContainersBulkImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersBulkImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersBulkImport(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TrackableContainersApiTrackableContainersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TrackableContainersApiTrackableContainersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This view returns the historical journey data for a Trackable Container , including geographical checkpoints (latitude, longitude, and timestamp) recorded during its journey. The data is obtained from the associated Tracker Device\'s journey logs.  Example Response: {     \"id\": 1,     \"trackable_container_history\": [         {             \"lat\": 40.7128,             \"lng\": -74.0060,             \"timestamp\": \"2023-11-02T10:00:00Z\"         },         {             \"lat\": 42.6526,             \"lng\": -73.7562,             \"timestamp\": \"2023-11-02T12:00:00Z\"         },         ...     ] }
     * @summary Retrieve the historical journey data for a Trackable Container.
     * @param {TrackableContainersApiTrackableContainersHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersHistory(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TrackableContainersApiTrackableContainersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersList(requestParameters.page, requestParameters.pageSize, requestParameters.assetId, requestParameters.ownerId, requestParameters.trackerDeviceIdentifier, requestParameters.cornerLl, requestParameters.cornerRu, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the trackable containers that will fill the map.
     * @summary Retrieve Trackable Containers
     * @param {TrackableContainersApiTrackableContainersMapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersMap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersMap(requestParameters.cornerLl, requestParameters.cornerRu, requestParameters.page, requestParameters.pageSize, requestParameters.assetId, requestParameters.ownerId, requestParameters.trackerDeviceIdentifier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TrackableContainersApiTrackableContainersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {TrackableContainersApiTrackableContainersReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackableContainersApi
     */
    TrackableContainersApi.prototype.trackableContainersRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackableContainersApiFp)(this.configuration).trackableContainersRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrackableContainersApi;
}(base_1.BaseAPI));
exports.TrackableContainersApi = TrackableContainersApi;
/**
 * TrackingApi - axios parameter creator
 * @export
 */
var TrackingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * *This endpoint returns a list of Packages and the tracking records of this objects*
         * @summary Get package tracking information
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {Array<string>} [trackingNumbers] Filter by package tracking numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingList: function (page, pageSize, trackingNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tracking/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (trackingNumbers) {
                                localVarQueryParameter['tracking_numbers'] = trackingNumbers.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrackingApiAxiosParamCreator = TrackingApiAxiosParamCreator;
/**
 * TrackingApi - functional programming interface
 * @export
 */
var TrackingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrackingApiAxiosParamCreator)(configuration);
    return {
        /**
         * *This endpoint returns a list of Packages and the tracking records of this objects*
         * @summary Get package tracking information
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {Array<string>} [trackingNumbers] Filter by package tracking numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingList: function (page, pageSize, trackingNumbers, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackingList(page, pageSize, trackingNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TrackingApi.trackingList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TrackingApiFp = TrackingApiFp;
/**
 * TrackingApi - factory interface
 * @export
 */
var TrackingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrackingApiFp)(configuration);
    return {
        /**
         * *This endpoint returns a list of Packages and the tracking records of this objects*
         * @summary Get package tracking information
         * @param {TrackingApiTrackingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.trackingList(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumbers, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrackingApiFactory = TrackingApiFactory;
/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
var TrackingApi = /** @class */ (function (_super) {
    __extends(TrackingApi, _super);
    function TrackingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * *This endpoint returns a list of Packages and the tracking records of this objects*
     * @summary Get package tracking information
     * @param {TrackingApiTrackingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    TrackingApi.prototype.trackingList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TrackingApiFp)(this.configuration).trackingList(requestParameters.page, requestParameters.pageSize, requestParameters.trackingNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrackingApi;
}(base_1.BaseAPI));
exports.TrackingApi = TrackingApi;
/**
 * WeatherApi - axios parameter creator
 * @export
 */
var WeatherApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Requests weather data for the given location from OpenWeatherMap and returns the relevant parameters. The relevant parameters are temperature, weather conditions and the location id.
         * @summary Get weather data for a given location.
         * @param {string} q Location. Format: &lt;zip_code&gt;,&lt;country_code&gt; or &lt;city_name&gt;,&lt;country_code&gt;
         * @param {WeatherListUnitsEnum} units Unit system for temperature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weatherList: function (q, units, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'q' is not null or undefined
                            (0, common_1.assertParamExists)('weatherList', 'q', q);
                            // verify required parameter 'units' is not null or undefined
                            (0, common_1.assertParamExists)('weatherList', 'units', units);
                            localVarPath = "/weather/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (units !== undefined) {
                                localVarQueryParameter['units'] = units;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.WeatherApiAxiosParamCreator = WeatherApiAxiosParamCreator;
/**
 * WeatherApi - functional programming interface
 * @export
 */
var WeatherApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WeatherApiAxiosParamCreator)(configuration);
    return {
        /**
         * Requests weather data for the given location from OpenWeatherMap and returns the relevant parameters. The relevant parameters are temperature, weather conditions and the location id.
         * @summary Get weather data for a given location.
         * @param {string} q Location. Format: &lt;zip_code&gt;,&lt;country_code&gt; or &lt;city_name&gt;,&lt;country_code&gt;
         * @param {WeatherListUnitsEnum} units Unit system for temperature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weatherList: function (q, units, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.weatherList(q, units, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WeatherApi.weatherList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.WeatherApiFp = WeatherApiFp;
/**
 * WeatherApi - factory interface
 * @export
 */
var WeatherApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WeatherApiFp)(configuration);
    return {
        /**
         * Requests weather data for the given location from OpenWeatherMap and returns the relevant parameters. The relevant parameters are temperature, weather conditions and the location id.
         * @summary Get weather data for a given location.
         * @param {WeatherApiWeatherListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weatherList: function (requestParameters, options) {
            return localVarFp.weatherList(requestParameters.q, requestParameters.units, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WeatherApiFactory = WeatherApiFactory;
/**
 * WeatherApi - object-oriented interface
 * @export
 * @class WeatherApi
 * @extends {BaseAPI}
 */
var WeatherApi = /** @class */ (function (_super) {
    __extends(WeatherApi, _super);
    function WeatherApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Requests weather data for the given location from OpenWeatherMap and returns the relevant parameters. The relevant parameters are temperature, weather conditions and the location id.
     * @summary Get weather data for a given location.
     * @param {WeatherApiWeatherListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeatherApi
     */
    WeatherApi.prototype.weatherList = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WeatherApiFp)(this.configuration).weatherList(requestParameters.q, requestParameters.units, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WeatherApi;
}(base_1.BaseAPI));
exports.WeatherApi = WeatherApi;
/**
 * @export
 */
exports.WeatherListUnitsEnum = {
    IMPERIAL: 'Imperial',
    METRIC: 'Metric'
};
/**
 * WebhooksApi - axios parameter creator
 * @export
 */
var WebhooksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint creates a new WebHook Subscription. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.  The request will return the following data: * The `id` of the WebHook Subscription * The `url` to which the CloudSort System will notify if a certain event got triggered. Supported protocols are HTTP, HTTPS, FTP and SFTP. * The `method` that the CloudSort System will use to do that request - `PUT` or `POST` (only applies if protocol is HTTP or HTTPS) * The `owner_id` if the WebHook Subscription was created by a Customer * The `organization_id` if the WebHook Subscription was created by an Organization Staff * The `filter_events` which indicates what should trigger the CloudSort System to notify the Subscriber  The `filter_events` works as an array of objects that can have the following fields: * `filter_type`, e.g. `TRACKING_UPDATE` or `OUTBOUND_MANIFEST`. To receive all webhooks for all types of events, use `*`. * `resource_type` which defines which resource the Subscriber wants to be notified of. Can be either `PACKAGE` or `CONTAINER` and if empty will default to `PACKAGE`. To subscribe to all resource types, use `*`. * `station_id` which indicates the Station from where the Subscriber wants to be notified. To subscribe to all stations, leave empty, or omit.  Depending on the `filter_type` the following additional filters are as well available: * `event_types` - for `TRACKING_UPDATE` subscriptions - which defines what Event types should make the CloudSort System notify the Subscriber about. Use `[]` (empty list) to subscribe to all possible events, and omit the parameter to subscribe to the default, most relevant set of events.  The `disabled` flag (also available on the PATCH endpoint) adds the ability to pause/resume a Subscription temporarily. The system itself may act auto- matically and disable a Subscription if it detects the target has become unhealthy.
         * @summary Create Outbound WebHook Subscription
         * @param {WebHookSubscription} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksCreate', 'data', data);
                            localVarPath = "/webhooks/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint deletes an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Delete Outbound WebHook Subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksDelete', 'id', id);
                            localVarPath = "/webhooks/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of WebHook Subscriptions. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Get Outbound WebHook Subscriptions
         * @param {number} [owner] Filter by Owner ID
         * @param {number} [organization] Filter by Organization ID
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksList: function (owner, organization, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/webhooks/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (owner !== undefined) {
                                localVarQueryParameter['owner'] = owner;
                            }
                            if (organization !== undefined) {
                                localVarQueryParameter['organization'] = organization;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Patch Outbound WebHook Subscription
         * @param {number} id
         * @param {WebHookSubscription} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksPartialUpdate', 'data', data);
                            localVarPath = "/webhooks/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the WebHook Subscriptions by ID. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Retrieve Outbound WebHook Subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksRead', 'id', id);
                            localVarPath = "/webhooks/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary WebHook Subscription Task History
         * @param {number} id
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksTaskhistory: function (id, pageSize, page, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksTaskhistory', 'id', id);
                            localVarPath = "/webhooks/{id}/taskhistory/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.WebhooksApiAxiosParamCreator = WebhooksApiAxiosParamCreator;
/**
 * WebhooksApi - functional programming interface
 * @export
 */
var WebhooksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WebhooksApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint creates a new WebHook Subscription. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.  The request will return the following data: * The `id` of the WebHook Subscription * The `url` to which the CloudSort System will notify if a certain event got triggered. Supported protocols are HTTP, HTTPS, FTP and SFTP. * The `method` that the CloudSort System will use to do that request - `PUT` or `POST` (only applies if protocol is HTTP or HTTPS) * The `owner_id` if the WebHook Subscription was created by a Customer * The `organization_id` if the WebHook Subscription was created by an Organization Staff * The `filter_events` which indicates what should trigger the CloudSort System to notify the Subscriber  The `filter_events` works as an array of objects that can have the following fields: * `filter_type`, e.g. `TRACKING_UPDATE` or `OUTBOUND_MANIFEST`. To receive all webhooks for all types of events, use `*`. * `resource_type` which defines which resource the Subscriber wants to be notified of. Can be either `PACKAGE` or `CONTAINER` and if empty will default to `PACKAGE`. To subscribe to all resource types, use `*`. * `station_id` which indicates the Station from where the Subscriber wants to be notified. To subscribe to all stations, leave empty, or omit.  Depending on the `filter_type` the following additional filters are as well available: * `event_types` - for `TRACKING_UPDATE` subscriptions - which defines what Event types should make the CloudSort System notify the Subscriber about. Use `[]` (empty list) to subscribe to all possible events, and omit the parameter to subscribe to the default, most relevant set of events.  The `disabled` flag (also available on the PATCH endpoint) adds the ability to pause/resume a Subscription temporarily. The system itself may act auto- matically and disable a Subscription if it detects the target has become unhealthy.
         * @summary Create Outbound WebHook Subscription
         * @param {WebHookSubscription} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint deletes an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Delete Outbound WebHook Subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns a list of WebHook Subscriptions. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Get Outbound WebHook Subscriptions
         * @param {number} [owner] Filter by Owner ID
         * @param {number} [organization] Filter by Organization ID
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksList: function (owner, organization, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksList(owner, organization, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint updates an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Patch Outbound WebHook Subscription
         * @param {number} id
         * @param {WebHookSubscription} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the WebHook Subscriptions by ID. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Retrieve Outbound WebHook Subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary WebHook Subscription Task History
         * @param {number} id
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksTaskhistory: function (id, pageSize, page, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksTaskhistory(id, pageSize, page, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksApi.webhooksTaskhistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.WebhooksApiFp = WebhooksApiFp;
/**
 * WebhooksApi - factory interface
 * @export
 */
var WebhooksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WebhooksApiFp)(configuration);
    return {
        /**
         * This endpoint creates a new WebHook Subscription. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.  The request will return the following data: * The `id` of the WebHook Subscription * The `url` to which the CloudSort System will notify if a certain event got triggered. Supported protocols are HTTP, HTTPS, FTP and SFTP. * The `method` that the CloudSort System will use to do that request - `PUT` or `POST` (only applies if protocol is HTTP or HTTPS) * The `owner_id` if the WebHook Subscription was created by a Customer * The `organization_id` if the WebHook Subscription was created by an Organization Staff * The `filter_events` which indicates what should trigger the CloudSort System to notify the Subscriber  The `filter_events` works as an array of objects that can have the following fields: * `filter_type`, e.g. `TRACKING_UPDATE` or `OUTBOUND_MANIFEST`. To receive all webhooks for all types of events, use `*`. * `resource_type` which defines which resource the Subscriber wants to be notified of. Can be either `PACKAGE` or `CONTAINER` and if empty will default to `PACKAGE`. To subscribe to all resource types, use `*`. * `station_id` which indicates the Station from where the Subscriber wants to be notified. To subscribe to all stations, leave empty, or omit.  Depending on the `filter_type` the following additional filters are as well available: * `event_types` - for `TRACKING_UPDATE` subscriptions - which defines what Event types should make the CloudSort System notify the Subscriber about. Use `[]` (empty list) to subscribe to all possible events, and omit the parameter to subscribe to the default, most relevant set of events.  The `disabled` flag (also available on the PATCH endpoint) adds the ability to pause/resume a Subscription temporarily. The system itself may act auto- matically and disable a Subscription if it detects the target has become unhealthy.
         * @summary Create Outbound WebHook Subscription
         * @param {WebhooksApiWebhooksCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksCreate: function (requestParameters, options) {
            return localVarFp.webhooksCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint deletes an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Delete Outbound WebHook Subscription
         * @param {WebhooksApiWebhooksDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksDelete: function (requestParameters, options) {
            return localVarFp.webhooksDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns a list of WebHook Subscriptions. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Get Outbound WebHook Subscriptions
         * @param {WebhooksApiWebhooksListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.webhooksList(requestParameters.owner, requestParameters.organization, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint updates an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Patch Outbound WebHook Subscription
         * @param {WebhooksApiWebhooksPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksPartialUpdate: function (requestParameters, options) {
            return localVarFp.webhooksPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the WebHook Subscriptions by ID. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
         * @summary Retrieve Outbound WebHook Subscription
         * @param {WebhooksApiWebhooksReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksRead: function (requestParameters, options) {
            return localVarFp.webhooksRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary WebHook Subscription Task History
         * @param {WebhooksApiWebhooksTaskhistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksTaskhistory: function (requestParameters, options) {
            return localVarFp.webhooksTaskhistory(requestParameters.id, requestParameters.pageSize, requestParameters.page, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WebhooksApiFactory = WebhooksApiFactory;
/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
var WebhooksApi = /** @class */ (function (_super) {
    __extends(WebhooksApi, _super);
    function WebhooksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint creates a new WebHook Subscription. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.  The request will return the following data: * The `id` of the WebHook Subscription * The `url` to which the CloudSort System will notify if a certain event got triggered. Supported protocols are HTTP, HTTPS, FTP and SFTP. * The `method` that the CloudSort System will use to do that request - `PUT` or `POST` (only applies if protocol is HTTP or HTTPS) * The `owner_id` if the WebHook Subscription was created by a Customer * The `organization_id` if the WebHook Subscription was created by an Organization Staff * The `filter_events` which indicates what should trigger the CloudSort System to notify the Subscriber  The `filter_events` works as an array of objects that can have the following fields: * `filter_type`, e.g. `TRACKING_UPDATE` or `OUTBOUND_MANIFEST`. To receive all webhooks for all types of events, use `*`. * `resource_type` which defines which resource the Subscriber wants to be notified of. Can be either `PACKAGE` or `CONTAINER` and if empty will default to `PACKAGE`. To subscribe to all resource types, use `*`. * `station_id` which indicates the Station from where the Subscriber wants to be notified. To subscribe to all stations, leave empty, or omit.  Depending on the `filter_type` the following additional filters are as well available: * `event_types` - for `TRACKING_UPDATE` subscriptions - which defines what Event types should make the CloudSort System notify the Subscriber about. Use `[]` (empty list) to subscribe to all possible events, and omit the parameter to subscribe to the default, most relevant set of events.  The `disabled` flag (also available on the PATCH endpoint) adds the ability to pause/resume a Subscription temporarily. The system itself may act auto- matically and disable a Subscription if it detects the target has become unhealthy.
     * @summary Create Outbound WebHook Subscription
     * @param {WebhooksApiWebhooksCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint deletes an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
     * @summary Delete Outbound WebHook Subscription
     * @param {WebhooksApiWebhooksDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns a list of WebHook Subscriptions. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
     * @summary Get Outbound WebHook Subscriptions
     * @param {WebhooksApiWebhooksListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksList(requestParameters.owner, requestParameters.organization, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint updates an existing WebHook Subscription by ID. In order to make the request, the user needs to be:  * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
     * @summary Patch Outbound WebHook Subscription
     * @param {WebhooksApiWebhooksPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the WebHook Subscriptions by ID. In order to make the request, the user needs to be either:  * Super User/Corporate Admin, in which the User will have access to all WebHook Subscriptions; * Customer or Organization Staff in which the User will only have access to the WebHook Subscriptions assigned and created by them.
     * @summary Retrieve Outbound WebHook Subscription
     * @param {WebhooksApiWebhooksReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary WebHook Subscription Task History
     * @param {WebhooksApiWebhooksTaskhistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    WebhooksApi.prototype.webhooksTaskhistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration).webhooksTaskhistory(requestParameters.id, requestParameters.pageSize, requestParameters.page, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhooksApi;
}(base_1.BaseAPI));
exports.WebhooksApi = WebhooksApi;
/**
 * WebhooksInboundApi - axios parameter creator
 * @export
 */
var WebhooksInboundApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint generates an api token that will be used to authenticate requests when consuming third-party webhooks. A signed token will be returned in the response and the original token will be stored in the db.  Every WebHook source requires to use a separate token as each is bound to a specific input-type.
         * @summary Inbound WebHooks: Generate a third-party WebHook ingestion token.
         * @param {WebHookGenerateApiToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundGenerateToken: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksInboundGenerateToken', 'data', data);
                            localVarPath = "/webhooks/generate_token/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint consumes third-party webhooks, using the given API token as a form of authentication. The API token is generated for a specific input-type, so it is important that each source uses their own distinct token.
         * @summary Inbound WebHooks: Ingest a third-party WebHook Payload.
         * @param {string} apiToken API Authentication Token (Ingestion Permit)
         * @param {object} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundIngest: function (apiToken, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'apiToken' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksInboundIngest', 'apiToken', apiToken);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('webhooksInboundIngest', 'data', data);
                            localVarPath = "/webhooks/ingest/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (apiToken !== undefined) {
                                localVarQueryParameter['api_token'] = apiToken;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.WebhooksInboundApiAxiosParamCreator = WebhooksInboundApiAxiosParamCreator;
/**
 * WebhooksInboundApi - functional programming interface
 * @export
 */
var WebhooksInboundApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WebhooksInboundApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint generates an api token that will be used to authenticate requests when consuming third-party webhooks. A signed token will be returned in the response and the original token will be stored in the db.  Every WebHook source requires to use a separate token as each is bound to a specific input-type.
         * @summary Inbound WebHooks: Generate a third-party WebHook ingestion token.
         * @param {WebHookGenerateApiToken} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundGenerateToken: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksInboundGenerateToken(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksInboundApi.webhooksInboundGenerateToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint consumes third-party webhooks, using the given API token as a form of authentication. The API token is generated for a specific input-type, so it is important that each source uses their own distinct token.
         * @summary Inbound WebHooks: Ingest a third-party WebHook Payload.
         * @param {string} apiToken API Authentication Token (Ingestion Permit)
         * @param {object} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundIngest: function (apiToken, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.webhooksInboundIngest(apiToken, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WebhooksInboundApi.webhooksInboundIngest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.WebhooksInboundApiFp = WebhooksInboundApiFp;
/**
 * WebhooksInboundApi - factory interface
 * @export
 */
var WebhooksInboundApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WebhooksInboundApiFp)(configuration);
    return {
        /**
         * This endpoint generates an api token that will be used to authenticate requests when consuming third-party webhooks. A signed token will be returned in the response and the original token will be stored in the db.  Every WebHook source requires to use a separate token as each is bound to a specific input-type.
         * @summary Inbound WebHooks: Generate a third-party WebHook ingestion token.
         * @param {WebhooksInboundApiWebhooksInboundGenerateTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundGenerateToken: function (requestParameters, options) {
            return localVarFp.webhooksInboundGenerateToken(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint consumes third-party webhooks, using the given API token as a form of authentication. The API token is generated for a specific input-type, so it is important that each source uses their own distinct token.
         * @summary Inbound WebHooks: Ingest a third-party WebHook Payload.
         * @param {WebhooksInboundApiWebhooksInboundIngestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhooksInboundIngest: function (requestParameters, options) {
            return localVarFp.webhooksInboundIngest(requestParameters.apiToken, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WebhooksInboundApiFactory = WebhooksInboundApiFactory;
/**
 * WebhooksInboundApi - object-oriented interface
 * @export
 * @class WebhooksInboundApi
 * @extends {BaseAPI}
 */
var WebhooksInboundApi = /** @class */ (function (_super) {
    __extends(WebhooksInboundApi, _super);
    function WebhooksInboundApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint generates an api token that will be used to authenticate requests when consuming third-party webhooks. A signed token will be returned in the response and the original token will be stored in the db.  Every WebHook source requires to use a separate token as each is bound to a specific input-type.
     * @summary Inbound WebHooks: Generate a third-party WebHook ingestion token.
     * @param {WebhooksInboundApiWebhooksInboundGenerateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksInboundApi
     */
    WebhooksInboundApi.prototype.webhooksInboundGenerateToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksInboundApiFp)(this.configuration).webhooksInboundGenerateToken(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint consumes third-party webhooks, using the given API token as a form of authentication. The API token is generated for a specific input-type, so it is important that each source uses their own distinct token.
     * @summary Inbound WebHooks: Ingest a third-party WebHook Payload.
     * @param {WebhooksInboundApiWebhooksInboundIngestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksInboundApi
     */
    WebhooksInboundApi.prototype.webhooksInboundIngest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksInboundApiFp)(this.configuration).webhooksInboundIngest(requestParameters.apiToken, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhooksInboundApi;
}(base_1.BaseAPI));
exports.WebhooksInboundApi = WebhooksInboundApi;
/**
 * ZonesApi - axios parameter creator
 * @export
 */
var ZonesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint returns the Zone using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Zone by query
         * @param {number} [id] Zone ID
         * @param {string} [name] Zone Name
         * @param {number} [area] Area ID
         * @param {string} [areaName] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesByquery: function (id, name, area, areaName, station, stationName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/zones/byquery/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (areaName !== undefined) {
                                localVarQueryParameter['area_name'] = areaName;
                            }
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (stationName !== undefined) {
                                localVarQueryParameter['station_name'] = stationName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Zone*
         * @summary Create Zone
         * @param {Zone} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesCreate: function (data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('zonesCreate', 'data', data);
                            localVarPath = "/zones/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Zone with specified id*
         * @summary Delete Zone
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesDelete', 'id', id);
                            localVarPath = "/zones/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Zone, which is contains a human-readable name of the zone and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Zone
         * @param {number} id
         * @param {ZonesLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabel: function (id, dataFormat, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesLabel', 'id', id);
                            localVarPath = "/zones/{id}/label/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (dataFormat !== undefined) {
                                localVarQueryParameter['data_format'] = dataFormat;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Zone by ID.
         * @summary Get the PNG label for the a Zone
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelPng: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesLabelLabelPng', 'id', id);
                            localVarPath = "/zones/{id}/label/png/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Zone by ID.
         * @summary Get the ZPL label for a Zone
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelZpl: function (id, size, dpi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesLabelLabelZpl', 'id', id);
                            localVarPath = "/zones/{id}/label/zpl/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (dpi !== undefined) {
                                localVarQueryParameter['dpi'] = dpi;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * A Zone is an Activity Area in a Station that is subordinate to a Primary Sort or Secondary Sort and consists of a collection of Load Points. In CloudSort Stations, Zones are modular. As part of a Secondary Sort Area, the typical configuration is 12 pallet positions but Zones can support a variety of Continare devices, including bags and Aircraft ULDs. Zones are useful for grouping destinations, simplifying sortation, and creating Visual Sortation Marker Files.  *This endpoint returns a list of Zones*
         * @summary Get Zones
         * @param {number} [station] Station ID
         * @param {number} [area] Area ID
         * @param {ZonesListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesList: function (station, area, sortBy, search, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/zones/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (station !== undefined) {
                                localVarQueryParameter['station'] = station;
                            }
                            if (area !== undefined) {
                                localVarQueryParameter['area'] = area;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page_size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Zone with specified id*
         * @summary Patch Zone
         * @param {number} id
         * @param {ZoneDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesPartialUpdate: function (id, data, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesPartialUpdate', 'id', id);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('zonesPartialUpdate', 'data', data);
                            localVarPath = "/zones/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Zone with specified id*
         * @summary Retrieve Zone
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesRead: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('zonesRead', 'id', id);
                            localVarPath = "/zones/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ZonesApiAxiosParamCreator = ZonesApiAxiosParamCreator;
/**
 * ZonesApi - functional programming interface
 * @export
 */
var ZonesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ZonesApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint returns the Zone using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Zone by query
         * @param {number} [id] Zone ID
         * @param {string} [name] Zone Name
         * @param {number} [area] Area ID
         * @param {string} [areaName] Area Name
         * @param {number} [station] Station ID
         * @param {string} [stationName] Station Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesByquery: function (id, name, area, areaName, station, stationName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesByquery(id, name, area, areaName, station, stationName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesByquery']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will create a new Zone*
         * @summary Create Zone
         * @param {Zone} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesCreate: function (data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesCreate(data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will delete the Zone with specified id*
         * @summary Delete Zone
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the printable label for a Zone, which is contains a human-readable name of the zone and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Zone
         * @param {number} id
         * @param {ZonesLabelDataFormatEnum} [dataFormat] Format
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabel: function (id, dataFormat, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesLabel(id, dataFormat, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesLabel']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the PNG label for a Zone by ID.
         * @summary Get the PNG label for the a Zone
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelPng: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesLabelLabelPng(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesLabelLabelPng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Zone by ID.
         * @summary Get the ZPL label for a Zone
         * @param {number} id
         * @param {string} [size] Size (wxh)
         * @param {number} [dpi] DPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelZpl: function (id, size, dpi, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesLabelLabelZpl(id, size, dpi, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesLabelLabelZpl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A Zone is an Activity Area in a Station that is subordinate to a Primary Sort or Secondary Sort and consists of a collection of Load Points. In CloudSort Stations, Zones are modular. As part of a Secondary Sort Area, the typical configuration is 12 pallet positions but Zones can support a variety of Continare devices, including bags and Aircraft ULDs. Zones are useful for grouping destinations, simplifying sortation, and creating Visual Sortation Marker Files.  *This endpoint returns a list of Zones*
         * @summary Get Zones
         * @param {number} [station] Station ID
         * @param {number} [area] Area ID
         * @param {ZonesListSortByEnum} [sortBy] Sort By
         * @param {string} [search]
         * @param {number} [page] A page number within the paginated result set, starting with &#x60;1&#x60;. If larger than the available number of pages the endpoint returns a 404. Defaults to &#x60;1&#x60;.
         * @param {number} [pageSize] The number of results to load per page. This determines the total number of available pages. Set this to &#x60;0&#x60; to get only the &#x60;count&#x60; as a response. Defaults to &#x60;10&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesList: function (station, area, sortBy, search, page, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesList(station, area, sortBy, search, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint will partially update (patch) the Zone with specified id*
         * @summary Patch Zone
         * @param {number} id
         * @param {ZoneDetails} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesPartialUpdate: function (id, data, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesPartialUpdate(id, data, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * *This endpoint returns the Zone with specified id*
         * @summary Retrieve Zone
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesRead: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.zonesRead(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ZonesApi.zonesRead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ZonesApiFp = ZonesApiFp;
/**
 * ZonesApi - factory interface
 * @export
 */
var ZonesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ZonesApiFp)(configuration);
    return {
        /**
         * This endpoint returns the Zone using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
         * @summary Get a Zone by query
         * @param {ZonesApiZonesByqueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesByquery: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.zonesByquery(requestParameters.id, requestParameters.name, requestParameters.area, requestParameters.areaName, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will create a new Zone*
         * @summary Create Zone
         * @param {ZonesApiZonesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesCreate: function (requestParameters, options) {
            return localVarFp.zonesCreate(requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will delete the Zone with specified id*
         * @summary Delete Zone
         * @param {ZonesApiZonesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesDelete: function (requestParameters, options) {
            return localVarFp.zonesDelete(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the printable label for a Zone, which is contains a human-readable name of the zone and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
         * @summary DEPRECATED Get the label for a Zone
         * @param {ZonesApiZonesLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabel: function (requestParameters, options) {
            return localVarFp.zonesLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the PNG label for a Zone by ID.
         * @summary Get the PNG label for the a Zone
         * @param {ZonesApiZonesLabelLabelPngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelPng: function (requestParameters, options) {
            return localVarFp.zonesLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint returns the ZPL label as JSON for a Zone by ID.
         * @summary Get the ZPL label for a Zone
         * @param {ZonesApiZonesLabelLabelZplRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesLabelLabelZpl: function (requestParameters, options) {
            return localVarFp.zonesLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A Zone is an Activity Area in a Station that is subordinate to a Primary Sort or Secondary Sort and consists of a collection of Load Points. In CloudSort Stations, Zones are modular. As part of a Secondary Sort Area, the typical configuration is 12 pallet positions but Zones can support a variety of Continare devices, including bags and Aircraft ULDs. Zones are useful for grouping destinations, simplifying sortation, and creating Visual Sortation Marker Files.  *This endpoint returns a list of Zones*
         * @summary Get Zones
         * @param {ZonesApiZonesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesList: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.zonesList(requestParameters.station, requestParameters.area, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint will partially update (patch) the Zone with specified id*
         * @summary Patch Zone
         * @param {ZonesApiZonesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesPartialUpdate: function (requestParameters, options) {
            return localVarFp.zonesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * *This endpoint returns the Zone with specified id*
         * @summary Retrieve Zone
         * @param {ZonesApiZonesReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesRead: function (requestParameters, options) {
            return localVarFp.zonesRead(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ZonesApiFactory = ZonesApiFactory;
/**
 * ZonesApi - object-oriented interface
 * @export
 * @class ZonesApi
 * @extends {BaseAPI}
 */
var ZonesApi = /** @class */ (function (_super) {
    __extends(ZonesApi, _super);
    function ZonesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint returns the Zone using the specified query and can be used as drop-in replacement for the `retrieve` endpoint.
     * @summary Get a Zone by query
     * @param {ZonesApiZonesByqueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesByquery = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ZonesApiFp)(this.configuration).zonesByquery(requestParameters.id, requestParameters.name, requestParameters.area, requestParameters.areaName, requestParameters.station, requestParameters.stationName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will create a new Zone*
     * @summary Create Zone
     * @param {ZonesApiZonesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesCreate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesCreate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will delete the Zone with specified id*
     * @summary Delete Zone
     * @param {ZonesApiZonesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesDelete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the printable label for a Zone, which is contains a human-readable name of the zone and a machine-readable QR-code that defines a query payload for the `/byquery` endpoint. The label is provided in a printable format given the parameters.
     * @summary DEPRECATED Get the label for a Zone
     * @param {ZonesApiZonesLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesLabel = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesLabel(requestParameters.id, requestParameters.dataFormat, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the PNG label for a Zone by ID.
     * @summary Get the PNG label for the a Zone
     * @param {ZonesApiZonesLabelLabelPngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesLabelLabelPng = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesLabelLabelPng(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint returns the ZPL label as JSON for a Zone by ID.
     * @summary Get the ZPL label for a Zone
     * @param {ZonesApiZonesLabelLabelZplRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesLabelLabelZpl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesLabelLabelZpl(requestParameters.id, requestParameters.size, requestParameters.dpi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A Zone is an Activity Area in a Station that is subordinate to a Primary Sort or Secondary Sort and consists of a collection of Load Points. In CloudSort Stations, Zones are modular. As part of a Secondary Sort Area, the typical configuration is 12 pallet positions but Zones can support a variety of Continare devices, including bags and Aircraft ULDs. Zones are useful for grouping destinations, simplifying sortation, and creating Visual Sortation Marker Files.  *This endpoint returns a list of Zones*
     * @summary Get Zones
     * @param {ZonesApiZonesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesList = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ZonesApiFp)(this.configuration).zonesList(requestParameters.station, requestParameters.area, requestParameters.sortBy, requestParameters.search, requestParameters.page, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint will partially update (patch) the Zone with specified id*
     * @summary Patch Zone
     * @param {ZonesApiZonesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesPartialUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesPartialUpdate(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * *This endpoint returns the Zone with specified id*
     * @summary Retrieve Zone
     * @param {ZonesApiZonesReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    ZonesApi.prototype.zonesRead = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ZonesApiFp)(this.configuration).zonesRead(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ZonesApi;
}(base_1.BaseAPI));
exports.ZonesApi = ZonesApi;
/**
 * @export
 */
exports.ZonesLabelDataFormatEnum = {
    ZPL: 'ZPL',
    PNG: 'PNG'
};
/**
 * @export
 */
exports.ZonesListSortByEnum = {
    NAME: 'name',
    NAME2: '-name'
};
